/**
 * atlas-product-custom-variant-picker.js
 * All CVP logic extracted from the Liquid snippet.
 * Called per instance via window.__atlasCvpConfig queue.
 */
(function () {
    function initAtlasCvp(uid) {
        const __cvpUid = uid || "";
        const __cvpCfg = (window.__atlasCvpConfig && window.__atlasCvpConfig[__cvpUid]) || {};
        const CVP_DEBUG = !!__cvpCfg.debug;
        const log = (...args) => { if (!CVP_DEBUG) return; try { /* console.log('[CVP]', ...args); */ } catch(_) {} };
        const warn = (...args) => { try { console.warn('[CVP]', ...args); } catch(_) {} };
        const err = (...args) => { try { console.error('[CVP]', ...args); } catch(_) {} };

        const root = document.getElementById("atlas-cvp-" + __cvpUid);



// --- Scope + form resolvers (robust) ---
        function _cvpGetSectionRoot() {
            return root ? (root.closest('[data-section-id]') || document) : document;
        }
        function _cvpFindForm() {
            const formId = root && root.dataset ? root.dataset.formId : '';
            // 1) by explicit id
            if (formId) {
                const byId = document.getElementById(formId);
                if (byId) return byId;
            }
            // 2) nearest form ancestor
            if (root) {
                const up = root.closest('form');
                if (up) return up;
            }
            // 3) any product form in same section
            const sec = _cvpGetSectionRoot();
            const inSec = sec && sec.querySelector ? sec.querySelector('form[action*="/cart"]') : null;
            if (inSec) return inSec;
            // 4) global fallback
            return document.querySelector('form[action*="/cart"]') || null;
        }

        // --- Guarantee a usable global formId for renderers that reference it ---
        function _cvpEnsureFormId() {
          try {
            const ds = root && root.dataset ? root.dataset.formId : '';
            if (ds) return ds;
            const f = _cvpFindForm();
            return (f && f.id) ? f.id : '';
          } catch(_) { return ''; }
        }
        try {
          if (typeof window.formId === 'undefined' || !window.formId) {
            window.formId = _cvpEnsureFormId();
          }
        } catch(_) {}

        function _cvpFindATC() {
            try {
                const ATC_SEL = 'button[name="add"], .product-form__submit, [data-add-to-cart]';
                const scope = root.closest('form') || root.closest('[data-section-id]') || document;
                const arr = Array.from(scope.querySelectorAll(ATC_SEL));
                return arr.length ? arr : Array.from(document.querySelectorAll(ATC_SEL));
            } catch(_) { return []; }
        }

        // === Tiny toast + invalid state tracking ===
        function _cvpEnsureToastHost(){
            let host = document.getElementById('cvp-toast-host');
            if (!host){
                host = document.createElement('div');
                host.id = 'cvp-toast-host';
                host.setAttribute('aria-live','polite');
                host.style.position='fixed';
                host.style.left='0';
                host.style.top='0';
                host.style.zIndex='9999';
                host.style.pointerEvents='none';
            }
            if (!host.isConnected) document.body.appendChild(host);
            return host;
        }
        let _cvpToastTimer = null;
        function _cvpToast(msg){
            try{
                const host = _cvpEnsureToastHost();
                host.innerHTML = '';
                const box = document.createElement('div');
                box.className = 'cvp-toast';
                box.textContent = String(msg || '');
                box.style.pointerEvents = 'auto';
                box.style.maxWidth = '90vw';
                box.style.padding = '10px 14px';
                box.style.borderRadius = '8px';
                box.style.background = '#262967';
                box.style.color = '#fff';
                box.style.boxShadow = '0 6px 20px rgba(0,0,0,.25)';
                box.style.font = '14px/1.4 system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif';
                box.style.opacity = '0';
                box.style.transition = 'opacity .2s ease';

                // Always position toast top center of viewport
                box.style.position = 'fixed';
                box.style.top = '130px';
                box.style.left = '50%';
                box.style.transform = 'translateX(-50%)';
                box.style.zIndex = '9999';

                _cvpEnsureToastHost().appendChild(box);
                requestAnimationFrame(()=>{ box.style.opacity = '1'; });
                clearTimeout(_cvpToastTimer);
                _cvpToastTimer = setTimeout(()=>{
                    try{
                        box.style.opacity = '0';
                        setTimeout(()=>{ const h=_cvpEnsureToastHost(); if (h) h.innerHTML=''; }, 200);
                    }catch(_){}
                }, 5000);
            }catch(_){}
        }

        let _cvpLastInvalidEl = null;
        let _cvpShouldShowInvalid = false;

        // Helper to set accordion open/closed state and maxHeight
        function _cvpSetAccordionOpenState(item, open) {
          try {
            if (!item) return;
            const content = item.querySelector && item.querySelector('.accordion-content');
            const recalc = () => {
              if (!content || !item.classList.contains('open')) return;
                 let h = content.scrollHeight || 0;
              // Add a buffer to account for margins / rounding so content is never clipped
              // 120px is intentionally generous to avoid any "half‑cut" bottom rows.
              const EXTRA_BUFFER_PX = 120;
              h += EXTRA_BUFFER_PX;
              content.style.maxHeight = (h > 0 ? h : 0) + 'px';
            };

            if (open) {
              item.classList.add('open');
              if (content) {
                content.style.maxHeight='0px';requestAnimationFrame(()=>{requestAnimationFrame(()=>{recalc();})});

                // Re-run after layout settles (e.g. fonts / cached images)
                setTimeout(recalc, 50);
              

                // Bind resize + image-load recalculation once per content
                if (!content._cvpHeightBound) {
                  content._cvpHeightBound = true;

                  // Recalc on window resize
                  try {
                    window.addEventListener('resize', recalc);
                  } catch (_) {}

                  // Recalc when images inside load (lazy images often change height)
                  try {
                    const imgs = content.querySelectorAll('img');
                    imgs.forEach(img => {
                      img.addEventListener('load', recalc, { once: true });
                    });
                  } catch (_) {}
                }
              }
            } else {
              item.classList.remove('open');
              if (content) {
                content.style.maxHeight = '0px';
              }
            }
          } catch(_) {}
        }

        // Auto-advance accordion: when a step is completed, close it and open the next one
        function _cvpAdvanceToNextAccordion(currentItem) {
          try {
            if (!currentItem || !root) return;

            // Collect accordion items in DOM order that actually contain a CVP step
            const items = Array
              .from(root.querySelectorAll('.accordion-item'))
              .filter(it => it.querySelector && it.querySelector('.atlas-cvp__step'));
            if (!items.length) return;

            const idx = items.indexOf(currentItem);
            if (idx === -1) return;

            // Mark current step as done (if badge exists) and close it
            const currentBadge = currentItem.querySelector('.accordion-step-badge');
            if (currentBadge) {
              setBadgeState(currentBadge, currentBadge.getAttribute('data-index'), true);
            }
            _cvpSetAccordionOpenState(currentItem, false);

            // Open the next non-skipped accordion item
            for (let i = idx + 1; i < items.length; i++) {
              const next = items[i];
              if (!next) continue;
              if (next.hasAttribute('data-skipped') && String(next.getAttribute('data-skipped')).toLowerCase() === 'true') {
                continue;
              }
              // Close all, then open only the next (and update max-height)
              items.forEach(it => _cvpSetAccordionOpenState(it, false));
              _cvpSetAccordionOpenState(next, true);

              // Focus header for accessibility if possible
              try {
                const headerBtn = next.querySelector('.accordion-header button, .accordion-header');
                if (headerBtn && headerBtn.focus) {
                          setTimeout(function(){ requestAnimationFrame(function(){ try { var _r = headerBtn.getBoundingClientRect(); window.scrollTo({ top: _r.top + window.scrollY - 170, behavior: 'smooth' }); headerBtn.focus({ preventScroll: true }); } catch(_e) {} }); }, 950);
                }
              } catch (_) {}

              break;
            }
          } catch (_) {}
        }

        // === ATC: replace real disabled with soft-block + force guidance ===
        (function cvpInstallAtcSoftBlock(){
          if (!root || root._cvpAtcSoftBlockInstalled) return;

          let _cvpAtcSyncing = false;
          const OBS_ROOT = root.closest('[data-section-id]') || root;

          const ATC_SEL = 'button[name="add"], .product-form__submit, [data-add-to-cart]';

            function findAtcButtons() {
                const arr = [];
                const sec = _cvpGetSectionRoot();
                const scopes = [root.closest('form'), root, sec, document];
                scopes.forEach(sc => {
                    if (!sc || !sc.querySelectorAll) return;
                    sc.querySelectorAll(ATC_SEL).forEach(b => { if (arr.indexOf(b) === -1) arr.push(b); });
                });
                return arr;
            }

          function softBlock(btn, blocked) {
            if (!btn) return;
            try {
              _cvpAtcSyncing = true;

              if (blocked) {
                // We want guidance to run: ensure clicks are possible
                if (btn.disabled) { btn.disabled = false; }
                if (btn.hasAttribute('disabled')) { btn.removeAttribute('disabled'); }
                btn.setAttribute('aria-disabled', 'true');
                btn.dataset.cvpBlocked = '1';
                btn.classList.add('cvp-atc-blocked');
                btn.classList.add('cvp-pointer-enabled');
              } else {
                // Allow theme to fully control disabled/loading state
                btn.setAttribute('aria-disabled', 'false');
                btn.dataset.cvpBlocked = '0';
                btn.classList.remove('cvp-atc-blocked');
                btn.classList.remove('cvp-pointer-enabled');
                // IMPORTANT: do NOT touch native disabled/class here
              }
            } finally {
              Promise.resolve().then(() => { _cvpAtcSyncing = false; });
            }
          }

          function shouldBlock() {
            try {
              const res = validateRequiredSteps();
              return !(res && res.valid);
            } catch(_) { return false; }
          }

          function syncAll() {
            const blocked = shouldBlock();
            _cvpAtcSyncing = true;
            try {
              findAtcButtons().forEach(btn => softBlock(btn, blocked));
            } finally {
              // clear guard in a microtask to coalesce attribute mutations
              Promise.resolve().then(() => { _cvpAtcSyncing = false; });
            }
          }

          // Attach a direct click handler to ATC (works even if theme cancels bubbling)
          function attachDirectHandlers() {
            findAtcButtons().forEach(btn => {
              if (btn._cvpClickBound) return;
              btn.addEventListener('click', function(ev){
                  _cvpShouldShowInvalid = true;
                const res = validateRequiredSteps();
                  if (!res.valid) {
                      ev.preventDefault(); ev.stopImmediatePropagation();
                      _cvpShouldShowInvalid = true;
                      _cvpMarkInvalid(res.firstInvalidStep || root);
                      _cvpToast('Please complete the required options');
                      try {
                          _cvpScrollInto(res.firstInvalidStep || root);
                          _cvpFocusFirstInput(res.firstInvalidStep || null);
                      } catch(_) {}
                      softBlock(btn, true);
                      return false;
                  } else {
                  softBlock(btn, false);
                }
              }, true); // capture to outrun theme handlers
              btn._cvpClickBound = true;
            });
          }

          // Observe DOM to react to class/aria-disabled changes on ATC
          const obs = new MutationObserver((mlist) => {
            if (_cvpAtcSyncing) return; // ignore our own writes
            let touched = false;
            for (const m of mlist) {
              if (m.type === 'attributes') {
                if (m.attributeName === 'class' || m.attributeName === 'aria-disabled') {
                  const el = m.target;
                  if (el && el.matches && el.matches(ATC_SEL)) { touched = true; break; }
                }
              } else if (m.type === 'childList') {
                // only consider relevant subtree changes
                if ((m.target && (m.target === OBS_ROOT || (m.target.contains && m.target.contains(root))))) {
                  touched = true; break;
                }
              }
            }
            if (touched) { syncAll(); attachDirectHandlers(); }
          });
          try {
            obs.observe(OBS_ROOT, {
              attributes: true,
              attributeFilter: ['class','aria-disabled'],
              childList: true,
              subtree: true
            });
          } catch(_) {}

          // Initial run
          syncAll(); attachDirectHandlers();
          root._cvpAtcSoftBlockInstalled = true;
        })();

        function _cvpClearInvalidMarks() {
          try {
            root.querySelectorAll('.cvp-invalid').forEach(el => el.classList.remove('cvp-invalid'));
          } catch(_) {}
        }
        function _cvpMarkInvalid(el) {
            if (!el) return;
            try { log('MarkInvalid:start', el); } catch(_){}
            // Don't mark the .atlas-cvp__step anymore — only the accordion item wrapper
            const acc = el.closest ? (el.closest('.accordion-item') || el.closest('.accordion-header') || null) : null;
            if (acc && !acc.classList.contains('cvp-invalid')) {
                acc.classList.add('cvp-invalid');
            }
            try {
              log('MarkInvalid:applied', {
                accHas: !!(acc && acc.classList && acc.classList.contains('cvp-invalid'))
              });
            } catch(_){}
        }
        function _cvpScrollInto(el) {
          try {
            const target = (el && el.closest) ? (el.closest('.accordion-item') || el) : el;
            if (target) {
              const rect = target.getBoundingClientRect();
              const offsetTop = window.pageYOffset + rect.top - 150; // extra 150px offset for header
              window.scrollTo({ top: offsetTop, behavior: 'smooth' });
              return;
            }
          } catch (_) {}
          try {
            const t = (el && el.closest) ? (el.closest('.accordion-item') || el) : el;
            if (t && t.scrollIntoView) t.scrollIntoView(true);
          } catch (__){}
        }
        function _cvpFocusFirstInput(el) {
          try {
            const inp = el.querySelector('input,textarea,select,button');
            if (inp) inp.focus({ preventScroll: true });
          } catch(_) {}
        }
        // Validate required steps. Returns { valid: boolean, firstInvalidStep: Element|null }
        function validateRequiredSteps() {
            const steps = Array.from(root.querySelectorAll('.atlas-cvp__step[data-required="true"], .atlas-cvp__step.required, .accordion-item.required .atlas-cvp__step, .accordion-item[data-required="true"] .atlas-cvp__step'));
            try {
                log('validate:steps.count', steps.length);
                log('validate:steps.types', steps.map(s => (s.getAttribute('data-step-type') || '').toLowerCase()));
            } catch(_){}

            let firstInvalid = null;
            let markEl = null;

            for (const step of steps) {
                const type = (step.getAttribute('data-step-type') || '').toLowerCase();
                let ok = true;
                let candidate = step;
                try { log('validate:check.step', { step, type }); } catch(_){}
                if (type === 'swatch-single') {
                    ok = !!step.querySelector('input.atlas-cvp__input[type="radio"]:checked');
                    candidate = step.querySelector('.atlas-cvp__swatches') || step;
                } else if (type === 'swatch-table-text') {
                    const ta = step.querySelector('.atlas-cvp__textarea');
                    const radioChecked = !!step.querySelector('input.js-cvp-text-toggle[type="radio"]:checked');
                    const textOk = ta ? (ta.value || '').trim() !== '' : true;
                    ok = (step.querySelector('.js-cvp-text-toggle') ? (radioChecked && textOk) : textOk);
                    candidate = (ta ? (ta.closest('.atlas-cvp__table-row') || ta) : step);
                } else if (type === 'multi-qty') {
                    ok = Array.from(step.querySelectorAll('.cvp-qty-input')).some(inp => (parseInt(inp.value || '0', 10) || 0) > 0);
                    candidate = step.querySelector('.atlas-cvp__multiqty') || step;
                } else if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
                    // Require sum of quantities to meet the step's data-total (if provided). If no data-total, require sum > 0.
                    const box = step.querySelector('.atlas-cvp__multiqty');
                    const requiredTotal = (() => {
                        try {
                            return Math.max(0, parseInt((box && box.getAttribute('data-total')) || '0', 10) || 0);
                        } catch(_) { return 0; }
                    })();
                    const sum = Array.from(step.querySelectorAll('.cvp-qty-input')).reduce((acc, inp) => {
                        const v = parseInt((inp && inp.value) || '0', 10) || 0;
                        return acc + Math.max(0, v);
                    }, 0);
                    ok = requiredTotal ? (sum === requiredTotal) : (sum > 0);
                    candidate = box || step;
                } else if (type === 'dropdown' || type === 'select') {
                    const sel = step.querySelector('select');
                    ok = sel ? !!(sel.value && sel.value !== '' && sel.value.toLowerCase() !== 'please choose') : true;
                    candidate = sel || step;
                } else if (type === 'description') {
                    ok = true;
                } else if (type === 'text') {
                    const input = step.querySelector('.atlas-cvp__text-input');
                    const raw = (input && input.value) || '';
                    const value = raw.trim();
                    let textOk = value.length > 0;

                    if (input && input.hasAttribute('data-max-digits')) {
                        const maxDigits = parseInt(input.getAttribute('data-max-digits') || '0', 10) || 0;
                        if (maxDigits === 1) {
                            // exactly one digit 0–9
                            textOk = /^[0-9]$/.test(value);
                        } else if (maxDigits === 2) {
                            // exactly two digits 10–99 (no leading zero)
                            textOk = /^[1-9][0-9]$/.test(value);
                        }
                    }

                    ok = textOk;
                    candidate = input || step;
                } else if (type === 'file') {
                    // Required file upload: ensure a file is selected
                    const fileInput = step.querySelector('.atlas-cvp__file-input, input[type="file"]');
                    if (fileInput && fileInput.files && typeof fileInput.files.length === 'number') {
                        ok = fileInput.files.length > 0;
                    } else {
                        // Fallback: if the input has a value string, use that
                        ok = !!(fileInput && fileInput.value && fileInput.value.trim() !== '');
                    }
                    candidate = fileInput || step;
                } else {
                    const reqInputs = Array.from(step.querySelectorAll('input[required], textarea[required], select[required]'));
                    if (reqInputs.length) {
                        ok = reqInputs.every(inp => {
                            if (inp.type === 'radio') return !!step.querySelector(`input[name="${inp.name}"]:checked`);
                            if (inp.tagName === 'TEXTAREA' || inp.tagName === 'INPUT') return (inp.value || '').trim() !== '';
                            if (inp.tagName === 'SELECT') return !!inp.value;
                            return true;
                        });
                    }
                }

                try { log('validate:step.result', { type, ok, candidate }); } catch(_){}
                if (!ok) {
                    firstInvalid = step;
                    markEl = candidate || step;
                    try { log('validate:FIRST_INVALID', { step, candidate }); } catch(_){}
                    break;
                }
            }

            if (firstInvalid) {
                if (_cvpShouldShowInvalid) {
                    // Remove previous highlight from its accordion wrapper (not from the step itself)
                    if (_cvpLastInvalidEl && _cvpLastInvalidEl !== firstInvalid) {
                        try {
                            const prevAcc = _cvpLastInvalidEl.closest && _cvpLastInvalidEl.closest('.accordion-item');
                            if (prevAcc) prevAcc.classList.remove('cvp-invalid');
                            else _cvpLastInvalidEl.classList.remove('cvp-invalid');
                        } catch(_) {}
                    }
                    // Mark only the accordion wrapper for the current invalid step
                    _cvpMarkInvalid(firstInvalid);
                    // Do NOT mark the step or candidate anymore
                }
                _cvpLastInvalidEl = firstInvalid;
                return { valid: false, firstInvalidStep: firstInvalid };
            } else {
                if (_cvpLastInvalidEl) {
                    try { _cvpLastInvalidEl.classList.remove('cvp-invalid'); } catch(_) {}
                    _cvpLastInvalidEl = null;
                }
                return { valid: true, firstInvalidStep: null };
            }
        }
        // Sync "Number of Digits" dropdown with following text input (enable/disable + hint)
        function _cvpSyncNumberOfDigitsStep(target) {
          try {
            if (!target || String(target.tagName).toUpperCase() !== 'SELECT') return;

            const stepEl = target.closest('.atlas-cvp__step[data-step-type="dropdown"]');
            if (!stepEl) return;

            const stepName = (stepEl.getAttribute('data-step-name') || '').toLowerCase();
            if (stepName.indexOf('number of digits') === -1) return;

            const val = String(target.value || '').toLowerCase();
            let maxDigits = 0;
            if (val.indexOf('1 digit') !== -1) {
              maxDigits = 1;
            } else if (val.indexOf('2 digits') !== -1) {
              maxDigits = 2;
            }

            // Find the very next text step by data-step-index
            let textStep = null;
            const idxAttr = stepEl.getAttribute('data-step-index');
            if (idxAttr) {
              const nextIndex = String((parseInt(idxAttr, 10) || 0) + 1);
              textStep = root.querySelector(
                '.atlas-cvp__step[data-step-type="text"][data-step-index="' + nextIndex + '"]'
              );
            }

            if (!textStep) return;

            const input = textStep.querySelector('.atlas-cvp__text-input');
            const hint  = textStep.querySelector('.atlas-cvp__text-hint');

            if (input) {
              if (maxDigits > 0) {
                input.removeAttribute('disabled');
                input.removeAttribute('readonly');
                input.setAttribute('data-max-digits', String(maxDigits));
                input.setAttribute('inputmode', 'numeric');
                input.setAttribute('maxlength', String(maxDigits));
              } else {
                input.value = '';
                input.removeAttribute('data-max-digits');
                input.removeAttribute('inputmode');
                input.removeAttribute('maxlength');
                input.setAttribute('disabled', 'disabled');
              }
            }

            if (hint) {
              if (maxDigits === 1) {
                hint.textContent = 'Max 1 digit';
                hint.style.display = '';
              } else if (maxDigits === 2) {
                hint.textContent = 'Max 2 digits';
                hint.style.display = '';
              } else {
                hint.textContent = '';
                hint.style.display = 'none';
              }
            }
          } catch (_) {}
        }

// Initial sync for "Number of Digits" flow on load (after steps are rendered)
        function _cvpInitDigitsOnRender() {
            try {
                let attempts = 0;
                const maxAttempts = 40;
                const delay = 200;

                const tick = () => {
                    attempts++;

                    const sel =
                        root.querySelector(
                            '.atlas-cvp__step[data-step-type="dropdown"][data-step-name*="Number of Digits"] select'
                        ) ||
                        root.querySelector(
                            '.atlas-cvp__step[data-step-type="dropdown"] select[name="cvp__Number of Digits"]'
                        );

                    if (!sel) {
                        if (attempts < maxAttempts) {
                            setTimeout(tick, delay);
                        }
                        return;
                    }

                    const stepEl = sel.closest('.atlas-cvp__step[data-step-type="dropdown"]');
                    if (!stepEl) return;

                    let textStep = null;
                    const idxAttr = stepEl.getAttribute('data-step-index');
                    if (idxAttr) {
                        const nextIndex = String((parseInt(idxAttr, 10) || 0) + 1);
                        textStep = root.querySelector(
                            '.atlas-cvp__step[data-step-type="text"][data-step-index="' + nextIndex + '"]'
                        );
                    }

                    if (!textStep) {
                        const acc = stepEl.closest('.accordion-item') || root;
                        textStep =
                            acc.querySelector('.atlas-cvp__step[data-step-type="text"]') ||
                            root.querySelector('.atlas-cvp__step[data-step-type="text"]');
                    }

                    if (textStep) {
                        const input = textStep.querySelector('.atlas-cvp__text-input');
                        const hint  = textStep.querySelector('.atlas-cvp__text-hint');

                        if (input) {
                            input.value = '';
                            input.setAttribute('disabled', 'disabled');
                            input.removeAttribute('data-max-digits');
                            input.removeAttribute('inputmode');
                            input.removeAttribute('maxlength');
                        }

                        if (hint) {
                            hint.textContent = '';
                            hint.style.display = 'none';
                        }
                    }

                    _cvpSyncNumberOfDigitsStep(sel);
                };

                tick();
            } catch (_) {}
        }

// Kick off initial "Number of Digits" sync once per snippet instance
_cvpInitDigitsOnRender();

root.addEventListener('change', (e) => {
  const wrap = e.target.closest('.cvp-invalid');
  if (wrap) wrap.classList.remove('cvp-invalid');

  // Sync "Number of Digits" dropdown with following text input
  try {
    const target = e.target;
    if (target && target.tagName === 'SELECT') {
      _cvpSyncNumberOfDigitsStep(target);
    }
  } catch (_) {}

  // Ignore non-user initiated changes (e.g. initial preselection / script-driven)
  try {
    if (typeof e.isTrusted !== 'undefined' && !e.isTrusted) {
      return;
    }
  } catch (_) {}

  // Auto-advance accordion when a selection is made on certain step types
  try {
    const stepEl = e.target.closest && e.target.closest('.atlas-cvp__step');
    const accItem = stepEl && stepEl.closest && stepEl.closest('.accordion-item');
    if (!stepEl || !accItem) return;

    const type = (stepEl.getAttribute('data-step-type') || '').toLowerCase();
    let shouldAdvance = false;

    // Radio-based swatch steps (single row or table-style) – advance once a value is picked
    if (type === 'swatch-single' || type === 'swatch-table') {
      const checked = stepEl.querySelector('input[type="radio"]:checked');
      if (checked) {
        shouldAdvance = true;
      }
    }
    // Text + radio combo: advance only when radio is selected AND textarea is non-empty
    else if (type === 'swatch-table-text') {
      const ta = stepEl.querySelector('.atlas-cvp__textarea');
      const hasText = !!(ta && ta.value && ta.value.trim() !== '');
      const radioChecked = !!stepEl.querySelector('input.js-cvp-text-toggle[type="radio"]:checked');
      if (hasText && radioChecked) {
        shouldAdvance = true;
      }
    }
    // Multi-qty steps (including conditional) – advance when total selected meets required total
    else if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
      const box = stepEl.querySelector('.atlas-cvp__multiqty');
      if (box) {
        let requiredTotal = 0;
        try {
          requiredTotal = Math.max(
            0,
            parseInt(box.getAttribute('data-total') || '0', 10) || 0
          );
        } catch (_) {}

        const sum = Array.from(stepEl.querySelectorAll('.cvp-qty-input')).reduce(
          (acc, inp) => {
            const v = parseInt((inp && inp.value) || '0', 10) || 0;
            return acc + Math.max(0, v);
          },
          0
        );

        const isUnlimited = !requiredTotal || requiredTotal === 0;

        if (!isUnlimited && sum === requiredTotal) {
          shouldAdvance = true;
        }
      }
    }
    // Dropdown/select – advance once a non-placeholder option is chosen
    else if (type === 'dropdown' || type === 'select') {
      const sel = stepEl.querySelector('select');
      if (sel && sel.value && sel.value !== '' && sel.value.toLowerCase() !== 'please choose') {
        shouldAdvance = true;
      }
    }
    // File upload – advance once a file is selected
    else if (type === 'file') {
      const fileInput = stepEl.querySelector('.atlas-cvp__file-input, input[type="file"]');
      if (fileInput && fileInput.files && typeof fileInput.files.length === 'number') {
        if (fileInput.files.length > 0) {
          shouldAdvance = true;
        }
      } else if (fileInput && fileInput.value && fileInput.value.trim() !== '') {
        // Fallback for older browsers that may not expose files array as expected
        shouldAdvance = true;
      }
    }

    if (shouldAdvance) {
      setTimeout(() => { _cvpAdvanceToNextAccordion(accItem); }, 600);
    }
  } catch (_) {}
}, true);


root.addEventListener('click', (e) => {
  try {
    if (!e.target || !e.target.closest) return;

    // 1) Handle "Apply" button for swatch-table-text steps
    const applyBtn = e.target.closest('.cvp-action[data-action="apply"]');
    if (applyBtn && root.contains(applyBtn)) {
      const stepEl = applyBtn.closest('.atlas-cvp__step');
      if (stepEl) {
        const type = (stepEl.getAttribute('data-step-type') || '').toLowerCase();
        if (type === 'swatch-table-text') {
          const accItem = stepEl.closest('.accordion-item');
          if (accItem) {
            // Defer to allow any internal state/UI updates on click to finish first
            setTimeout(() => {
              try {
                const ta = stepEl.querySelector('.atlas-cvp__textarea');
                const hasText = !!(ta && ta.value && ta.value.trim() !== '');
                const radioChecked = !!stepEl.querySelector('input.js-cvp-text-toggle[type="radio"]:checked');
                if (hasText && radioChecked) {
                  _cvpAdvanceToNextAccordion(accItem);
                }
              } catch (_) {}
            }, 0);
          }
        }
      }
    }

    // 2) Handle quantity +/- buttons for multi-qty steps (including conditional)
    const qtyBtn = e.target.closest('.cvp-btn.js-cvp-inc, .cvp-btn.js-cvp-dec');
    if (qtyBtn && root.contains(qtyBtn)) {
      const stepEl = qtyBtn.closest('.atlas-cvp__step');
      if (stepEl) {
        const type = (stepEl.getAttribute('data-step-type') || '').toLowerCase();
        if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
          const accItem = stepEl.closest('.accordion-item');
          if (accItem) {
            // Defer until quantities have actually been updated by the existing logic
            setTimeout(() => {
              try {
                const box = stepEl.querySelector('.atlas-cvp__multiqty');
                let requiredTotal = 0;
                if (box) {
                  try {
                    requiredTotal = Math.max(
                      0,
                      parseInt(box.getAttribute('data-total') || '0', 10) || 0
                    );
                  } catch (_) {}
                }

                const sum = Array.from(stepEl.querySelectorAll('.cvp-qty-input')).reduce(
                  (acc, inp) => {
                    const v = parseInt((inp && inp.value) || '0', 10) || 0;
                    return acc + Math.max(0, v);
                  },
                  0
                );

                const isUnlimited = !requiredTotal || requiredTotal === 0;

                if (!isUnlimited && sum === requiredTotal) {
                  _cvpAdvanceToNextAccordion(accItem);
                }
              } catch (_) {}
            }, 0);
          }
        }
      }
    }

    // 2) Existing behaviour for swatch-table rows (non-text)
    const row = e.target.closest('.atlas-cvp__table-row');
    if (!row || !root.contains(row)) return;

    const stepEl = row.closest('.atlas-cvp__step');
    if (!stepEl) return;

    const type = (stepEl.getAttribute('data-step-type') || '').toLowerCase();
    if (type !== 'swatch-table') return;

    const accItem = stepEl.closest('.accordion-item');
    if (!accItem) return;

    // Defer to allow the theme's own handlers to update the checked radio first
    setTimeout(() => {
      try {
        const checked = stepEl.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        _cvpAdvanceToNextAccordion(accItem);
      } catch (_) {}
    }, 600);
  } catch (_) {}
}, true);

        // --- ATC validation guards: run validation even if ATC gets disabled upstream ---
        (function cvpInstallValidationGuardsOnce(){
          try {
            if (!root || root._cvpGuardsInstalled) return;
            const ATC_SEL = 'button[name="add"], .product-form__submit, [data-add-to-cart]';
              const inSameScope = (el) => {
                  if (!el) return false;
                  const byRoot = !!el.closest('#' + root.id);
                  const f1 = el.closest('form');
                  const f2 = _cvpFindForm();
                  const byForm = !!(f1 && f2 && f1 === f2);
                  const sec = _cvpGetSectionRoot();
                  const bySection = !!(sec && el.closest && el.closest('[data-section-id]') === sec);
                  return byRoot || byForm || bySection;
              };
              const guideToInvalid = () => {
                  try {
                      const res = validateRequiredSteps();
                      if (!res.valid) {
                          _cvpShouldShowInvalid = true;
                          _cvpMarkInvalid(res.firstInvalidStep || root);
                          _cvpToast('Please complete the required options');
                          _cvpScrollInto(res.firstInvalidStep || root);
                          _cvpFocusFirstInput(res.firstInvalidStep || null);
                          return false;
                      }
                      return true;
                  } catch(_) { return false; }
              };
            // pointerdown fires even on disabled buttons; capture-phase so we always catch it
            document.addEventListener('pointerdown', function(ev){
              const btn = ev.target && ev.target.closest && ev.target.closest(ATC_SEL);
              if (!btn || !inSameScope(btn)) return;
              const isDisabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
                if (isDisabled) { _cvpShouldShowInvalid = true; guideToInvalid(); }
            }, true);
            // keyboard (Space/Enter) over disabled submit
            document.addEventListener('keydown', function(ev){
              const key = (ev.code || ev.key || '').toUpperCase();
              if (key !== 'SPACE' && key !== 'ENTER') return;
              const btn = ev.target && ev.target.closest && ev.target.closest(ATC_SEL);
              if (!btn || !inSameScope(btn)) return;
              const isDisabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
              if (isDisabled) {
                ev.preventDefault();
                ev.stopPropagation();
                  _cvpShouldShowInvalid = true;
                guideToInvalid();
                return false;
              }
            }, true);
            // safety: if ATC is enabled but validation still fails, stop submit and guide
            document.addEventListener('click', function(ev){
              const btn = ev.target && ev.target.closest && ev.target.closest(ATC_SEL);
              if (!btn || !inSameScope(btn)) return;
              _cvpShouldShowInvalid = true;
              if (!guideToInvalid()) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
              }
            }, true);
            root._cvpGuardsInstalled = true;
          } catch(_) {}
        })();

        function formatStepNum(n){ try { return String(Math.max(1, parseInt(n,10)||1)).padStart(2,'0'); } catch(_){ return '01'; } }

        // --- Persistent quantities (survives mini-cart add/remove) ---
        const storageKeyQty = `cvp_qty:${root.dataset.uid || 'default'}`;

        function saveQtyState() {
          try {
            const data = {};
            root.querySelectorAll('.cvp-qty-input').forEach(inp => {
              const h = inp.getAttribute('data-handle') || '';
              const v = Math.max(0, parseInt(inp.value || '0', 10) || 0);
              if (h) data[h] = v;
            });
            sessionStorage.setItem(storageKeyQty, JSON.stringify(data));
          } catch(_) {}
        }

        function loadQtyState() {
          let parsed = null;
          try {
            const raw = sessionStorage.getItem(storageKeyQty);
            if (raw) parsed = JSON.parse(raw);
          } catch(_) { parsed = null; }
          if (!parsed || typeof parsed !== 'object') return;
          try {
            root.querySelectorAll('.cvp-qty-input').forEach(inp => {
              const h = inp.getAttribute('data-handle');
              if (!h) return;
              const q = Math.max(0, parseInt(parsed[h] ?? 'NaN', 10));
              if (!isNaN(q)) {
                inp.value = String(q);
                // Sync selected state
                const item = inp.closest('.atlas-cvp__multiqty-item');
                if (item) item.classList.toggle('selected', q > 0);
              }
            });
            // Refresh helper UI for all multi-qty boxes
            root.querySelectorAll('.atlas-cvp__multiqty').forEach(box => updateMultiQtyUI(box));
            try { recomputeSelections(); } catch(_) {}
            try { recomputeTotal(); } catch(_) {}
            try { updateAccordionHeaderDisplay(); } catch(_) {}
            try { syncAtcDisabled(); } catch(_) {}
          } catch(_) {}
        }

        if (!root) return;
        let form = null;
        function onFormSubmit(e){
            _cvpShouldShowInvalid = true;
            try {
                const res = validateRequiredSteps();
                if (!res.valid) {
                    e && e.preventDefault && e.preventDefault();
                    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
                    _cvpMarkInvalid(res.firstInvalidStep || root);
                    _cvpToast('Please complete the required options');
                    _cvpScrollInto(res.firstInvalidStep || root);
                    _cvpFocusFirstInput(res.firstInvalidStep || null);
                    return false;
                }
            } catch(_) {}
            try { resetSkippedStepInputs(); } catch(_) {}
            try { recomputeSelections(); } catch(_) {}
            try { normalizeTextKeysInState(); } catch(_) {}
            try { dedupeTextProperties(); } catch(_) {}
            try {
              const ph = root.querySelector("[data-props-holder]");
              if (ph) {
                Array.from(ph.querySelectorAll('input[name^="properties[Add Candles & Toppers"]')).forEach(inp => ph.appendChild(inp));
              }
            } catch(_) {}

            // Explicitly put the primary ATC into loading state (disable + show spinner)
            try {
              const btn = _cvpGetPrimaryATC && _cvpGetPrimaryATC();
              if (btn) {
                const sp = btn.querySelector('.loading__spinner');
                btn.classList.add('loading');
                btn.setAttribute('aria-disabled','true');
                btn.disabled = true;
                if (sp) sp.classList.remove('hidden');
                // mark that we toggled it, so we know to revert on cart add end
                btn.dataset.cvpLoading = '1';
              }
            } catch(_) {}
            // Also call the shared helper to cover any other ATC buttons in scope
            try { _cvpToggleAtcLoading(true); } catch(_) {}

            // --- Inject line-item properties for classic form submit (/cart/add) ---
            try {
                const targetForm = form || _cvpFindForm() || root.closest('form');
                if (!targetForm) { /* no form found – nothing to do */ }
                else {
                    const pvId = String(__cvpCfg.parentVariantId || "");
                    const pvTag = __cvpCfg.parentTag || null;
                    const pvDelivery = !!__cvpCfg.parentHasDelivery;

                    const ensureHidden = (frm, name, value) => {
                        if (!frm || !name) return;
                        if (frm.querySelector(`input[type="hidden"][name="${CSS.escape(name)}"]`)) return;
                        const inp = document.createElement('input');
                        inp.type = 'hidden'; inp.name = name; inp.value = String(value);
                        frm.appendChild(inp);
                    };

                    const idInput = targetForm.querySelector('input[name="id"]');
                    if (idInput && String(idInput.value || '') === pvId) {
                        if (pvTag && String(pvTag).trim() !== '') ensureHidden(targetForm, 'properties[__product-tag]', pvTag);
                        if (pvDelivery) ensureHidden(targetForm, 'properties[__delivery-label]', 'true');
                    }

                    const itemIdInputs = Array.from(targetForm.querySelectorAll('input[name^="items["][name$="][id]"]'));
                    itemIdInputs.forEach((inp) => {
                        const m = inp.name.match(/^items\[(\d+)\]\[id\]$/);
                        if (!m) return;
                        const idx = m[1];
                        const val = String(inp.value || '');
                        if (val !== pvId) return;
                        const base = `items[${idx}][properties]`;
                        if (pvTag && String(pvTag).trim() !== '') ensureHidden(targetForm, `${base}[__product-tag]`, pvTag);
                        if (pvDelivery) ensureHidden(targetForm, `${base}[__delivery-label]`, 'true');
                    });
                }
            } catch(_) {}
        }

        function _cvpGetPrimaryATC() {
          // Returns the main/first Add To Cart button in the current scope
          try {
            const ATC_SEL = 'button[name="add"], .product-form__submit, [data-add-to-cart]';
            const scope = root.closest('form') || root.closest('[data-section-id]') || document;
            return scope.querySelector(ATC_SEL);
          } catch(_) { return null; }
        }
        function _cvpToggleAtcLoading(loading) {
          // Helper to toggle loading/spinner state for all ATC buttons in scope
          try {
            const ATC_SEL = 'button[name="add"], .product-form__submit, [data-add-to-cart]';
            const scope = root.closest('form') || root.closest('[data-section-id]') || document;
            const btns = Array.from(scope.querySelectorAll(ATC_SEL));
            btns.forEach(btn => {
              const sp = btn.querySelector('.loading__spinner');
              if (loading) {
                btn.classList.add('loading');
                btn.setAttribute('aria-disabled','true');
                btn.disabled = true;
                if (sp) sp.classList.remove('hidden');
              } else {
                btn.classList.remove('loading');
                btn.setAttribute('aria-disabled','false');
                btn.disabled = false;
                if (sp) sp.classList.add('hidden');
              }
            });
          } catch(_) {}
        }

        function bindFormOnce() {
            const next = _cvpFindForm();
            if (!next) { warn('bindFormOnce(): form still not found'); return; }
            if (form === next) return;
            form = next;
            try { window.formId = form.id || window.formId || ''; } catch(_) {}
            try { form.addEventListener('submit', onFormSubmit, true); } catch(_) {}
        }
        bindFormOnce();
        try {
            const sec = _cvpGetSectionRoot();
            const mo = new MutationObserver(() => { bindFormOnce(); });
            mo.observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['id','name','action'] });
        } catch(_) {}
        const propsHolder = root.querySelector("[data-props-holder]");
        function resetSkippedStepInputs() {
          try {
            // Remove all skipped handles from handleVariants
            try {
              root.querySelectorAll('.atlas-cvp__step[data-skipped="true"] [data-handle]').forEach(el => {
                const h = el.getAttribute('data-handle');
                if (h && handleVariants[h]) delete handleVariants[h];
              });
            } catch(_) {}
            // For every skipped step: unselect radios, zero qty, disable native inputs
            root.querySelectorAll('.atlas-cvp__step[data-skipped="true"]').forEach(stepEl => {
              stepEl.querySelectorAll('input[type="radio"]').forEach(inp => { inp.checked = false; });
              stepEl.querySelectorAll('.cvp-qty-input').forEach(inp => { inp.value = '0'; });
              stepEl.querySelectorAll('input, textarea, select').forEach(el => { el.disabled = true; });
            });
            // Clear props holder completely – it will be rebuilt from current UI state
            if (propsHolder) propsHolder.innerHTML = '';
            sessionStorage.removeItem(storageKeyQty);
          } catch(_) {}
        }

        let baseCents = parseInt(root.dataset.basePrice || '0', 10) || 0;
        const baseCentsOriginal = baseCents;
        let handlePrices = {};
        try {
          const pNode = root.querySelector('script[type="application/json"][data-cvp-prices]');
          handlePrices = pNode ? JSON.parse(pNode.textContent || '{}') : JSON.parse(root.dataset.prices || '{}');
        } catch(e){ handlePrices = {}; }

        let handleVariants = {};
        try {
          const vNode = root.querySelector('script[type="application/json"][data-cvp-variants]');
          handleVariants = vNode ? JSON.parse(vNode.textContent || '{}') : JSON.parse(root.dataset.variants || '{}');
        } catch(e){ handleVariants = {}; }

        let handleTags = {};
        try {
            const tNode = root.querySelector('script[type="application/json"][data-cvp-handle-tags]');
            handleTags = tNode ? JSON.parse(tNode.textContent || '{}') : {};
        } catch(e){ handleTags = {}; }

        let handleDelivery = {};
        try {
            const dNode = root.querySelector('script[type="application/json"][data-cvp-handle-delivery]');
            handleDelivery = dNode ? JSON.parse(dNode.textContent || '{}') : {};
        } catch(e){ handleDelivery = {}; }

        let handleStep1Presets = {};
        try {
            const p1Node = root.querySelector('script[type="application/json"][data-cvp-step1-presets]');
            handleStep1Presets = p1Node ? JSON.parse(p1Node.textContent || '{}') : {};
        } catch(e){ handleStep1Presets = {}; }

        // Pre-fetched step data for finishing-touches-modal collection members, supplied
        // server-side via Liquid since these "hidden" products often can't render their own
        // storefront page (blocked as "not available for purchase"), so a client-side fetch
        // of their page would silently find nothing.
        let collectionSteps = {};
        try {
            const csNode = root.querySelector('script[type="application/json"][data-cvp-collection-steps]');
            collectionSteps = csNode ? JSON.parse(csNode.textContent || '{}') : {};
        } catch(e){ collectionSteps = {}; }

        // Heuristic fallback: infer cake tag from handle/title when product tags don't contain our taxonomy
        function _cvpInferTagFromItem(it) {
          try {
            const title = String((it && (it.product_title || it.title)) || '').toLowerCase();
            const handle = String((it && it.handle) || '').toLowerCase();
            const s = (handle + ' ' + title);

            if (/(fully[-\s]?iced|drizzle|iced\s*cake|buttercream)/i.test(s)) return 'Iced Cake';
            if (/(un[-\s]?iced|slab\s*cake|naked\s*cake)/i.test(s)) return 'Un-Iced Cake';
            if (/(tier|two[-\s]?tier|three[-\s]?tier)/i.test(s)) return 'Tiered Cake';
            if (/(regular\s*cupcake.*12|12\s*pack)/i.test(s)) return 'Regular Cupcake - 12 Pack';
            if (/(regular\s*cupcake.*6|6\s*pack)/i.test(s)) return 'Regular Cupcake - 6 Pack';
            if (/mini\s*cupcake/i.test(s)) return 'Mini Cupcake';
            if (/cheese\s*cake|cheesecake/i.test(s)) return 'Cheesecake';
            if (/takeaway.*high\s*tea|high\s*tea/i.test(s)) return 'Takeaway High Tea';

            return '';
          } catch(_) { return ''; }
        }

        // --- Parent (PDP) context for fallback tagging ---
        const parentVariantId = String(__cvpCfg.parentVariantId || "");
        const parentTag = __cvpCfg.parentTag || null;
        const parentHasDelivery = !!__cvpCfg.parentHasDelivery;

        // ---------- Cart Attributes Sync (Tag:* and Delivery Labels) ----------
        let _cvpAttrSyncTimer = null;
        let _cvpAttrLastSignature = '';

        function _cvpIsChildItem(item) {
          try {
            if (!item) return false;
            if (item.properties && (item.properties._Child === 'true' || item.properties._child === 'true')) return true;
            if (String(item.product_type || '').toUpperCase() === 'OPTIONS_HIDDEN_PRODUCT') return true;
          } catch(_) {}
          return false;
        }

        function _cvpBuildCartAttributes(cart) {
          const out = {};
          let deliveryCount = 0;
          try {
            (cart.items || []).forEach(it => {
              if (_cvpIsChildItem(it)) return;

              const vid = String(it.variant_id || it.id || '');
              const handle = it.handle || (variantToHandle[vid] ? variantToHandle[vid] : null);

              // 1) Tag:* counter (per parent item)
              let tag =
                (it.properties && it.properties['__product-tag']) ||
                (handle && handleTags && handleTags[handle]) ||
                ((parentVariantId && vid === parentVariantId) ? parentTag : null) ||
                _cvpInferTagFromItem(it);

              if (tag && String(tag).trim() !== '') {
                const key = `Tag:${tag}`;
                out[key] = (out[key] || 0) + 1;
              }

              // 2) Delivery Labels counter (per parent item)
              const hasDelivery =
                (it.properties && (it.properties['__delivery-label'] === 'true' || it.properties['__delivery-label'] === true)) ||
                (handle && handleDelivery && handleDelivery[handle] === true) ||
                ((parentVariantId && vid === parentVariantId) ? !!parentHasDelivery : false);

              if (hasDelivery) deliveryCount += 1;
            });
            if (deliveryCount > 0) out['Delivery Labels'] = deliveryCount;
          } catch(_) {}
          return out;
        }

        async function _cvpSyncCartAttributes() {
          try {
            const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
            if (!res.ok) return;
            const cart = await res.json();
            const attrs = _cvpBuildCartAttributes(cart);

            // Create a signature to avoid redundant updates
            const sig = JSON.stringify(attrs);
            if (sig === _cvpAttrLastSignature) return;
            _cvpAttrLastSignature = sig;

            // If empty, still push to clear previous values
            await fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attrs })
            }).catch(() => {});
            try { document.dispatchEvent(new CustomEvent('cvp:cartAttributesSynced')); } catch(_) {}
          } catch(_) {}
        }

        function _cvpSyncCartAttributesDebounced(delay = 400) {
          try {
            if (_cvpAttrSyncTimer) clearTimeout(_cvpAttrSyncTimer);
            _cvpAttrSyncTimer = setTimeout(_cvpSyncCartAttributes, delay);
          } catch(_) {}
        }

        // Initial sync on PDP load (helps when arriving with items already in cart)
        // (removed DOMContentLoaded sync to avoid double-trigger; sync will be handled after cart/add)

        // If hc-mini-cart broadcasts updates, keep in sync
        document.addEventListener('hc-cart:updated', () => _cvpSyncCartAttributesDebounced(150));

// Reverse map: variantId -> handle
        let variantToHandle = {};
        try {
            Object.keys(handleVariants || {}).forEach(h => {
                const vid = String(handleVariants[h] || '');
                if (vid) variantToHandle[vid] = h;
            });
        } catch(_) {}
        log('handleVariants keys:', Object.keys(handleVariants));
        const handleImages = {};
        async function resolveImageUrlViaAjax(handle) {
          if (!handle) return null;
          if (handleImages[handle]) return handleImages[handle];
          try {
            const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            const url = (data && data.images && data.images[0]) ? data.images[0] : (data && data.featured_image) ? data.featured_image : null;
            if (url) handleImages[handle] = url;
            return url || null;
          } catch(_) { return null; }
        }

        function getPriceCentsFromDOM() {
          try {
            const scope = root.closest('[data-section-id]') || document;
            const priceRoot = scope.querySelector('.price');
            if (!priceRoot) return 0;
            const pick = priceRoot.querySelector('.price__sale .price-item--sale') || priceRoot.querySelector('.price__regular .price-item--regular') || priceRoot.querySelector('.price-item');
            if (!pick) return 0;
            const txt = (pick.textContent || '').replace(/[^0-9.,]/g, '').trim();
            if (!txt) return 0;

            const normalized = txt.includes(',') && txt.indexOf(',') > txt.indexOf('.')
              ? txt.replace(/\./g, '').replace(',', '.')
              : txt.replace(/,/g, '');
            const num = parseFloat(normalized);
            if (isNaN(num)) return 0;
            return Math.round(num * 100);
          } catch(_) { return 0; }
        }
        if (!baseCents) {
          const domCents = getPriceCentsFromDOM();
          if (domCents) baseCents = domCents;
        }

        async function resolveVariantIdViaAjax(handle) {
          if (!handle) return null;
          if (handleVariants && handleVariants[handle]) return handleVariants[handle];
          try {
            const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
              credentials: 'same-origin',
              headers: { 'Accept': 'application/json' }
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            const vid = (data && Array.isArray(data.variants) && data.variants[0] && data.variants[0].id) ? data.variants[0].id : null;
            if (vid) {
              handleVariants[handle] = vid; // cache for this session
              log('Resolved variant via AJAX', handle, vid);
              return vid;
            }
          } catch (e) {
            warn('resolveVariantIdViaAjax failed for handle', handle, e);
          }
          return null;
        }

        async function resolvePriceCentsViaAjax(handle) {
          if (!handle) return null;
          if (handlePrices && handlePrices[handle] != null) return handlePrices[handle];
          try {
            const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
              credentials: 'same-origin',
              headers: { 'Accept': 'application/json' }
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            let cents = 0;
            if (data && Array.isArray(data.variants) && data.variants[0]) {
              const v = data.variants[0];
              cents = (typeof v.price === 'number') ? Math.round(v.price) : parseInt(v.price, 10);
              if (!isNaN(cents) && cents < 100 && (''+v.price).indexOf('.') !== -1) {
                cents = Math.round(parseFloat(v.price) * 100);
              }
            }
            if (!cents && data && data.price) {
              cents = (typeof data.price === 'number') ? Math.round(data.price) : parseInt(data.price, 10);
              if (!isNaN(cents) && cents < 100 && (''+data.price).indexOf('.') !== -1) {
                cents = Math.round(parseFloat(data.price) * 100);
              }
            }
            if (!isNaN(cents)) {
              handlePrices[handle] = cents;
              applyPriceToInputs(handle, cents);
              document.dispatchEvent(new CustomEvent('cvp:priceResolved', { detail: { handle, cents } }));
              try { recomputeTotal(); } catch(_){}
              return cents;
            }
          } catch(e) {
            warn('resolvePriceCentsViaAjax failed for handle', handle, e);
          }
          return null;
        }

        function applyPriceToInputs(handle, cents) {
          if (!handle) return;
          const inputs = root.querySelectorAll(`[data-handle="${CSS.escape(handle)}"]`);
          inputs.forEach(inp => {
            inp.setAttribute('data-price-cents', String(Math.max(0, parseInt(cents||'0',10) || 0)));
            inp.removeAttribute('data-price-pending');
          });
        }

        async function ensureVariantIds(handles) {
          const unique = Array.from(new Set((handles || []).filter(Boolean)));
          const missing = unique.filter(h => !handleVariants[h]);
          if (!missing.length) return;
          log('ensureVariantIds: resolving via AJAX for', missing);
          await Promise.all(missing.map(h => resolveVariantIdViaAjax(h)));
        }

        const mount = root.querySelector("[data-cvp-steps-mount]");

        // --- Skip this step: close current accordion and open next ---
        root.addEventListener('click', function (ev) {
          const skipBtn = ev.target && ev.target.closest && ev.target.closest('.atlas-cvp__skip');
          if (!skipBtn) return;

          // Find the CVP step for this Skip button
          let stepEl = skipBtn.closest('.atlas-cvp__step');
          let accItem = skipBtn.closest('.accordion-item');

          // If the click came from a Skip button in the accordion header,
          // the actual step element lives inside the accordion content.
          if (!stepEl && accItem) {
            stepEl = accItem.querySelector('.atlas-cvp__step');
          }

          // If we found a step, mark it as skipped using the central helper
          // (so state, props and labels stay consistent). If for some reason
          // the step element is missing, just advance the accordion without touching state.
          if (stepEl) {
            try {
              setStepSkipped(stepEl, true);
            } catch (_) {
              try {
                stepEl.setAttribute('data-skipped', 'true');
              } catch (_) {}
            }
          }

          // Ensure we have the accordion item that contains this step / button
          if (!accItem && stepEl) {
            accItem = stepEl.closest('.accordion-item');
          }
          if (!accItem) return;

          // Delegate the actual open/close and step switching to the shared helper
          try {
            _cvpAdvanceToNextAccordion(accItem);
          } catch (_) {}

          // Clear invalid highlight on this item, if any
          try {
            accItem.classList.remove('cvp-invalid');
          } catch (_) {}

          // Re-check Add to Cart state
          try { syncAtcDisabled && syncAtcDisabled(); } catch (_) {}
        }, true);
        let steps = [];
        try {
            const sNode = root.querySelector('script[type="application/json"][data-cvp-steps]');
            if (sNode) {
                steps = JSON.parse(sNode.textContent || "[]");
            } else if (Array.isArray(window.cvpSteps)) {
                steps = window.cvpSteps;
            } else {
                steps = JSON.parse(root.dataset.steps || "[]");
            }
        } catch (_) {
            steps = [];
        }
        try {
          if (Array.isArray(steps) && steps.length > 0) {
            root.setAttribute('data-cvp-controls-price', '1');
          } else {
            root.removeAttribute('data-cvp-controls-price');
          }
        } catch(_) {}

        const moneyFormat = __cvpCfg.moneyFormat || "{{ amount }}";
        function formatMoney(cents) {
          const n = Math.round(Number(cents) || 0);
          if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(n, moneyFormat);
          }
          const v = (n / 100);
          const parts = {
            amount: v.toFixed(2),
            amount_no_decimals: Math.round(v).toString(),
            amount_with_comma_separator: v.toFixed(2).replace('.', ','),
            amount_no_decimals_with_comma_separator: Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          };
          let fmt = (moneyFormat || '').toString();
          fmt = fmt.replace(/\{\{\s*/g, '{{').replace(/\s*\}\}/g, '}}');
          fmt = fmt.replace('{{amount_no_decimals_with_comma_separator}}', parts.amount_no_decimals_with_comma_separator);
          fmt = fmt.replace('{{amount_with_comma_separator}}', parts.amount_with_comma_separator);
          fmt = fmt.replace('{{amount_no_decimals}}', parts.amount_no_decimals);
          fmt = fmt.replace('{{amount}}', parts.amount);
          if (!fmt || fmt.indexOf('{{') !== -1) {
            return '$' + parts.amount;
          }
          return fmt;
        }

        function syncPdpPrice(totalCents) {
          // Only allow CVP to control the PDP price when this component actually has steps.
          if (!root || !root.hasAttribute('data-cvp-controls-price')) return;
          try {
            const scope = root.closest('[data-section-id]') || document;
            let priceRoots = Array.from(scope.querySelectorAll('.price'));
            if (!priceRoots.length) priceRoots = Array.from(document.querySelectorAll('.price'));
            if (!priceRoots.length) return;
            const formatted = formatMoney(totalCents);

            priceRoots.forEach((priceRoot) => {
              const regularEl = priceRoot.querySelector('.price_regular .price-item--regular') || priceRoot.querySelector('.price__regular .price-item--regular');
              if (regularEl) {
                regularEl.textContent = formatted;
              }

              const saleEl = priceRoot.querySelector('.price_sale .price-item--sale') || priceRoot.querySelector('.price__sale .price-item--sale');
              if (saleEl) {
                saleEl.textContent = formatted;
              }

              const crossed = priceRoot.querySelector('.price__sale s.price-item--regular');
              if (crossed) crossed.textContent = '';

              priceRoot.querySelectorAll('.price-item').forEach((node) => {
                if (node.closest('s')) return;
                const tokenStart = '\\u007B\\u007Bamount';
                if ((node.textContent || '').indexOf(tokenStart) !== -1) {
                  node.textContent = formatted;
                }
              });
            });
          } catch (e) {
            // no-op
          }
        }

        function dedupeTextProperties() {
            try {
                if (!propsHolder) return;
                const inputs = Array.from(
                    propsHolder.querySelectorAll('input[type="hidden"][name^="properties["]')
                );
                if (!inputs.length) return;


                const groups = new Map();
                inputs.forEach(inp => {
                    const m = inp.name && inp.name.match(/^properties\[(.+)\]$/);
                    if (!m) return;
                    const key = m[1];
                    if (!groups.has(key)) groups.set(key, []);
                    groups.get(key).push(inp);
                });

                groups.forEach((arr, key) => {
                    const textKey = key + ' Text';
                    if (!groups.has(textKey)) return;
                    const textInputs = groups.get(textKey) || [];
                    const textVal = (textInputs.find(i => (i.value || '').trim() !== '') || {}).value || '';

                    if (textVal) {
                        arr.forEach(i => { i.value = textVal; });
                    }
                    textInputs.forEach(i => i.remove());
                });
            } catch(_) {}
        }
        function normalizeTextKeysInState() {
            try {
                if (typeof state !== 'object') return;
                const sel = (state.selections = state.selections || {});
                const txt = (state.textInputs = state.textInputs || {});
                const keys = new Set([...Object.keys(sel), ...Object.keys(txt)]);

                keys.forEach((k) => {
                    if (!/\sText$/.test(k)) return;
                    const base = k.replace(/\sText$/, '');
                    const v = (txt[k] != null ? String(txt[k]) : (sel[k] != null ? String(sel[k]) : '')).trim();
                    if (v) {
                        txt[base] = v;
                    }
                    delete txt[k];
                    delete sel[k];
                });
            } catch(_) {}
        }

        // --- CVP Sanitize MetaObject and Properties helpers & fetch wrapper ---
        function _cvpSanitizeMetaObject(obj) {
          if (!obj || typeof obj !== 'object') return obj;
          const out = { ...obj };
          Object.keys(out).forEach((k) => {
            if (/\sText$/.test(k)) {
              const base = k.replace(/\sText$/, '');
              const v = out[k];
              if (v != null && String(v).trim() !== '') out[base] = v;
              delete out[k];
            }
          });
          return out;
        }

        function _cvpSanitizeProperties(props) {
          try {
            if (!props || typeof props !== 'object') return props;
            const p = { ...props };
            // Collapse any "... Text" keys into their base key
            Object.keys(p).forEach((k) => {
              if (/\sText$/.test(k)) {
                const base = k.replace(/\sText$/, '');
                const v = p[k];
                if (v != null && String(v).trim() !== '') p[base] = v;
                delete p[k];
              }
            });
            // If _group-data present, sanitize its encoded meta
            if (typeof p["_group-data"] === 'string' && p["_group-data"].includes('meta:')) {
              const parts = p["_group-data"].split('meta:');
              const enc = parts[1] || '';
              let obj = null;
              try { obj = JSON.parse(decodeURIComponent(enc)); } catch(_) { obj = null; }
              if (obj && typeof obj === 'object') {
                const cleaned = _cvpSanitizeMetaObject(obj);
                parts[1] = encodeURIComponent(JSON.stringify(cleaned));
                p["_group-data"] = parts.join('meta:');
              }
            }
            return p;
          } catch(_) { return props; }
        }

        // Ensure __product-tag / __delivery-label are also mirrored into _group-data meta (for cart transform/bundling)
        function _cvpAttachBundleMetaToPropsObject(props, tagValue, deliveryBool) {
          try {
            if (!props || typeof props !== 'object') return props;
            const tag = (tagValue && String(tagValue).trim()) ? String(tagValue).trim() : '';
            const hasDelivery = !!deliveryBool;
            if (!props["_group-data"] || typeof props["_group-data"] !== 'string' || props["_group-data"].indexOf('meta:') === -1) {
              return props;
            }
            const parts = props["_group-data"].split('meta:');
            const enc = parts[1] || '';
            let meta = null;
            try { meta = JSON.parse(decodeURIComponent(enc)); } catch(_) { meta = {}; }
            if (!meta || typeof meta !== 'object') meta = {};
            // Only set if not present to avoid clobbering upstream values
            if (tag && (meta['__product-tag'] == null || meta['__product-tag'] === '')) {
              meta['__product-tag'] = tag;
            }
            if (hasDelivery && (meta['__delivery-label'] == null || meta['__delivery-label'] === '' || meta['__delivery-label'] === false)) {
              meta['__delivery-label'] = true;
            }
            parts[1] = encodeURIComponent(JSON.stringify(meta));
            props["_group-data"] = parts.join('meta:');
            return props;
          } catch(_) { return props; }
        }

        // Intercept /cart/add.js requests to sanitize duplicated text keys in properties
        (function _cvpWrapFetchOnce(){
          try {
            if (window._cvpFetchWrapped) return; // idempotent
            const _origFetch = window.fetch;
            if (typeof _origFetch !== 'function') return;

            window.fetch = async function(url, init){
              try {
                const u = (typeof url === 'string') ? url : (url && url.url) || '';
                const method = (init && (init.method || '') || '').toUpperCase();
                if (u && /\/cart\/add\.js($|\?)/.test(u) && method === 'POST' && init && init.body) {
                  try {
                    const body = init.body;
                    const attachPropsByHandleForItem = (it) => {
                      if (!it || typeof it !== 'object' || !it.id) return it;
                      const vid = String(it.id);
                      const handle = variantToHandle[vid] || it.handle || null;
                      const props = _cvpSanitizeProperties(Object.assign({}, it.properties || {}));

                      // Compute tag: by explicit handle map, else PDP fallback, else heuristic
                      let tag = '';
                      if (handle && handleTags[handle]) tag = handleTags[handle];
                      else if (parentVariantId && vid === parentVariantId && parentTag) tag = parentTag;
                      if (!tag) {
                        const guess = _cvpInferTagFromItem({ id: vid, handle: it.handle || handle, product_title: it.product_title, title: it.title });
                        if (guess) tag = guess;
                      }

                      // Compute delivery flag: handle map, else PDP fallback
                      let hasDelivery = false;
                      if (handle && handleDelivery[handle] === true) hasDelivery = true;
                      else if (parentVariantId && vid === parentVariantId && parentHasDelivery) hasDelivery = true;

                      if (tag && !props['__product-tag']) props['__product-tag'] = tag;
                      if (hasDelivery && !props['__delivery-label']) props['__delivery-label'] = 'true';

                      // Mirror into _group-data meta for cart transform/bundling
                      _cvpAttachBundleMetaToPropsObject(props, tag, hasDelivery);

                      it.properties = props;
                      return it;
                    };

                    // --- Case 1: JSON payload (string) ---
                    if (typeof body === 'string') {
                      try {
                        let payload = JSON.parse(body);
                        if (payload && typeof payload === 'object') {
                          if (payload.id) payload = attachPropsByHandleForItem(payload);
                          if (payload.properties) payload.properties = _cvpSanitizeProperties(payload.properties);
                          if (Array.isArray(payload.items)) payload.items = payload.items.map(attachPropsByHandleForItem);
                          init.body = JSON.stringify(payload);
                        }
                      } catch(_) {
                        // Try URLSearchParams-formatted body
                        try {
                          const usp = new URLSearchParams(body);
                          // Collapse any properties[... Text] -> properties[...]
                          const keys = Array.from(usp.keys());
                          keys.forEach(k => {
                            const m = k.match(/^properties\[(.+)\]$/);
                            if (!m) return;
                            const key = m[1];
                            if (/\sText$/.test(key)) {
                              const base = key.replace(/\sText$/, '');
                              const v = usp.get(k);
                              if (v && v.trim() !== '') {
                                usp.set(`properties[${base}]`, v);
                              }
                              usp.delete(k);
                            }
                          });
                          init.body = usp.toString();
                        } catch(__) {}
                      }
                    }
                    // --- Case 2: FormData payload ---
                    else if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
                      try {
                        const fd = body;
                        const entries = [];
                        fd.forEach((v, k) => entries.push([k, v]));
                        const items = new Map(); // idx -> { id, props: Map }
                        const single = { id: null, props: new Map() };
                        entries.forEach(([k, v]) => {
                          let m;
                          if ((m = k.match(/^items\[(\d+)\]\[id\]$/))) {
                            const idx = m[1];
                            if (!items.has(idx)) items.set(idx, { id: null, props: new Map() });
                            items.get(idx).id = String(v);
                            return;
                          }
                          if ((m = k.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/))) {
                            const idx = m[1], pk = m[2];
                            if (!items.has(idx)) items.set(idx, { id: null, props: new Map() });
                            items.get(idx).props.set(pk, v);
                            return;
                          }
                          if (k === 'id') { single.id = String(v); return; }
                          if ((m = k.match(/^properties\[(.+)\]$/))) {
                            single.props.set(m[1], v);
                            return;
                          }
                        });
                        const out = new FormData();

                        const applyPropsFor = (id, propsMap) => {
                          const vid = id ? String(id) : '';
                          const handle = vid ? (variantToHandle[vid] || null) : null;
                          const p2 = new Map();
                          propsMap.forEach((val, key) => {
                            if (/\sText$/.test(key)) {
                              const base = key.replace(/\sText$/, '');
                              if (val != null && String(val).trim() !== '') p2.set(base, val);
                            } else {
                              p2.set(key, val);
                            }
                          });

                          // Compute tag and delivery using handle map, PDP fallback, or heuristic
                          let tag = '';
                          if (handle && handleTags[handle]) tag = handleTags[handle];
                          else if (parentVariantId && vid === parentVariantId && parentTag) tag = parentTag;
                          if (!tag) {
                            const guess = _cvpInferTagFromItem({ id: vid, handle, title: '' });
                            if (guess) tag = guess;
                          }
                          let hasDelivery = false;
                          if (handle && handleDelivery[handle] === true) hasDelivery = true;
                          else if (parentVariantId && vid === parentVariantId && parentHasDelivery) hasDelivery = true;

                          if (tag && !p2.has('__product-tag')) p2.set('__product-tag', tag);
                          if (hasDelivery && !p2.has('__delivery-label')) p2.set('__delivery-label', 'true');

                          // Mirror into _group-data meta (if present)
                          try {
                            const plainProps = {};
                            p2.forEach((v, k) => { plainProps[k] = v; });
                            _cvpAttachBundleMetaToPropsObject(plainProps, tag, hasDelivery);
                            // Write back any possibly-updated _group-data
                            if (plainProps['_group-data']) {
                              p2.set('_group-data', plainProps['_group-data']);
                            }
                          } catch(_) {}

                          return p2;
                        };

                        if (items.size > 0) {
                          items.forEach((rec, idx) => {
                            const p2 = applyPropsFor(rec.id, rec.props);
                            out.set(`items[${idx}][id]`, rec.id || '');
                            p2.forEach((val, key) => out.set(`items[${idx}][properties][${key}]`, val));
                          });
                        } else if (single.id) {
                          const p2 = applyPropsFor(single.id, single.props);
                          out.set('id', single.id);
                          p2.forEach((val, key) => out.set(`properties[${key}]`, val));
                        }
                        // Pass through untouched fields
                        entries.forEach(([k, v]) => {
                          if (/^(items\[\d+\]\[id\]|items\[\d+\]\[properties\]\[.+\]|id|properties\[.+\])$/.test(k)) return;
                          out.append(k, v);
                        });
                        init.body = out;
                      } catch(_) {}
                    }
                  } catch(_) { /* ignore non-JSON/non-FormData bodies */ }
                }
              } catch(_) { /* no-op */ }
              // After add-to-cart request is initiated, schedule a sync (pre-emptive and after completion)
              let resp = _origFetch.apply(this, arguments);
              try {
                if (u && /\/cart\/add\.js($|\?)/.test(u) && method === 'POST') {
                  _cvpSyncCartAttributesDebounced(300); // pre-emptive
                  Promise.resolve(resp).then(() => _cvpSyncCartAttributesDebounced(50)); // after server accepts
                }
              } catch(_) {}
              return resp;
            };
            window._cvpFetchWrapped = true;
          } catch(_) {}
        })();

        // Intercept XHR /cart/add.js as well (covers jQuery.ajax and native XHR)


        function makeGroupKey() {
          return 'cvp_' + Date.now().toString(36) + Math.random().toString(36).slice(2,8);
        }

        function el(tag, attrs = {}, children = []) {
            const node = document.createElement(tag);
            for (const [k, v] of Object.entries(attrs || {})) {
                if (v === false || v === null || v === undefined) continue;
                if (k === "class") node.className = v;
                else if (k === "html") node.innerHTML = v;
                else if (k.startsWith("data-")) node.setAttribute(k, v);
                else node.setAttribute(k, String(v));
            }
            (Array.isArray(children) ? children : [children]).forEach((c) => {
                if (c == null) return;
                if (c instanceof Node) node.appendChild(c);
                else node.appendChild(document.createTextNode(String(c)));
            });
            return node;
        }

        function renderDescription(step, idx) {
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "description",
                "data-step-name": step.name || step.label || `Step ${idx + 1}`
            });

            if (step.label) {
                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label)
                ]);
                wrap.appendChild(head);
                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }
            }
            wrap.appendChild(
                el("div", {
                    class: "atlas-cvp__desc rte",
                    html: (step.content || "").replace(/<br\s*\/?>/gi, "")
                })
            );
            return wrap;
        }

// --- Delegated guard for Apply buttons (handles re-renders/replacements) ---
(function setupApplyGuardOnce(){
  try{
    if (root._applyGuardInstalled) return;
    // Block empty apply on any future buttons inside this component
    document.addEventListener('click', function(ev){
      const btn = ev.target && ev.target.closest && ev.target.closest('.cvp-action[data-action="apply"]');
      if (!btn || !root.contains(btn)) return;
      const row = btn.closest('.atlas-cvp__table-row');
      const ta = row ? row.querySelector('.atlas-cvp__textarea') : null;
      const val = ta ? (ta.value || '').trim() : '';
      if (!val){
        ev.preventDefault();
        ev.stopPropagation();
        btn.disabled = true;
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled','true');
        try { ta && ta.focus(); } catch(_) {}
      }
    }, true);
    // Keep button state in sync as user types
    root.addEventListener('input', function(ev){
      const ta = ev.target && ev.target.classList && ev.target.classList.contains('atlas-cvp__textarea') ? ev.target : null;
      if (!ta) return;
      const row = ta.closest('.atlas-cvp__table-row');
      const btn = row ? row.querySelector('.cvp-action[data-action="apply"]') : null;
      if (!btn) return;
      const empty = (ta.value || '').trim() === '';
      btn.disabled = empty;
      btn.classList.toggle('is-disabled', empty);
      btn.setAttribute('aria-disabled', empty ? 'true' : 'false');
    }, true);
    root._applyGuardInstalled = true;
  }catch(_){}
})();

        function imgForProduct(handle, size) {
            const holder = el('span', { class: 'atlas-cvp__table-thumb', 'data-img-handle': handle || '' });
            const setSrc = (url) => {
              if (!url) return;
              let finalUrl = url;

              // Normalize protocol-less or relative URLs
              if (finalUrl.startsWith('//')) finalUrl = 'https:' + finalUrl;
              // Apply width param if a positive size is provided and no explicit width param exists
              if (size && Number(size) > 0) {
                const hasParam = /[?&]width=\d+/i.test(finalUrl);
                if (!hasParam) {
                  finalUrl += (finalUrl.includes('?') ? '&' : '?') + 'width=' + Number(size);
                }
              }

              while (holder.firstChild) holder.removeChild(holder.firstChild);
              holder.appendChild(el('img', { src: finalUrl, loading: 'lazy', alt: '' }));
            };
            if (handle && handleImages[handle]) setSrc(handleImages[handle]);
            else if (handle) resolveImageUrlViaAjax(handle).then(setSrc).catch(() => {});
            return holder;
        }

        function renderSwatchSingle(step, idx) {
            const stepName = step.name || step.label || `Step ${idx + 1}`;
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "swatch-single",
                "data-step-name": stepName
            });

            if (step.label) {
                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label),
                    step.required
                        ? el("span", { class: "atlas-cvp__req" }, "Required")
                        : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);
                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }
            }
            const grid = el("div", {
                "class": "atlas-cvp__swatches atlas-cvp__swatches--single",
                "role": "radiogroup",
                "aria-label": stepName
            });
            (step.options || []).forEach((opt, i) => {
                const handle = opt.handle;
                const optLabel =
                    opt.name_override || handle || `Option ${i + 1}`;
                const inputId = `cvp-${root.dataset.uid}-${stepName.replace(/\s+/g, "-").toLowerCase()}-${i + 1}`;
                const lbl = el("label", {
                    class: "atlas-cvp__swatch",
                    for: inputId
                });
                const inp = el("input", {
                    "type": "radio",
                    "class": "atlas-cvp__input",
                    "name": `cvp__${stepName.replace(/\s+/g, "-").toLowerCase()}`,
                    "id": inputId,
                    "value": optLabel,
                    "data-handle": handle,
                    "form": formId
                });

                let pc = 0;
                if (handle && handlePrices[handle] != null) pc = parseInt(handlePrices[handle],10) || 0;
                else if (opt.name_override) {
                  const m = opt.name_override.match(/\+\s*\$\s*(\d+(?:[\.,]\d{1,2})?)/i);
                  if (m) pc = Math.round(parseFloat(m[1].replace(',', '.'))*100);
                }
                inp.setAttribute('data-price-cents', String(pc));
                if ((!pc || pc === 0) && handle) {
                  inp.setAttribute('data-price-pending', '1');
                  resolvePriceCentsViaAjax(handle);
                }
                if (step.required) inp.setAttribute("required", "");
                const vis = el("span", { class: "atlas-cvp__swatch-visual" });
                let thumbEl = null;
                if (opt.image_override && typeof opt.image_override === 'string') {
                  // 1) Explicit URL from JSON has highest priority
                  thumbEl = el('img', {
                    class: 'atlas-cvp__swatch-thumb',
                    src: opt.image_override,
                    alt: optLabel,
                    loading: 'lazy'
                  });
                } else if (handle) {
                  // 2) Fallback to product image resolved by handle
                  thumbEl = imgForProduct(handle, 120);
                  if (thumbEl && thumbEl.tagName === 'IMG') {
                    // no-op: already an IMG from imgForProduct (if it returns IMG)
                  }
                } else {
                  // 3) Minimal dot placeholder if nothing available
                  thumbEl = el('span', { class: 'atlas-cvp__swatch-dot' });
                }
                if (thumbEl) vis.appendChild(thumbEl);
                const cap = el(
                    "span",
                    { class: "atlas-cvp__swatch-label" },
                    optLabel
                );
                lbl.appendChild(inp);
                lbl.appendChild(vis);
                lbl.appendChild(cap);
                grid.appendChild(lbl);
            });
            wrap.appendChild(grid);
            return wrap;
        }

        function renderSwatchTable(step, idx) {
            const stepName = step.name || step.label || `Step ${idx + 1}`;
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "swatch-table",
                "data-step-name": stepName
            });

            if (step.label) {
                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label),
                    step.required
                        ? el("span", { class: "atlas-cvp__req" }, "Required")
                        : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);
                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }
            }
            const table = el("div", {
                "class": "atlas-cvp__table",
                "role": "radiogroup",
                "aria-label": stepName
            });
            (step.options || []).forEach((opt, i) => {
                const handle = opt.handle;
                const optLabel =
                    opt.name_override || handle || `Option ${i + 1}`;
                const inputId = `cvp-tab-${root.dataset.uid}-${stepName.replace(/\s+/g, "-").toLowerCase()}-${i + 1}`;
                const row = el("label", {
                    class: "atlas-cvp__table-row",
                    for: inputId
                });
                const inp = el("input", {
                    "type": "radio",
                    "class": "atlas-cvp__input",
                    "name": `cvp__${stepName.replace(/\s+/g, "-").toLowerCase()}`,
                    "id": inputId,
                    "value": optLabel,
                    "data-handle": handle,
                    "form": formId
                });
                // Attach price if known
                let pc = 0;
                if (handle && handlePrices[handle] != null) pc = parseInt(handlePrices[handle],10) || 0;
                else if (opt.name_override) {
                  const m = opt.name_override.match(/\+\s*\$\s*(\d+(?:[\.,]\d{1,2})?)/i);
                  if (m) pc = Math.round(parseFloat(m[1].replace(',', '.'))*100);
                }
                inp.setAttribute('data-price-cents', String(pc));
                if ((!pc || pc === 0) && handle) {
                  inp.setAttribute('data-price-pending', '1');
                  resolvePriceCentsViaAjax(handle);
                }
                if (step.required) inp.setAttribute("required", "");
                const main = el("span", { class: "atlas-cvp__table-main" });
                main.appendChild(
                    el("span", { class: "atlas-cvp__table-title" }, optLabel)
                );
                if (opt.description)
                    main.appendChild(
                        el(
                            "span",
                            { class: "atlas-cvp__table-desc" },
                            opt.description
                        )
                    );
                row.appendChild(inp);
                row.appendChild(imgForProduct(handle, 64));
                row.appendChild(main);
                table.appendChild(row);
            });
            wrap.appendChild(table);
            return wrap;
        }

function renderNumberWheelPicker(step, idx) {
            const stepName = step.name || step.label || `Step ${idx + 1}`;
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "swatch-table",
                "data-step-name": stepName
            });

            if (step.label) {
                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label),
                    step.required
                        ? el("span", { class: "atlas-cvp__req" }, "Required")
                        : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);
                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }
            }

            const wheelsRow = el('div', {});
            wheelsRow.style.cssText = 'display:flex;gap:16px;margin:12px 0;';

            function makeWheel(labelText) {
                const col = el('div', {});
                col.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:6px;';
                const lbl = el('div', {}, labelText);
                lbl.style.cssText = 'font-size:0.8em;color:rgba(var(--color-foreground),0.7);';
                const select = el('select', {});
                select.style.cssText = 'font-size:1.4em;padding:10px 14px;border-radius:10px;border:1px solid rgba(var(--color-foreground),0.2);background:rgb(var(--color-background));min-width:80px;text-align:center;';
                const blank = el('option', { value: '' }, '\u2013');
                select.appendChild(blank);
                for (let n = 0; n <= 9; n++) {
                    select.appendChild(el('option', { value: String(n) }, String(n)));
                }
                col.appendChild(lbl);
                col.appendChild(select);
                return { col, select };
            }

            const wheelA = makeWheel('First Number');
            const wheelB = makeWheel('Second Number');
            wheelsRow.appendChild(wheelA.col);
            wheelsRow.appendChild(wheelB.col);
            wrap.appendChild(wheelsRow);

            const preview = el('div', {}, '');
            preview.style.cssText = 'font-weight:600;margin-bottom:4px;';
            wrap.appendChild(preview);

            const priceNote = el('div', {}, '$3 per number');
            priceNote.style.cssText = 'font-size:0.85em;color:rgba(var(--color-foreground),0.7);margin-bottom:10px;';
            wrap.appendChild(priceNote);

            let currentRadio = null;

            function commit() {
                const a = wheelA.select.value;
                const b = wheelB.select.value;
                const digits = [a, b].filter((v) => v !== '');

                if (currentRadio && currentRadio.parentNode) currentRadio.parentNode.removeChild(currentRadio);
                currentRadio = null;

                if (!digits.length) {
                    preview.textContent = '';
                    try { recomputeSelections(); } catch (_) {}
                    try { recomputeTotal(); } catch (_) {}
                    try { updateAccordionHeaderDisplay(); } catch (_) {}
                    try { syncAtcDisabled(); } catch (_) {}
                    return;
                }

                const numberText = a + b;
                const digitCount = digits.length;

                const inp = document.createElement('input');
                inp.type = 'radio';
                inp.className = 'atlas-cvp__input';
                inp.name = `cvp__${stepName.replace(/\s+/g, '-').toLowerCase()}`;
                inp.value = numberText;
                inp.dataset.linkedHandle = step.addon_handle;
                inp.dataset.linkedQuantity = String(digitCount);
                inp.dataset.keepLabel = '1'; // send the chosen digits (not 'Included') to the order
                inp.setAttribute('data-price-cents', String(digitCount * 300));
                inp.setAttribute('form', formId);
                inp.style.display = 'none';
                inp.checked = true;
                wrap.appendChild(inp);
                currentRadio = inp;

                inp.dispatchEvent(new Event('change', { bubbles: true }));

                preview.textContent = 'Number: ' + numberText + ' ($' + (digitCount * 3) + '.00)';

                try { recomputeSelections(); } catch (_) {}
                try { recomputeTotal(); } catch (_) {}
                try { updateAccordionHeaderDisplay(); } catch (_) {}
                try { syncAtcDisabled(); } catch (_) {}
            }

            wheelA.select.addEventListener('change', commit);
            wheelB.select.addEventListener('change', commit);

            return wrap;
        }
function parseLeadTime(rawList) {
    if (!Array.isArray(rawList) || !rawList.length) return null;

    const lines = rawList
        .map((line) => {
            const parts = String(line).split('=>');
            if (parts.length < 2) return null;
            const left = parts[0].trim();
            const right = parts.slice(1).join('=>').trim();
            return left && right ? `${left}: ${right}` : null;
        })
        .filter(Boolean);

    return lines.length ? lines.join('; ') + '.' : null;
}
function renderFinishingTouchesModal(step, idx) {
    const stepName = step.name || step.label || `Step ${idx + 1}`;
    const uid = (root.dataset.uid || 'x') + '-' + idx;
    const wrap = el("div", {
        "class": "atlas-cvp__step",
        "data-step-index": idx + 1,
        "data-step-type": "swatch-table",
        "data-step-name": stepName
    });

    if (step.required) wrap.setAttribute("data-required", "true");

    wrap.style.cssText = 'margin:16px 0;';
    const addLabel = step.button_label || step.label || 'Finishing Touches';
    const triggerBtn = el('button', { type: 'button', class: 'button button--primary atlas-cvp__fts-btn' }, addLabel);
    wrap.appendChild(triggerBtn);

    const selectedSummary = el('div', { class: 'atlas-cvp__ft-summary' });
    wrap.appendChild(selectedSummary);

    const itemsHolder = el('div', { class: 'atlas-cvp__ft-items-holder', style: 'display:none;' });
    wrap.appendChild(itemsHolder);

    const dialog = document.createElement('dialog');
    dialog.id = 'FinishingTouches-' + uid;
    dialog.className = 'important-order-info__modal product-popup-modal';

    const closeForm = el('form', { method: 'dialog', class: 'important-order-info__close' });
    const closeBtn = el('button', { type: 'submit', class: 'important-order-info__close-btn', 'aria-label': 'Close' }, '\u00D7');
    closeForm.appendChild(closeBtn);
    dialog.appendChild(closeForm);

    const content = el('div', { role: 'document', class: 'product-popup-modal__content-info atlas-ft-modal-content' });
    dialog.appendChild(content);

    function ftStyleOnce() {
        if (document.getElementById('ft-modal-style')) return;
        const s = document.createElement('style');
        s.id = 'ft-modal-style';
        s.textContent = `
            dialog.important-order-info__modal.product-popup-modal { background: #FBE7E6; }
            .atlas-ft-modal-content { max-width: 340px; padding-bottom: 16px; position: relative; }
            @media (max-width: 480px) {
                .atlas-ft-modal-content { max-width: 100%; }
            }
            .atlas-cvp__ft-subtitle { font-size:0.85em; color:rgba(var(--color-foreground),0.7); margin:-6px 0 10px; text-align:center; }
            .atlas-cvp__ft-list { display:flex; flex-direction:column; gap:10px; margin-top:16px; }
            .atlas-cvp__ft-row { border:1px solid rgba(var(--color-foreground),0.15); border-radius:8px; overflow:hidden; background:rgb(var(--color-background)); }
            .atlas-cvp__ft-row.selected { border-color:#262967; border-width:2px; }
            .atlas-cvp__ft-row.added { border-color:#262967; }
            .atlas-cvp__ft-item { display:flex; align-items:flex-start; gap:14px; padding:10px; background:none; border:none; cursor:pointer; text-align:left; width:100%; font-size:1em; }
            .atlas-cvp__ft-item img { width:224px; height:224px; object-fit:cover; border-radius:6px; flex-shrink:0; }
            .atlas-cvp__ft-item-text { display:flex; flex-direction:column; gap:2px; flex:1; min-width:0; }
            .atlas-cvp__ft-title-row { display:flex; align-items:center; justify-content:space-between; gap:8px; font-weight:600; flex-wrap:wrap; }
            .atlas-cvp__ft-price-tag { font-size:0.85em; font-weight:600; color:#262967; white-space:nowrap; }
            @media (max-width: 480px) {
                .atlas-cvp__ft-lead-label { display:none; }
            }                .atlas-cvp__ft-lead-label { display:none; }
            }
            .atlas-cvp__ft-lead-label { font-size: 0.75em !important; font-weight: 400 !important; }
            .atlas-cvp__ft-added-tag { font-size:0.75em; font-weight:700; color:#1a7d3a; white-space:nowrap; }
            .atlas-cvp__ft-desc { font-size:0.8em; color:rgba(var(--color-foreground),0.7); font-weight:400; }
            .atlas-cvp__ft-detail { max-height:0; overflow:hidden; transition:max-height .25s ease; padding:0 12px; }
            .atlas-cvp__ft-detail.open { max-height:1200px; overflow-y:auto; padding:0 12px 12px; }
            .atlas-cvp__ft-detail-inner { padding-top:8px; border-top:1px solid rgba(var(--color-foreground),0.1); }
            .atlas-cvp__ft-section { margin-top:12px; }
            .atlas-cvp__ft-section-label { font-size:0.85em; font-weight:600; margin-bottom:6px; }
            .atlas-cvp__swatches { display:flex; flex-wrap:wrap; gap:10px; }
            .atlas-cvp__ft-swatch { display:flex; flex-direction:column; align-items:center; gap:6px; padding:8px; border:1px solid rgba(var(--color-foreground),0.15); border-radius:8px; background:none; cursor:pointer; min-width:90px; }
            .atlas-cvp__ft-swatch.selected { border-color:#262967; border-width:2px; }
            .atlas-cvp__ft-swatch img { width:70px; height:70px; object-fit:cover; border-radius:6px; }
            .atlas-cvp__ft-text-input { width:100%; padding:10px; border-radius:8px; border:1px solid rgba(var(--color-foreground),0.2); background:rgb(var(--color-background)); font-size:1em; }
            .atlas-cvp__ft-text-hint { font-size:0.8em; color:rgba(var(--color-foreground),0.6); margin-top:4px; }
            .atlas-cvp__ft-word-boxes { display:flex; gap:8px; flex-wrap:wrap; }
            .atlas-cvp__ft-word-input { flex:1 1 0; min-width:0; padding:10px 8px; text-align:center; border-radius:8px; border:1px solid rgba(var(--color-foreground),0.2); background:rgb(var(--color-background)); font-size:1em; }
            @media (max-width: 480px) {
                .atlas-cvp__ft-word-boxes { gap:6px; }
                .atlas-cvp__ft-word-input { padding:10px 4px; font-size:0.95em; }
                                .atlas-cvp__ft-item img { width:100px; height:100px; }
            }
            .atlas-cvp__ft-wheels { display:flex; gap:16px; }
            .atlas-cvp__ft-wheel-col { display:flex; flex-direction:column; align-items:center; gap:6px; }
            .atlas-cvp__ft-wheel-col label { font-size:0.8em; color:rgba(var(--color-foreground),0.7); }
            .atlas-cvp__ft-summary { display:flex; flex-direction:column; gap:2px; margin-top:6px; }
            .atlas-cvp__ft-summary-line { display:flex; justify-content:space-between; gap:10px; font-size:0.9em; font-weight:600; color:rgb(var(--color-foreground)); }
            .atlas-cvp__ft-wheel-col select { font-size:1.3em; padding:8px 12px; border-radius:8px; border:1px solid rgba(var(--color-foreground),0.2); background:rgb(var(--color-background)); min-width:70px; text-align:center; }
            .atlas-cvp__ft-footer { position:sticky; bottom:0; left:0; right:0; background:#FBE7E6; padding:12px 16px 16px; margin-top:16px; border-top:1px solid rgba(var(--color-foreground),0.1); display:flex; justify-content:flex-end; }
            .atlas-cvp__ft-footer button { width:auto; padding:12px 32px; }
            .atlas-cvp__ft-footer button:disabled { opacity:0.5; cursor:not-allowed; }
            .atlas-cvp__ft-add-btn { width:100%; margin-top:8px; }
            .atlas-cvp__ft-lead-time-side { margin-top:10px; padding:10px 10px 10px 0; border-radius:8px; background:rgb(var(--color-background)); }
            .atlas-cvp__ft-lead-time-heading { font-size:0.85em; font-weight:600; margin-bottom:6px; }
            .atlas-cvp__ft-lead-time { display:flex; flex-wrap:wrap; gap:6px; }
                        .atlas-cvp__ft-lead-pill { align-self:flex-start; max-width:100%; font-size:0.75em; padding:4px 10px; border-radius:999px; background:#FBE7E6; border:1px solid rgba(38,41,103,0.15); color:#262967; white-space:normal; }
        `;
        document.head.appendChild(s);
    }
    ftStyleOnce();

    let itemCounter = 0;
    const selectedItems = new Map(); // key -> { stepDiv, label, extraCents, handle }
    const addedByHandle = new Map(); // handle -> Set of item keys, for row "Added" restoration
    const answersByHandle = new Map(); // handle -> answers object, for restoring detail-panel selections

    function updateTriggerSummary() {
        selectedSummary.innerHTML = '';
        selectedItems.forEach((it) => {
            const line = el('div', { class: 'atlas-cvp__ft-summary-line' }, [
                el('span', {}, '\u2713 ' + (it.shortLabel || it.label)),
                it.extraCents > 0 ? el('span', {}, formatMoney(it.extraCents)) : null
            ]);
            selectedSummary.appendChild(line);
            triggerBtn.textContent = selectedItems.size > 0 ? ('Edit ' + addLabel.replace(/^Add\s+/i, '')) : addLabel;
        });
    }

    function commitItem(payload) {
        itemCounter += 1;
        const uniqueStepName = `${stepName}${'\u200B'.repeat(itemCounter)}`;
        const itemStep = el('div', {
            class: 'atlas-cvp__step',
            'data-step-name': uniqueStepName,
            'data-step-type': 'swatch-single',
            'data-step-index': '999',
            style: 'display:none;'
        });
        const inp = document.createElement('input');
        inp.type = 'radio';
        inp.className = 'atlas-cvp__input';
        inp.name = `cvp__${uniqueStepName.replace(/\s+/g, '-').toLowerCase()}`;
        inp.value = payload.label;
        if (payload.handle) inp.dataset.handle = payload.handle;
        if (payload.linkedHandle) inp.dataset.linkedHandle = payload.linkedHandle;
        if (payload.linkedQuantity) inp.dataset.linkedQuantity = String(payload.linkedQuantity);
        inp.setAttribute('data-price-cents', String(payload.extraCents || 0));
        inp.setAttribute('form', formId);
        inp.checked = true;
        itemStep.appendChild(inp);
        itemsHolder.appendChild(itemStep);

        inp.dispatchEvent(new Event('change', { bubbles: true }));

        try {
            if (payload.extraProps) {
                Object.entries(payload.extraProps).forEach(([k, v]) => setProp(k, v));
            }
        } catch (_) {}

        const key = 'item-' + itemCounter;
        selectedItems.set(key, { stepDiv: itemStep, label: payload.label, shortLabel: payload.shortLabel || payload.label, extraCents: payload.extraCents || 0, handle: payload.handle || null });

        const trackHandle = payload.parentHandle || payload.handle;
        if (trackHandle) {
            if (!addedByHandle.has(trackHandle)) addedByHandle.set(trackHandle, new Set());
            addedByHandle.get(trackHandle).add(key);
        }

        updateTriggerSummary();
        try { recomputeSelections(); } catch (_) {}
        try { recomputeTotal(); } catch (_) {}
        try { updateAccordionHeaderDisplay(); } catch (_) {}
        try { syncAtcDisabled(); } catch (_) {}
        return key;
    }

    const footer = el('div', { class: 'atlas-cvp__ft-footer' });
    const footerBtn = el('button', { type: 'button', class: 'button button--primary' }, 'Done');
    footer.appendChild(footerBtn);
    footerBtn.addEventListener('click', () => { try { dialog.close(); } catch (_) {} });

       const stepsCache = {};
    function fetchStepsForHandle(handle) {
        if (stepsCache[handle] !== undefined) return Promise.resolve(stepsCache[handle]);

        // Prefer server-supplied data (works even for "hidden"/not-purchasable products,
        // whose own storefront page can't be fetched client-side).
        if (collectionSteps && collectionSteps[handle]) {
            const pre = collectionSteps[handle];
            const result = {
                steps: Array.isArray(pre.steps) ? pre.steps : [],
                leadTimeRaw: Array.isArray(pre.leadTimeRaw) ? pre.leadTimeRaw : []
            };
            stepsCache[handle] = result;
            return Promise.resolve(result);
        }

        return fetch(`/products/${encodeURIComponent(handle)}`)
            .then((r) => r.text())
            .then((html) => {
                let steps = [];
                try {
                    const m = html.match(/<script[^>]+data-cvp-steps[^>]*>([\s\S]*?)<\/script>/);
                    if (m) steps = JSON.parse(m[1]);
                } catch (_) { steps = []; }

                let leadTimeRaw = [];
                try {
                    const lm = html.match(/<script[^>]+data-cvp-lead-time[^>]*>([\s\S]*?)<\/script>/);
                    if (lm) leadTimeRaw = JSON.parse(lm[1]) || [];
                } catch (_) { leadTimeRaw = []; }

                const result = {
                    steps: Array.isArray(steps) ? steps : [],
                    leadTimeRaw: Array.isArray(leadTimeRaw) ? leadTimeRaw : []
                };
                stepsCache[handle] = result;
                return result;
            })
            .catch(() => {
                const result = { steps: [], leadTimeRaw: [] };
                stepsCache[handle] = result;
                return result;
            });
    }

    function stripHtml(html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html || '';
        return (tmp.textContent || '').trim();
    }

    function renderParentList() {
        content.innerHTML = '';
        content.appendChild(el('h2', { class: 'h2' }, step.label || 'Finishing Touches'));
        content.appendChild(el('p', { class: 'atlas-cvp__ft-subtitle' }, 'You can select more than one option.'));

        const list = el('div', { class: 'atlas-cvp__ft-list' });
        content.appendChild(list);
        list.appendChild(el('div', {}, 'Loading...'));

        const collectionHandle = step.collection_handle;
        fetch(`/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=50`)
            .then((r) => r.json())
            .then((data) => {
                list.innerHTML = '';
                (data.products || []).forEach((product) => {
                    const parentLabel = product.title;
                    const descText = stripHtml(product.body_html);
                    const img = product.images && product.images[0] ? product.images[0].src : null;
                    const baseVariantId = product.variants && product.variants[0] ? product.variants[0].id : null;
                    if (baseVariantId) handleVariants[product.handle] = baseVariantId;
                    let basePriceCents = 0;
                    if (product.variants && product.variants[0]) {
                        basePriceCents = Math.round(parseFloat(product.variants[0].price) * 100);
                        handlePrices[product.handle] = basePriceCents;
                    }

                    const row = el('div', { class: 'atlas-cvp__ft-row' });
                    const header = el('button', { type: 'button', class: 'atlas-cvp__ft-item' });
                    let ftImgSrc = img;
                    if (ftImgSrc) {
                        if (ftImgSrc.indexOf('//') === 0) ftImgSrc = 'https:' + ftImgSrc;
                        if (/[?&]width=\d+/i.test(ftImgSrc)) {
                            ftImgSrc = ftImgSrc.replace(/([?&])width=\d+/i, '$1width=448');
                        } else {
                            ftImgSrc += (ftImgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=448';
                        }
                    }
                    header.appendChild(ftImgSrc
                        ? el('img', { src: ftImgSrc, alt: parentLabel, loading: 'lazy' })
                        : imgForProduct(product.handle, 448));
                    const textCol = el('div', { class: 'atlas-cvp__ft-item-text' });
                    const titleRow = el('div', { class: 'atlas-cvp__ft-title-row' });
fetchStepsForHandle(product.handle).then(({ leadTimeRaw }) => {
    if (!Array.isArray(leadTimeRaw) || !leadTimeRaw.length) return;
    let kingslandValue = null;
    leadTimeRaw.forEach((line) => {
        const parts = String(line).split('=>');
        if (parts.length < 2) return;
        const left = parts[0].trim().toLowerCase();
        const right = parts.slice(1).join('=>').trim();
        if (left.includes('kingsland')) kingslandValue = right;
    });
    if (!kingslandValue) return;
    if (textCol.querySelector('.atlas-cvp__ft-lead-pill')) return;
    const miniPill = el('span', { class: 'atlas-cvp__ft-lead-pill' }, [el("span",{class:"atlas-cvp__ft-lead-label"},"Lead Time Required - "),kingslandValue]);
    textCol.insertBefore(miniPill, titleRow);
});
                    titleRow.appendChild(el('span', {}, parentLabel));
                    if (basePriceCents > 0) {
                        titleRow.appendChild(el('span', { class: 'atlas-cvp__ft-price-tag' }, formatMoney(basePriceCents)));
                    }
                    if (addedByHandle.has(product.handle) && addedByHandle.get(product.handle).size > 0) {
                        titleRow.appendChild(el('span', { class: 'atlas-cvp__ft-added-tag' }, '\u2713 Added'));
                        row.classList.add('added');
                    }
                    textCol.appendChild(titleRow);
                    if (descText) textCol.appendChild(el('span', { class: 'atlas-cvp__ft-desc' }, descText));
                    header.appendChild(textCol);
                    row.appendChild(header);

                    // If this item has no direct price (e.g. priced per-digit via an add-on),
                    // resolve and show a "$X each" tag once we know it.
                    if (!basePriceCents) {
                        fetchStepsForHandle(product.handle).then(({ steps: productSteps }) => {
                            const wheelStep = (productSteps || []).find((s) => (s.type || '').toLowerCase() === 'number-wheel-picker' && s.addon_handle);
                            if (!wheelStep) return;
                            resolvePriceCentsViaAjax(wheelStep.addon_handle).then((cents) => {
                                if (!cents) return;
                                if (titleRow.querySelector('.atlas-cvp__ft-price-tag')) return;
                                const tag = el('span', { class: 'atlas-cvp__ft-price-tag' }, formatMoney(cents) + ' each');
                                titleRow.insertBefore(tag, titleRow.querySelector('.atlas-cvp__ft-added-tag') || null);
                            });
                        });
                    }

                    const detail = el('div', { class: 'atlas-cvp__ft-detail' });
                    const inner = el('div', { class: 'atlas-cvp__ft-detail-inner' });
                    inner.appendChild(el('div', {}, 'Loading options...'));
                    detail.appendChild(inner);
                    row.appendChild(detail);

                    let detailLoaded = false;
                    header.addEventListener('click', () => {
                        const isOpen = detail.classList.contains('open');
                        list.querySelectorAll('.atlas-cvp__ft-detail.open').forEach((d) => d.classList.remove('open'));
                        list.querySelectorAll('.atlas-cvp__ft-row.selected').forEach((r) => r.classList.remove('selected'));
                        if (isOpen) return;
                        detail.classList.add('open');
                       setTimeout(() => {
    try {
        const dur = 600;
        const startY = dialog.scrollTop;
        const targetY = startY + (row.getBoundingClientRect().top - dialog.getBoundingClientRect().top) - 16;
        const t0 = performance.now();
        function step(now) {
            const p = Math.min(1, (now - t0) / dur);
            const eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
            dialog.scrollTop = startY + (targetY - startY) * eased;
            if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    } catch (_) {}
}, 350);

             if (detailLoaded) return;
                        detailLoaded = true;

                        fetchStepsForHandle(product.handle).then(({ steps: productSteps, leadTimeRaw }) => {
                            inner.innerHTML = '';
                            renderProductDetail(product, parentLabel, productSteps, inner, leadTimeRaw, row, basePriceCents);
                            
                        });
                    });

                    list.appendChild(row);
                });
            })
            .catch(() => {
                list.innerHTML = '';
                list.appendChild(el('div', {}, 'Could not load options.'));
            });
    }

    function renderProductDetail(product, parentLabel, productSteps, inner, leadTimeRaw, row, basePriceCents) {
        const relevantSteps = (productSteps || []).filter((s) => {
            const t = (s.type || '').toLowerCase();
            return ['swatch-single', 'swatch-table', 'text', 'number-wheel-picker'].includes(t);
        });

        renderLeadTimeBlock(); function renderLeadTimeBlock() {
            if (row.querySelector('.atlas-cvp__ft-lead-time-side') || row.querySelector('.atlas-cvp__ft-lead-pill')) return; if (!Array.isArray(leadTimeRaw) || !leadTimeRaw.length) return;

            let kingslandValue = null;
            leadTimeRaw.forEach((line) => {
                const parts = String(line).split('=>');
                if (parts.length < 2) return;
                const left = parts[0].trim().toLowerCase();
                const right = parts.slice(1).join('=>').trim();
                if (left.includes('kingsland')) kingslandValue = right;
            });
            if (!kingslandValue) return;

            const sideWrap = el('div', { class: 'atlas-cvp__ft-lead-time-side' });
            const badgeWrap = el('div', { class: 'atlas-cvp__ft-lead-time' });
            badgeWrap.appendChild(el('span', { class: 'atlas-cvp__ft-lead-pill' }, `Lead Time Required - ${kingslandValue}`));
            sideWrap.appendChild(badgeWrap);
            (row.querySelector('.atlas-cvp__ft-title-row') ? row.querySelector('.atlas-cvp__ft-title-row').insertAdjacentElement('beforebegin', sideWrap) : inner.appendChild(sideWrap));
        }

        function markRowAdded() {
            row.classList.add('added');
            const titleRow = row.querySelector('.atlas-cvp__ft-title-row');
            if (titleRow && !titleRow.querySelector('.atlas-cvp__ft-added-tag')) {
                titleRow.appendChild(el('span', { class: 'atlas-cvp__ft-added-tag' }, '\u2713 Added'));
            }
        }

        function markRowRemoved() {
            row.classList.remove('added');
            const titleRow = row.querySelector('.atlas-cvp__ft-title-row');
            const tag = titleRow && titleRow.querySelector('.atlas-cvp__ft-added-tag');
            if (tag) tag.remove();
        }

        function removeAllForThisProduct() {
            const keys = addedByHandle.get(product.handle);
            if (!keys) return;
            Array.from(keys).forEach((key) => {
                const it = selectedItems.get(key);
                if (it && it.stepDiv && it.stepDiv.parentNode) it.stepDiv.parentNode.removeChild(it.stepDiv);
                selectedItems.delete(key);
            });
            addedByHandle.delete(product.handle);
            updateTriggerSummary();
            try { recomputeSelections(); } catch (_) {}
            try { recomputeTotal(); } catch (_) {}
            try { updateAccordionHeaderDisplay(); } catch (_) {}
            try { syncAtcDisabled(); } catch (_) {}
            markRowRemoved();
        }

        const addBtnLabel = () => isAdded ? `Remove ${parentLabel}` : (`Add ${parentLabel}` + (basePriceCents > 0 ? ` (${formatMoney(basePriceCents)})` : ''));
        let isAdded = false;
        const addBtn = el('button', { type: 'button', class: 'button button--secondary atlas-cvp__ft-add-btn' }, addBtnLabel());

        const alreadyAdded = addedByHandle.has(product.handle) && addedByHandle.get(product.handle).size > 0;
        isAdded = alreadyAdded;
        const removeBtn = el('button', { type: 'button', class: 'button button--secondary atlas-cvp__ft-add-btn' }, 'Remove ' + parentLabel);
        removeBtn.style.cssText = 'margin-top:8px;border-color:#c0392b;color:#c0392b;';
        removeBtn.style.display = 'none';
        removeBtn.addEventListener('click', () => {
            removeAllForThisProduct();
            removeBtn.style.display = 'none';
        });

         if (!relevantSteps.length) {
            addBtn.addEventListener('click', () => {
                if (isAdded) { removeAllForThisProduct(); isAdded = false; addBtn.textContent = addBtnLabel(); return; }
                commitItem({ handle: product.handle, label: parentLabel, extraCents: basePriceCents, extraProps: null, parentHandle: product.handle });
                markRowAdded();
                isAdded = true; addBtn.textContent = addBtnLabel();
            });
            inner.appendChild(addBtn);
            inner.appendChild(removeBtn);
            renderLeadTimeBlock();
            return;
        }

        // Restore any previously-entered answers for this product (same Map instance is
        // mutated in place below, so future re-opens see the latest state automatically).
        let answers = answersByHandle.get(product.handle);
        if (!answers) {
            answers = {};
            answersByHandle.set(product.handle, answers);
        }
        let currentBuild = null;

        function stepIsSatisfied(s, i) {
            const a = answers[i];
            if (!s.required) return true;
            const t = (s.type || '').toLowerCase();
            if (t === 'text') return !!(a && a.text && a.text.trim());
            if (t === 'number-wheel-picker') return !!(a && a.digits && a.digits.length);
            return !!(a && a.handle);
        }

        function recomputeLocal() {
            const allOk = relevantSteps.every((s, i) => stepIsSatisfied(s, i));
            addBtn.disabled = !allOk;
            if (!allOk) { currentBuild = null; return; }

            currentBuild = () => {
                let handle = product.handle;
                let linkedHandle = null;
                let linkedQuantity = null;
                let extraCents = basePriceCents;
                const labelParts = [parentLabel];
                const shortLabelParts = [parentLabel];
                const extraProps = {};

                relevantSteps.forEach((s, i) => {
                    const t = (s.type || '').toLowerCase();
                    const a = answers[i] || {};
                    if ((t === 'swatch-single' || t === 'swatch-table') && a.handle) {
                        if ((JSON.parse((root.querySelector('script[type="application/json"][data-cvp-prices]')||{}).textContent||root.dataset.prices||'{}'))[a.handle] > 0) { handle = a.handle; } else { extraProps['_SelectedVariant'] = a.handle; }
                        labelParts.push(a.label);
                        shortLabelParts.push(a.label);
                    } else if (t === 'text' && a.text) {
                        const key = s.name || s.label || 'Message';
                        extraProps[key] = a.text;
                        labelParts.push(a.text);
                        // Deliberately omitted from shortLabelParts — free-text messages
                        // can be long, so they're left out of the compact summary line.
                    } else if (t === 'number-wheel-picker' && a.digits && a.digits.length) {
                        linkedHandle = s.addon_handle || null;
                        linkedQuantity = a.digits.length;
                        extraCents += (a.unitCents || 0) * a.digits.length;
                        labelParts.push(a.digits.join(''));
                        shortLabelParts.push(a.digits.join(''));
                    }
                });

                return {
                    handle,
                    linkedHandle,
                    linkedQuantity,
                    extraCents,
                    label: labelParts.filter(Boolean).join(' - '),
                    shortLabel: shortLabelParts.filter(Boolean).join(' - '),
                    extraProps: Object.keys(extraProps).length ? extraProps : null,
                    parentHandle: product.handle
                };
            };
        }

        relevantSteps.forEach((s, i) => {
            const t = (s.type || '').toLowerCase();
            const section = el('div', { class: 'atlas-cvp__ft-section' });
            if (s.label) section.appendChild(el('div', { class: 'atlas-cvp__ft-section-label' }, s.label));

            if (t === 'swatch-single' || t === 'swatch-table') {
                const grid = el('div', { class: 'atlas-cvp__swatches' });
                const prevAnswer = answers[i];
                (s.options || []).forEach((opt) => {
                    const optLabel = opt.name_override || opt.handle || 'Option';
                    const optHandle = opt.handle || product.handle;
                    const swatch = el('button', { type: 'button', class: 'atlas-cvp__ft-swatch' });
                    swatch.appendChild(imgForProduct(optHandle, 70));
                    swatch.appendChild(el('span', {}, optLabel));
                    if (prevAnswer && prevAnswer.handle === optHandle && prevAnswer.label === optLabel) {
                        swatch.classList.add('selected');
                    }
                    swatch.addEventListener('click', () => {
                        grid.querySelectorAll('.atlas-cvp__ft-swatch.selected').forEach((el2) => el2.classList.remove('selected'));
                        swatch.classList.add('selected');
                        answers[i] = { handle: optHandle, label: optLabel, isAddonToggle: (s.options||[]).length === 1 };
                        recomputeLocal();
                    });
                    grid.appendChild(swatch);
                });
                section.appendChild(grid);
            } else if (t === 'text') {
                const maxWords = parseInt(s.max_words || 0, 10) || 0;
                const prevText = (answers[i] && answers[i].text) || '';

                if (maxWords > 0) {
                    const wordBoxWrap = el('div', { class: 'atlas-cvp__ft-word-boxes' });
                    const wordInputs = [];
                    const prevWords = prevText.split(' ').filter(Boolean);

                    const commitWords = () => {
                        const val = wordInputs.map((inp) => (inp.value || '').trim()).filter(Boolean).join(' ');
                        answers[i] = { text: val };
                        recomputeLocal();
                    };

                    for (let w = 0; w < maxWords; w++) {
                        const wInput = el('input', {
                            type: 'text',
                            class: 'atlas-cvp__ft-word-input',
                            placeholder: `Word ${w + 1}`
                        });
                        if (prevWords[w]) wInput.value = prevWords[w];
                        wInput.addEventListener('input', () => {
                            if (/\s/.test(wInput.value)) {
                                wInput.value = wInput.value.replace(/\s+/g, '');
                                const next = wordInputs[w + 1];
                                if (next) next.focus();
                            }
                            commitWords();
                        });
                        wInput.addEventListener('keydown', (e) => {
                            if (e.key === ' ' || e.key === 'Enter') {
                                e.preventDefault();
                                const next = wordInputs[w + 1];
                                if (next) next.focus();
                            }
                        });
                        wordInputs.push(wInput);
                        wordBoxWrap.appendChild(wInput);
                    }
                    section.appendChild(wordBoxWrap);
                    if (prevWords.length) { answers[i] = { text: prevWords.join(' ') }; }
                 } else {
                    const input = el('textarea', {
                        class: 'atlas-cvp__ft-text-input',
                        rows: 2,
                        placeholder: s.placeholder || 'Enter your message'
                    });
                    input.style.overflow = 'hidden';
                    input.style.resize = 'none';
                    const autoGrow = () => {
                        input.style.height = 'auto';
                        input.style.height = input.scrollHeight + 'px';
                    };
                    if (prevText) { input.value = prevText; }
                    input.addEventListener('input', () => {
                        answers[i] = { text: input.value || '' };
                        recomputeLocal();
                        autoGrow();
                    });
                    section.appendChild(input);
                    setTimeout(autoGrow, 0);
                }
            } else if (t === 'number-wheel-picker') {
                const wheels = el('div', { class: 'atlas-cvp__ft-wheels' });

                function makeWheel(labelText) {
                    const col = el('div', { class: 'atlas-cvp__ft-wheel-col' });
                    col.appendChild(el('label', {}, labelText));
                    const select = el('select', {});
                    select.appendChild(el('option', { value: '' }, '\u2013'));
                    for (let n = 0; n <= 9; n++) select.appendChild(el('option', { value: String(n) }, String(n)));
                    col.appendChild(select);
                    return { col, select };
                }
                const wheelA = makeWheel('First Number');
                const wheelB = makeWheel('Second Number');
                wheels.appendChild(wheelA.col);
                wheels.appendChild(wheelB.col);
                section.appendChild(wheels);

                const priceNote = el('div', { class: 'atlas-cvp__ft-text-hint' }, '');
                section.appendChild(priceNote);

                const prevDigits = (answers[i] && answers[i].digits) || [];
                if (prevDigits[0]) wheelA.select.value = prevDigits[0];
                if (prevDigits[1]) wheelB.select.value = prevDigits[1];

                let unitCents = (answers[i] && answers[i].unitCents) || 0;
                if (s.addon_handle) {
                    resolvePriceCentsViaAjax(s.addon_handle).then((cents) => {
                        unitCents = cents || 0;
                        priceNote.textContent = formatMoney(unitCents) + ' per number';
                        if (answers[i]) { answers[i].unitCents = unitCents; recomputeLocal(); }
                    });
                }
                function commitWheels() {
                    const digits = [wheelA.select.value, wheelB.select.value].filter((v) => v !== '');
                    if (!digits.length) { delete answers[i]; recomputeLocal(); return; }
                    answers[i] = { digits, unitCents };
                    recomputeLocal();
                }
                wheelA.select.addEventListener('change', commitWheels);
                wheelB.select.addEventListener('change', commitWheels);
            }

            inner.appendChild(section);
        });

        recomputeLocal();

        addBtn.addEventListener('click', () => {
            if (isAdded) { removeAllForThisProduct(); isAdded = false; addBtn.textContent = addBtnLabel(); return; }
                    if (!currentBuild) return;
            const payload = currentBuild();
            if (!payload) return;
            commitItem(payload);
            markRowAdded();
            isAdded = true; addBtn.textContent = addBtnLabel();
        });
        inner.appendChild(addBtn);
        inner.appendChild(removeBtn);

        renderLeadTimeBlock();
    }

    dialog.appendChild(content);
    dialog.appendChild(footer);

    dialog.addEventListener('click', (ev) => {
        if (ev.target === dialog) { try { dialog.close(); } catch (_) {} }
    });

    triggerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        renderParentList();
        try {
            if (typeof dialog.showModal === 'function') dialog.showModal();
            else dialog.setAttribute('open', '');
        } catch (_) {}
    });

    wrap.appendChild(dialog);
    return wrap;
}

            function renderSwatchTableLinked(step, idx) {
            const stepName = step.name || step.label || `Step ${idx + 1}`;
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "swatch-table",
                "data-step-name": stepName
            });

            if (step.label) {
                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label),
                    step.required
                        ? el("span", { class: "atlas-cvp__req" }, "Required")
                        : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);
                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }
            }// ---- Single trigger button (replaces the old always-visible row list) ----
            const addLabel = step.button_label || step.label || 'Finishing Touches';
            const changeLabel = addLabel.replace(/^Add\s+/i, 'Change ');
            const triggerBtn = el('button', { type: 'button' }, addLabel);
            triggerBtn.style.cssText = 'padding:14px 28px;border-radius:24px;border:1px solid #262967;background:#262967;color:#fff;font-weight:600;cursor:pointer;white-space:nowrap;font-size:1em;line-height:1.2;';
            wrap.appendChild(triggerBtn);

            const selectedSummary = el('div', {});
            selectedSummary.style.cssText = 'margin-top:6px;margin-bottom:10px;font-size:0.95em;font-weight:600;color:rgb(var(--color-foreground));';
            wrap.appendChild(selectedSummary);

            // ---- Shared modal, reused for both the parent list and the colour sub-list ----
            const dialog = document.createElement('dialog');
            dialog.style.cssText = 'border:none;border-radius:12px;padding:20px;width:min(92vw,420px);max-height:80vh;overflow-y:auto;background:rgb(var(--color-background));color:rgb(var(--color-foreground));';
            const dialogInner = el('div', {});
            const dialogClose = el('button', { type: 'button', 'aria-label': 'Close' }, '\u00D7');
            dialogClose.style.cssText = 'position:absolute;top:10px;right:14px;background:none;border:none;font-size:1.4em;cursor:pointer;line-height:1;';
            dialog.style.position = 'relative';
            dialogClose.addEventListener('click', () => { try { dialog.close(); } catch (_) {} });
            dialog.appendChild(dialogClose);
            dialog.appendChild(dialogInner);
            dialog.addEventListener('click', (ev) => {
                if (ev.target === dialog) { try { dialog.close(); } catch (_) {} }
            });

            // Tracks the single current selection radio for this step (only ever one at a time)
            let currentRadio = null;

            function commitSelection(handle, linkedHandle, label) {
                if (currentRadio && currentRadio.parentNode) currentRadio.parentNode.removeChild(currentRadio);
                const inp = document.createElement('input');
                inp.type = 'radio';
                inp.className = 'atlas-cvp__input';
                inp.name = `cvp__${stepName.replace(/\s+/g, '-').toLowerCase()}`;
                inp.value = label;
                inp.dataset.handle = handle;
                if (linkedHandle) inp.dataset.linkedHandle = linkedHandle;
                inp.setAttribute('form', formId);
                inp.style.display = 'none';
                inp.checked = true;
                wrap.appendChild(inp);
                currentRadio = inp;
                resolvePriceCentsViaAjax(handle);

                inp.dispatchEvent(new Event('change', { bubbles: true }));
                

                triggerBtn.textContent = changeLabel;
                selectedSummary.textContent = '✓ ' + label;

                try { dialog.close(); } catch (_) {}
                try { recomputeSelections(); } catch (_) {}
                try { recomputeTotal(); } catch (_) {}
                try { updateAccordionHeaderDisplay(); } catch (_) {}
                try { syncAtcDisabled(); } catch (_) {}
            }

            function renderParentList() {
                dialogInner.innerHTML = '';
                const title = el('div', {}, step.label || 'Add Finishing Touches');
                title.style.cssText = 'font-weight:600;font-size:1.1em;margin:0 0 12px;padding-right:24px;';
                dialogInner.appendChild(title);

                const list = el('div', {});
                list.style.cssText = 'display:flex;flex-direction:column;gap:8px;';

                (step.options || []).forEach((parent) => {
                    const hasColours = Array.isArray(parent.colours) && parent.colours.length > 0;
                    const parentLabel = parent.name_override || parent.handle || 'Option';
                    const item = el('button', { type: 'button' });
                    item.style.cssText = 'display:flex;align-items:center;gap:12px;padding:8px;border:1px solid rgba(var(--color-foreground),0.15);border-radius:8px;background:rgb(var(--color-background));cursor:pointer;text-align:left;width:100%;';
                    item.appendChild(imgForProduct(parent.handle, 56));
                    const lbl = el('span', {}, parentLabel);
                    lbl.style.cssText = 'font-weight:500;';
                    item.appendChild(lbl);
                    item.addEventListener('click', () => {
                        if (hasColours) {
                            renderColourList(parent);
                        } else {
                            commitSelection(parent.handle, null, parentLabel);
                        }
                    });
                    list.appendChild(item);
                });

                dialogInner.appendChild(list);
            }

            function renderColourList(parent) {
                dialogInner.innerHTML = '';
                const backBtn = el('button', { type: 'button' }, '\u2190 Back');
                backBtn.style.cssText = 'background:none;border:none;color:rgb(var(--color-button));cursor:pointer;padding:0;margin-bottom:10px;font-size:0.95em;';
                backBtn.addEventListener('click', renderParentList);
                dialogInner.appendChild(backBtn);

                const title = el('div', {}, parent.name_override || parent.handle);
                title.style.cssText = 'font-weight:600;font-size:1.05em;margin:0 0 12px;';
                dialogInner.appendChild(title);

                const grid = el('div', {});
                grid.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px;';

                (parent.colours || []).forEach((c) => {
                    const item = el('button', { type: 'button' });
                    item.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:4px;padding:8px;border:1px solid rgba(var(--color-foreground),0.15);border-radius:8px;background:rgb(var(--color-background));cursor:pointer;min-width:100px;';
                    const vis = c.image_override
                        ? el('img', { src: c.image_override, alt: c.label, loading: 'lazy' })
                        : el('span', {});
                    if (!c.image_override) {
                        vis.style.cssText = `display:inline-block;width:28px;height:28px;border-radius:50%;background:${c.colour_hex || '#ccc'};border:1px solid rgba(0,0,0,0.1);`;
                    } else {
                        vis.style.cssText = 'width:80px;height:80px;object-fit:cover;border-radius:6px;';
                    }
                    const cap = el('span', {}, c.label);
                    cap.style.cssText = 'font-size:0.85em;';
                    item.appendChild(vis);
                    item.appendChild(cap);
                    item.addEventListener('click', () => {
                        const label = `${parent.name_override || parent.handle} - ${c.label}`;
                        if (c.handle) {
                            // Swap pattern: the colour IS its own separate priced product
                            commitSelection(c.handle, null, label);
                        } else if (c.linked_handle) {
                            // Modifier pattern: base product + $0 colour add-on
                            commitSelection(parent.handle, c.linked_handle, label);
                        }
                    });
                    grid.appendChild(item);
                });

                dialogInner.appendChild(grid);
            }

            triggerBtn.addEventListener('click', () => {
                renderParentList();
                try {
                    if (typeof dialog.showModal === 'function') dialog.showModal();
                    else dialog.setAttribute('open', '');
                } catch (_) {}
            });

            wrap.appendChild(dialog);
            return wrap;
        }

        function renderSwatchTableText(step, idx) {
    const stepName = step.name || step.label || `Step ${idx + 1}`;
    const wrap = el("div", {
        "class": "atlas-cvp__step",
        "data-step-index": idx + 1,
        "data-step-type": "swatch-table-text",
        "data-step-name": stepName
    });

    if (step.label) {
        const head = el("div", { class: "atlas-cvp__step-head" }, [
            el("div", { class: "atlas-cvp__step-title" }, step.label),
            step.required
                ? el("span", { class: "atlas-cvp__req" }, "Required")
                : null
        ]);
        if (step.required) wrap.setAttribute("data-required", "true");
        wrap.appendChild(head);
        if (!step.required) {
            const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
            const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
            head.appendChild(skipBtn);
            head.appendChild(skipBtnMobile);
        }
    }
    const table = el("div", {
        "class": "atlas-cvp__table atlas-cvp__table--text",
        "role": "radiogroup",
        "aria-label": stepName
    });
    (step.options || []).forEach((opt, i) => {
        const handle = opt.handle;
        const optLabel = opt.name_override || '';
        const inputId = `cvp-tt-${root.dataset.uid}-${stepName.replace(/\s+/g, "-").toLowerCase()}-${i + 1}`;
        const row = el("div", { class: "atlas-cvp__table-row" });

        // Image on top, large (matches old theme's _500x swatch image)
        const useLarge = !!(step.large_table_images || opt.large_table_images);
        const imgWrap = imgForProduct(handle, useLarge ? 500 : 64);
        imgWrap.classList.add('atlas-cvp__table-thumb--stacked');
        imgWrap.style.cssText = 'display:block;width:100%;text-align:center;margin-bottom:8px;';
        row.appendChild(imgWrap);

        const label = el("label", {
            class: "atlas-cvp__table-main",
            for: inputId
        });
        label.style.cssText = 'display:block;text-align:center;';
        const inp = el("input", {
            "type": "radio",
            "class": "atlas-cvp__input js-cvp-text-toggle",
            "name": `cvp__${stepName.replace(/\s+/g, "-").toLowerCase()}`,
            "id": inputId,
            "value": optLabel,
            "data-handle": handle,
            "form": formId
        });
        // Attach price if known
        let pc = 0;
        if (handle && handlePrices[handle] != null) pc = parseInt(handlePrices[handle],10) || 0;
        else if (opt.name_override) {
          const m = opt.name_override.match(/\+\s*\$\s*(\d+(?:[\.,]\d{1,2})?)/i);
          if (m) pc = Math.round(parseFloat(m[1].replace(',', '.'))*100);
        }
        inp.setAttribute('data-price-cents', String(pc));
        if ((!pc || pc === 0) && handle) {
          inp.setAttribute('data-price-pending', '1');
          resolvePriceCentsViaAjax(handle);
        }
        if (step.required) inp.setAttribute("required", "");
        label.appendChild(inp);
        if (opt.name_override) {
            label.appendChild(
                el("span", { class: "atlas-cvp__table-title" }, opt.name_override)
            );
        }
        row.appendChild(label);
        if (opt.text_area_name) {
            const taId = `${inputId}-ta`;
            const wrapTA = el("div", {
                class: "atlas-cvp__textarea-wrap",
                style: "display:block"
            });
            const ta = el("textarea", {
                id: taId,
                class: "atlas-cvp__textarea",
                name: `cvp__text__${stepName.replace(/\s+/g, "-").toLowerCase()}`,
                placeholder: opt.text_area_name,
                form: formId
            });

            const maxWords = parseInt(opt.max_words || 0, 10) || 0;
            if (maxWords > 0) {
                ta.style.display = 'none';
                const wordBoxWrap = el('div', { class: 'atlas-cvp__word-boxes' });
                wordBoxWrap.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px;';
                const wordInputs = [];
                const syncTaFromWords = () => {
                    ta.value = wordInputs.map((w) => (w.value || '').trim()).filter(Boolean).join(' ');
                    ta.dispatchEvent(new Event('input', { bubbles: false }));
                };
                for (let w = 0; w < maxWords; w++) {
                    const wInput = el('input', {
                        type: 'text',
                        class: 'atlas-cvp__word-input',
                        placeholder: `Word ${w + 1}`
                    });
                    wInput.style.cssText = 'flex:1 1 0;min-width:0;padding:10px 8px;text-align:center;border-radius:8px;border:1px solid rgba(var(--color-foreground),0.2);background:rgb(var(--color-background));font-size:1em;';
                    wInput.addEventListener('input', () => {
                        if (/\s/.test(wInput.value)) {
                            wInput.value = wInput.value.replace(/\s+/g, '');
                            const next = wordInputs[w + 1];
                            if (next) next.focus();
                        }
                        syncTaFromWords();
                    });
                    wInput.addEventListener('keydown', (e) => {
                        if (e.key === ' ' || e.key === 'Enter') {
                            e.preventDefault();
                            const next = wordInputs[w + 1];
                            if (next) next.focus();
                        }
                    });
                    wordInputs.push(wInput);
                    wordBoxWrap.appendChild(wInput);
                }
                wrapTA.appendChild(wordBoxWrap);
            }

            wrapTA.appendChild(ta);
            row.appendChild(wrapTA);

            const applyBtn = el('button', {
                class: 'cvp-action',
                type: 'button',
                'data-action': 'apply'
            }, 'Apply');
            row.appendChild(applyBtn);
            // Keep Apply disabled when textarea is empty (robust)
            const updateApplyDisabled = () => {
              const empty = (ta.value || '').trim() === '';
              applyBtn.disabled = empty; ta.style.height = 'auto'; ta.style.height = ta.scrollHeight + 'px'; var __accC = ta.closest('.accordion-content'); if (__accC) { __accC.style.maxHeight = (__accC.scrollHeight + 120) + 'px'; }
              if (empty) applyBtn.classList.add('is-disabled'); else applyBtn.classList.remove('is-disabled');
              applyBtn.setAttribute('aria-disabled', empty ? 'true' : 'false');
            };
            ['input','change','keyup','blur'].forEach(ev => ta.addEventListener(ev, updateApplyDisabled));
            // Initialize disabled state
            updateApplyDisabled();
            // Guard Apply click
            applyBtn.addEventListener('click', (e) => {
              if ((ta.value || '').trim() === '') {
                e.preventDefault();
                e.stopPropagation();
                updateApplyDisabled();
                try { ta.focus(); } catch(_) {}
                return false;
              }
              return true;
            });
        }
        table.appendChild(row);
    });
    wrap.appendChild(table);
    return wrap;
}

        function renderMultiQty(step, idx) {
            const stepName = step.name || step.label || `Step ${idx + 1}`;
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "swatch-multi-qty",
                "data-step-name": stepName
            });

            if (step.label) {
                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label),
                    step.required
                        ? el("span", { class: "atlas-cvp__req" }, "Required")
                        : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);
                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }
            }

            const totalQty = step.total_quantity || 0;
            const isMenu = /menu/i.test(String(step.label || step.name || ''));
            const showCap = totalQty > 0 && !isMenu;
            const cap = showCap ? el("div", { class: "atlas-cvp__multiqty-cap" }, [
                `Select ${totalQty} items for your pack. `,
                el("span", { class: "js-cvp-message" }, `Please add another ${totalQty} items.`)
            ]) : null;
            const grid = el("div", { class: "atlas-cvp__multiqty-grid" });
            (step.options || []).forEach((opt, i) => {
                const handle = opt.handle;
                const optLabel =
                    opt.name_override || handle || `Option ${i + 1}`;
                const qtyId = `cvp-qty-${root.dataset.uid}-${stepName.replace(/\s+/g, "-").toLowerCase()}-${i + 1}`;
                const item = el("div", { class: "atlas-cvp__multiqty-item" });
                const head = el("div", { class: "atlas-cvp__multiqty-head" }, [
                    imgForProduct(handle, 90),
                    el("div", { class: "atlas-cvp__multiqty-title" }, optLabel)
                ]);

                const ctrls = el("quantity-input", { class: "quantity cvp-quantity" });

                const dec = el("button", {
                  type: "button",
                  name: "minus",
                  class: "quantity__button cvp-btn js-cvp-dec",
                  "aria-controls": qtyId
                });
                dec.innerHTML = `
                  <span class="visually-hidden">Decrease quantity for ${optLabel}</span>
                  <span class="svg-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2">
                      <path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path>
                    </svg>
                  </span>
                `;

                const inp = el("input", {
                  id: qtyId,
                  class: "quantity__input cvp-qty-input",
                  type: "number",
                  inputmode: "numeric",
                  min: "0",
                  "data-min": "0",
                  step: "1",
                  value: "0",
                  "data-handle": handle,
                  "aria-label": `${optLabel} quantity`,
                  form: formId
                });
                let pc = 0;
                if (handle && handlePrices[handle] != null) pc = parseInt(handlePrices[handle],10) || 0;
                else if (opt.name_override) {
                  const m = opt.name_override.match(/\+\s*\$\s*(\d+(?:[\.,]\d{1,2})?)/i);
                  if (m) pc = Math.round(parseFloat(m[1].replace(',', '.'))*100);
                }
                inp.setAttribute('data-price-cents', String(pc));
                if ((!pc || pc === 0) && handle) {
                  inp.setAttribute('data-price-pending', '1');
                  resolvePriceCentsViaAjax(handle);
                }

                // Preselect tile on initial render if value > 0
                try {
                  const initialVal = Math.max(0, parseInt(inp.value || '0', 10) || 0);
                  if (initialVal > 0) {
                    const tile = inp.closest('.atlas-cvp__multiqty-item');
                    if (tile) tile.classList.add('selected');
                  }
                } catch(_) {}

                const inc = el("button", {
                  type: "button",
                  name: "plus",
                  class: "quantity__button cvp-btn js-cvp-inc",
                  "aria-controls": qtyId
                });
                inc.innerHTML = `
                  <span class="visually-hidden">Increase quantity for ${optLabel}</span>
                  <span class="svg-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
                      <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path>
                    </svg>
                  </span>
                `;

                ctrls.appendChild(dec);
                ctrls.appendChild(inp);
                ctrls.appendChild(inc);
                item.appendChild(head);
                item.appendChild(ctrls);

                try {
                  // Force min and data-min to 0 (Dawn's quantity-input may try to set them to 1)
                  inp.setAttribute('min', '0');
                  inp.setAttribute('data-min', '0');

                  const decBtn = ctrls.querySelector('.js-cvp-dec');
                  if (decBtn) {
                    const v = Math.max(0, parseInt(inp.value || '0', 10) || 0);
                    const minVal = (parseInt(inp.getAttribute('min') || '0', 10) || 0);
                    decBtn.classList.toggle('disabled', v <= minVal);
                  }

                  // Watch for any external changes to min/data-min and revert to 0
                  if (!inp._cvpMinObserver) {
                    const mo = new MutationObserver(() => {
                      if (inp.getAttribute('min') !== '0') inp.setAttribute('min', '0');
                      if (inp.getAttribute('data-min') !== '0') inp.setAttribute('data-min', '0');
                    });
                    mo.observe(inp, { attributes: true, attributeFilter: ['min', 'data-min'] });
                    inp._cvpMinObserver = mo;
                  }
                } catch(_) {}
                grid.appendChild(item);
            });
            const box = el("div", {
                "class": "atlas-cvp__multiqty",
                "data-total": String(step.total_quantity || 0)
            });
            if (cap) box.appendChild(cap);
            box.appendChild(grid);
            if (step.required)
                box.appendChild(
                    el("input", {
                        type: "hidden",
                        class: "cvp-multiqty-required",
                        value: "1",
                        form: formId
                    })
                );
            wrap.appendChild(box);
            return wrap;
        }

        function renderUpsell(step, idx) {
            const stepName = step.name || step.label || `Step ${idx + 1}`;
            const wrap = el("div", {
                "class": "atlas-cvp__step",
                "data-step-index": idx + 1,
                "data-step-type": "upsell-links",
                "data-step-name": stepName
            });
            if (step.label)
                wrap.appendChild(
                    el("div", { class: "atlas-cvp__step-head" }, [
                        el(
                            "div",
                            { class: "atlas-cvp__step-title" },
                            step.label
                        )
                    ])
                );
            const grid = el("div", { class: "atlas-cvp__upsell" });
            (step.options || []).forEach((card) => {
                const a = el("a", {
                    class: "atlas-cvp__upsell-card",
                    href: card.link
                });
                if (card.image)
                    a.appendChild(
                        el("img", { loading: "lazy", src: card.image, alt: "" })
                    );
                const meta = el("div", { class: "atlas-cvp__upsell-meta" }, [
                    el(
                        "div",
                        { class: "atlas-cvp__upsell-title" },
                        card.name || ""
                    ),
                    card.description
                        ? el(
                              "div",
                              { class: "atlas-cvp__upsell-desc" },
                              card.description
                          )
                        : null
                ]);
                a.appendChild(meta);
                grid.appendChild(a);
            });
            wrap.appendChild(grid);
            return wrap;
        }

        function refreshActionStates() {
            root.querySelectorAll('.atlas-cvp__table-row').forEach(row => {
                const radio = row.querySelector('input[type="radio"]');
                let btn = row.querySelector('.cvp-action');
                if (!btn) {
                    btn = el('button', { class: 'cvp-action', type: 'button' }, 'Select');
                    row.appendChild(btn);
                }
                const isTextStepRow = !!row.querySelector('input[type="radio"].js-cvp-text-toggle');
                const isChecked = !!(radio && radio.checked);

                if (isChecked) {
                    btn.classList.add('selected');
                    btn.textContent = isTextStepRow ? 'Applied' : 'Selected';
                } else {
                    btn.classList.remove('selected');
                    btn.textContent = isTextStepRow ? 'Apply' : 'Select';
                }
            });
        }

                function autoPreselectSingleOptionSteps() {
          root.querySelectorAll('.atlas-cvp__step[data-required="true"]').forEach((stepEl) => {
            const type = (stepEl.dataset.stepType || '').toLowerCase();
            if (!['swatch-single', 'swatch-table'].includes(type)) return;
            const radios = stepEl.querySelectorAll('input[type="radio"]');
            if (radios.length !== 1) return;
            const radio = radios[0];
            if (!radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
            const item = stepEl.closest('.accordion-item');
            if (item && !stepEl.dataset.cvpAutoOpened) {
              stepEl.dataset.cvpAutoOpened = '1';
              if (!item.classList.contains('open')) _cvpSetAccordionOpenState(item, true);
            }
          });
        }

        function autoPreselectFirstRequired() {
          try { autoPreselectSingleOptionSteps(); } catch (_) {}
          const firstReq = root.querySelector('.atlas-cvp__step[data-required="true"]');
          if (!firstReq) return;

          const type = (firstReq.dataset.stepType || '').toLowerCase();
          if ([
            'swatch-multi-qty',
            'swatch-conditional-qty',
            'atlas-cvp__multiqty',
            'atlas-cvp__multiqty-grid'
          ].includes(type)) return;

          if (!['swatch-single','swatch-table','swatch-table-text'].includes(type)) return;

          const firstRadio = firstReq.querySelector('input[type="radio"]');
          if (!firstRadio) return;

          const alreadyChecked = firstRadio.checked;
          firstRadio.checked = true;
          if (!alreadyChecked) {
            firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (firstRadio.classList.contains('js-cvp-text-toggle')) {
            const row = firstRadio.closest('.atlas-cvp__table-row');
            const ta = row && row.querySelector('.atlas-cvp__textarea');
            const taWrap = row && row.querySelector('.atlas-cvp__textarea-wrap');
            if (ta) ta.disabled = false;
            if (taWrap) taWrap.style.display = 'block';
          }
        }

        function clearStepSelections(stepEl) {
          if (!stepEl) return;

          stepEl.querySelectorAll('input[type="radio"]').forEach(inp => { inp.checked = false; });

          stepEl.querySelectorAll('.atlas-cvp__textarea').forEach(ta => {
              ta.value = '';
          });

          // Clear any file inputs and reset filename label (not placeholder)
          stepEl.querySelectorAll('input[type="file"]').forEach(fi => {
            try {
              fi.value = '';
              fi.removeAttribute('data-has-file');
            } catch(_) {}
          });
          try {
            const fileLabelEl = stepEl.querySelector('.atlas-cvp__file-label');
            const fileNameEl = stepEl.querySelector('.atlas-cvp__file-name');
            if (fileNameEl) fileNameEl.textContent = '';
            if (fileLabelEl) fileLabelEl.remove();
          } catch(_) {}
          // Also drop any hidden properties generated for this step (safety net)
          try {
            const stepName = stepEl.dataset.stepName || '';
            if (propsHolder && stepName) {
              propsHolder.querySelectorAll('[data-step-name]').forEach(el => {
                if (el.dataset.stepName === stepName) el.remove();
              });
            }
          } catch(_) {}

          stepEl.querySelectorAll('.cvp-qty-input').forEach(inp => { inp.value = '0'; });
          const mq = stepEl.querySelector('.atlas-cvp__multiqty');
          if (mq) updateMultiQtyUI(mq);

          stepEl.querySelectorAll('.cvp-action').forEach(btn => {
            btn.classList.remove('selected');
            const row = btn.closest('.atlas-cvp__table-row');
            const isTextRow = !!(row && row.querySelector('input[type="radio"].js-cvp-text-toggle'));
            btn.textContent = isTextRow ? 'Apply' : 'Select';
          });

          stepEl.querySelectorAll('.atlas-cvp__multiqty-item.selected').forEach(tile => {
            tile.classList.remove('selected');
          });
          recomputeSelections();
          try { recomputeTotal(); } catch(_) {}
        }

        function setStepSkipped(stepEl, skipped) {
          if (!stepEl) return;
          const isRequired = stepEl.dataset.required === 'true';
          if (isRequired) return;

          const accItem = stepEl.closest('.accordion-item');

          const applySkipStateToButtons = (skippedFlag) => {
            const allButtons = [];

            // Buttons inside the step (if any)
            stepEl.querySelectorAll('.atlas-cvp__skip').forEach((b) => {
              allButtons.push(b);
            });

            // Buttons in the accordion header for this step
            if (accItem) {
              accItem.querySelectorAll('.accordion-header .atlas-cvp__skip').forEach((b) => {
                if (!allButtons.includes(b)) allButtons.push(b);
              });
            }

            allButtons.forEach((b) => {
              const isMobile = b.classList.contains('atlas-cvp__skip--mobile');
              if (skippedFlag) {
                b.textContent = isMobile ? 'Skipped' : 'Step skipped';
                b.setAttribute('data-state', 'skipped');
              } else {
                b.textContent = isMobile ? 'Skip' : 'Skip this step';
                b.removeAttribute('data-state');
              }
            });
          };

          if (skipped) {
            // Mark step and accordion item as skipped
            stepEl.setAttribute('data-skipped', 'true');
            if (accItem) accItem.setAttribute('data-skipped', '');

            // Clear selections inside this step only
            clearStepSelections(stepEl);

            // Remove all skipped handles from handleVariants for this step
            try {
              stepEl.querySelectorAll('[data-handle]').forEach(el => {
                const h = el.getAttribute('data-handle');
                if (h && handleVariants[h]) delete handleVariants[h];
              });
            } catch(_) {}

            // Disable form controls inside skipped step
            try {
              stepEl.querySelectorAll('input, textarea, select').forEach(el => {
                el.disabled = true;
              });
            } catch(_) {}

            // Remove this step's properties from the propsHolder to prevent skipped selections from being submitted
            if (propsHolder) {
              try {
                const stepName = stepEl.dataset.stepName || '';
                propsHolder.querySelectorAll('[data-step-name]').forEach(el => {
                  if (el.dataset.stepName === stepName) el.remove();
                });
              } catch(_) {}
            }

            applySkipStateToButtons(true);
          } else {
            // Unskip: remove skipped markers
            stepEl.removeAttribute('data-skipped');
            if (accItem) accItem.removeAttribute('data-skipped');

            // Re-enable form controls so user can interact again
            try {
              stepEl.querySelectorAll('input, textarea, select').forEach(el => {
                el.disabled = false;
              });
            } catch(_) {}

            applySkipStateToButtons(false);
          }

          try { updateAccordionHeaderDisplay(); } catch(_) {}
          try { syncAtcDisabled(); } catch(_) {}
        }

        function updateMultiQtyUI(container) {
          try {
            const box = container.closest ? (container.closest('.atlas-cvp__multiqty') || container) : container;
            if (!box) return;
            const target = Math.max(0, parseInt(box.dataset.total || '0', 10) || 0);
            let selected = 0;
            box.querySelectorAll('.cvp-qty-input').forEach((inp) => {
              const q = Math.max(0, parseInt(inp.value || '0', 10) || 0);
              selected += q;
              const tile = inp.closest('.atlas-cvp__multiqty-item');
              if (tile) {
                if (q > 0) tile.classList.add('selected');
                else tile.classList.remove('selected');
              }
            });
            const selNode = box.querySelector('.js-cvp-selected');
            if (selNode) selNode.textContent = String(selected);
              const msg = box.querySelector('.js-cvp-message');
              if (msg) {
                  if (target > 0) {
                      const remaining = Math.max(0, target - selected);
                      msg.textContent = remaining > 0
                          ? `Please add another ${remaining} items.`
                                                    : `All ${target} items selected.`;
                      msg.classList.toggle('invalid', remaining > 0);
                      msg.classList.toggle('complete', remaining === 0);
                  } else {
                      msg.textContent = '';
                  }
              }
          } catch(_) {}
        }

        // Auto-unskip a skipped optional step on first user interaction
        root.addEventListener('pointerdown', (ev) => {
          try {
            const step = ev.target && ev.target.closest && ev.target.closest('.atlas-cvp__step');
            if (!step) return;
            if (step.dataset.required === 'true') return;
            if (step.getAttribute('data-skipped') !== 'true') return;
            // Do not toggle when clicking the Skip buttons themselves
            if (ev.target.closest('.atlas-cvp__skip')) return;
            setStepSkipped(step, false);
            try { injectSkipButtonsIntoHeaders(); } catch(_) {}
            try { updateAccordionHeaderDisplay(); } catch(_) {}
          } catch(_) {}
        }, true);

        // Also auto-unskip when a control inside a skipped step receives focus (keyboard users)
        root.addEventListener('focusin', (ev) => {
          try {
            const step = ev.target && ev.target.closest && ev.target.closest('.atlas-cvp__step');
            if (!step) return;
            if (step.dataset.required === 'true') return;
            if (step.getAttribute('data-skipped') !== 'true') return;
            if (ev.target.closest('.atlas-cvp__skip')) return;
            setStepSkipped(step, false);
            try { injectSkipButtonsIntoHeaders(); } catch(_) {}
            try { updateAccordionHeaderDisplay(); } catch(_) {}
          } catch(_) {}
        }, true);

        root.addEventListener('click', (ev) => {
          const tile = ev.target && ev.target.closest && ev.target.closest('.atlas-cvp__multiqty-item');
          if (!tile || !root.contains(tile)) return;

          if (ev.target.closest('.cvp-btn') || ev.target.closest('.cvp-qty-input') || ev.target.closest('button') || ev.target.closest('label')) {
            return;
          }

          const input = tile.querySelector('.cvp-qty-input');
          if (!input) return;

          const box = tile.closest('.atlas-cvp__multiqty');
          let val = Math.max(0, parseInt(input.value || '0', 10) || 0);

            const target = Math.max(0, parseInt(box.dataset.total || '0', 10) || 0);
            const current = Array.from(box.querySelectorAll('.cvp-qty-input'))
                .reduce((sum, i) => sum + Math.max(0, parseInt(i.value || '0', 10)), 0);

            if (val > 0) {
                val = 0;
                tile.classList.remove('selected');
            } else {

                if (target && current >= target) {
                    return;
                }
                val = 1;
                tile.classList.add('selected');
            }

          input.value = String(val);
          input.dispatchEvent(new Event('change', { bubbles: true }));

          // keep the helper UI, header, total, and ATC state in sync
          if (box) updateMultiQtyUI(box);
          try { recomputeSelections(); } catch(_) {}
          try { recomputeTotal(); } catch(_) {}
          try { updateAccordionHeaderDisplay(); } catch(_) {}
          try { syncAtcDisabled(); } catch(_) {}
          try { saveQtyState(); } catch(_) {}
        }, true);

        // Keep tile selected class synced when qty inputs change (typing or +/-)
        root.addEventListener('change', (ev) => {
          const inp = ev.target && ev.target.classList && ev.target.classList.contains('cvp-qty-input') ? ev.target : null;
          if (!inp) return;
          const box = inp.closest('.atlas-cvp__multiqty');
          // Enforce per-box total cap on change
          if (box) {
            const target = Math.max(0, parseInt(box.dataset.total || '0', 10) || 0);
            if (target) {
              const othersSum = Array.from(box.querySelectorAll('.cvp-qty-input'))
                .filter(i => i !== inp)
                .reduce((s, i) => s + Math.max(0, parseInt(i.value || '0', 10) || 0), 0);
              const maxForThis = Math.max(0, target - othersSum);
              let q = Math.max(0, parseInt(inp.value || '0', 10) || 0);
              if (q > maxForThis) {
                q = maxForThis;
                inp.value = String(q);
              }
            }
          }
          if (box) updateMultiQtyUI(box);
          try { saveQtyState(); } catch(_) {}
        }, true);
        // Keep "selected" class synced on live typing in qty inputs
        root.addEventListener('input', (ev) => {
          const inp = ev.target;
          if (!inp || !inp.classList || !inp.classList.contains('cvp-qty-input')) return;

          const value = Math.max(0, parseInt(inp.value || '0', 10));
          const item = inp.closest('.atlas-cvp__multiqty-item');
          if (item) item.classList.toggle('selected', value > 0);

          const box = inp.closest('.atlas-cvp__multiqty');
          // Enforce per-box total cap on input (live typing / +/-)
          if (box) {
            const target = Math.max(0, parseInt(box.dataset.total || '0', 10) || 0);
            if (target) {
              const othersSum = Array.from(box.querySelectorAll('.cvp-qty-input'))
                .filter(i => i !== inp)
                .reduce((s, i) => s + Math.max(0, parseInt(i.value || '0', 10) || 0), 0);
              const maxForThis = Math.max(0, target - othersSum);
              let q = Math.max(0, parseInt(inp.value || '0', 10) || 0);
              if (q > maxForThis) {
                q = maxForThis;
                inp.value = String(q);
              }
            }
          }
          if (box) {
            try { updateMultiQtyUI(box); } catch(_) {}
            try { recomputeSelections(); } catch(_) {}
            try { recomputeTotal(); } catch(_) {}
            try { syncAtcDisabled(); } catch(_) {}
          }
          try { saveQtyState(); } catch(_) {}
        }, true);
        // Hide 'Choose file' label when file selected and show filename instead
        root.addEventListener('change', (ev) => {
          const input = ev.target;
          if (!input || input.type !== 'file') return;
          const step = input.closest('.atlas-cvp__step');
          if (!step) return;
          const fileLabel = step.querySelector('.atlas-cvp__file-label');
          const fileNameEl = step.querySelector('.atlas-cvp__file-name');
          if (input.files && input.files.length > 0) {
            const name = input.files[0].name;
            if (fileNameEl) fileNameEl.textContent = name;
          } else {
            if (fileNameEl) fileNameEl.textContent = '';
          }
        });

        // Helper: render step badge either as number or as checkmark SVG
        function setBadgeState(badgeEl, index, done) {
          if (!badgeEl) return;
          badgeEl.setAttribute('data-index', String(index || 1));
          badgeEl.setAttribute('data-done', done ? 'true' : 'false');

          // Clear previous content to avoid mixing text and SVG
          while (badgeEl.firstChild) badgeEl.removeChild(badgeEl.firstChild);

          if (done) {

            const svgNS = 'http://www.w3.org/2000/svg';
            const svg = document.createElementNS(svgNS, 'svg');
            svg.setAttribute('width', '12');
            svg.setAttribute('height', '13');
            svg.setAttribute('viewBox', '0 0 12 13');
            svg.setAttribute('aria-hidden', 'true');
            const path = document.createElementNS(svgNS, 'path');
            path.setAttribute('d', 'M4.77578 9.9021L1.92578 7.0521L2.63828 6.3396L4.77578 8.4771L9.36328 3.8896L10.0758 4.6021L4.77578 9.9021Z');
            path.setAttribute('fill', 'white');
            svg.appendChild(path);
            badgeEl.appendChild(svg);
          } else {
            const num = (typeof formatStepNum === 'function')
              ? formatStepNum(index || 1)
              : String(index || 1).padStart(2, '0');
            badgeEl.textContent = `${num}.`;
          }
        }

        function updateAccordionHeaderDisplay() {
          root.querySelectorAll('.accordion-item').forEach(item => {
            const step = item.querySelector('.atlas-cvp__step');
            const header = item.querySelector('.accordion-selected-value');
            if (!step || !header) return;
            const type = (step.dataset.stepType || '').toLowerCase();
            {
              let _total = 0, _selected = 0;
              if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
                const _mqAll = step.querySelectorAll('.atlas-cvp__multiqty-item');
                _total = _mqAll.length;
                _mqAll.forEach(tile => {
                  const inp = tile.querySelector('.cvp-qty-input');
                  if (inp && parseInt(inp.value || '0', 10) > 0) _selected++;
                });
              } else if (['swatch-single','swatch-table','swatch-table-text'].includes(type)) {
                _total = step.querySelectorAll('input[type="radio"]').length;
                _selected = step.querySelectorAll('input[type="radio"]:checked').length;
              } else if (type === 'dropdown') {
                _total = step.querySelectorAll('.atlas-cvp__dropdown-select option[value]:not([value=""])').length;
                const sel = step.querySelector('.atlas-cvp__dropdown-select');
                _selected = (sel && sel.value) ? 1 : 0;
              }
              header.dataset.items = _total;
              header.dataset.itemsSelected = _selected;
            }
            let value = '';
            if (['swatch-single','swatch-table','swatch-table-text'].includes(type)) {
              const checked = step.querySelector('input[type="radio"]:checked');
              if (checked) value = checked.value;
            } else if (type === 'dropdown') {
              const sel = step.querySelector('.atlas-cvp__dropdown-select');
              if (sel) {
                const rawVal = (sel.value || '').trim();
                const txt = (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].text || '').trim();
                const isPlaceholder = !rawVal || /^please\s+choose$/i.test(txt);
                if (!isPlaceholder) value = txt;
              }
            } else if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
              let lines = [];
              step.querySelectorAll('.cvp-qty-input').forEach(inp => {
                const q = Math.max(0, parseInt(inp.value || '0', 10));
                if (!q) return;
                const item = inp.closest('.atlas-cvp__multiqty-item');
                const titleEl = item && item.querySelector('.atlas-cvp__multiqty-title');
                const label = (titleEl && titleEl.textContent ? titleEl.textContent.trim() : inp.getAttribute('data-handle') || '').trim();
                if (label) lines.push(`${q}x ${label}`);
              });
              if (lines.length) value = lines.join(', <br>');
            } else if (type === 'file') {
                const fi = step.querySelector('input[type="file"]');
                const f = fi && fi.files && fi.files[0];
                if (f) value = f.name;
            }

            const skipped = step.getAttribute('data-skipped') === 'true';
            const skipBtn = item.querySelector('.accordion-header .atlas-cvp__skip');
            if (skipBtn) {
              if (skipped) {
                skipBtn.textContent = 'Step skipped';
                skipBtn.setAttribute('data-state', 'skipped');
              } else {
                skipBtn.textContent = 'Skip this step';
                skipBtn.removeAttribute('data-state');
              }
            }
            header.innerHTML = skipped ? '' : (value ? `${value}` : '');
            item.toggleAttribute('data-skipped', skipped);
                        const hasCheckedRadio = !!step.querySelector('input[type="radio"]:checked');
            if (!skipped && (value || hasCheckedRadio)) item.classList.add('selected'); else item.classList.remove('selected');

            // Toggle colon after (Optional) only when a selection is made
            try {
              const optEl = item.querySelector('.accordion-title span');
              if (optEl) {
                const hasVal = !!(value && !skipped);
                optEl.textContent = hasVal ? '(Optional):' : '(Optional)';
              }
            } catch(_) {}

            // Update badge state: done only when there is a non-skipped selection
            const badge = item.querySelector('.accordion-step-badge');
            if (badge) {
              const idx = parseInt(badge.getAttribute('data-index') || '1', 10) || 1;
                            const done = !!(!skipped && (value || hasCheckedRadio));
              setBadgeState(badge, idx, done);
            }

          });
        }

        function injectSkipButtonsIntoHeaders() {
          let idx = 0;
          root.querySelectorAll('.accordion-item').forEach(item => {
            const step = item.querySelector('.atlas-cvp__step');
            if (!step) return;
            idx += 1;

            const header = item.querySelector('.accordion-header');
            if (!header) return;

            let badge = header.querySelector('.accordion-step-badge');
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'accordion-step-badge';
              header.insertBefore(badge, header.firstChild || null);
            }
            setBadgeState(badge, idx, false);

            let selectedSpan = header.querySelector('.accordion-selected-value');
            if (!selectedSpan) {
              selectedSpan = document.createElement('span');
              selectedSpan.className = 'accordion-selected-value';
              header.appendChild(selectedSpan);
            }

            let editSpan = header.querySelector('.accordion-edit-label');
            if (!editSpan) {
              editSpan = document.createElement('span');
              editSpan.className = 'accordion-edit-label';
              editSpan.textContent = 'Edit Selection';
              header.appendChild(editSpan);
            }

              const isRequired = step.dataset.required === 'true';
              let skipBtn = header.querySelector('.atlas-cvp__skip:not(.atlas-cvp__skip--mobile)');
              let skipBtnMobile = header.querySelector('.atlas-cvp__skip.atlas-cvp__skip--mobile');

              if (!isRequired) {
                  if (!skipBtn) {
                      skipBtn = document.createElement('button');
                      skipBtn.type = 'button';
                      skipBtn.className = 'atlas-cvp__skip';
                      header.appendChild(skipBtn);
                  }
                  if (!skipBtnMobile) {
                      skipBtnMobile = document.createElement('button');
                      skipBtnMobile.type = 'button';
                      skipBtnMobile.className = 'atlas-cvp__skip atlas-cvp__skip--mobile';
                      header.appendChild(skipBtnMobile);
                  }
                  const skipped = step.getAttribute('data-skipped') === 'true';
                  skipBtn.textContent = skipped ? 'Step skipped' : 'Skip this step';
                  skipBtnMobile.textContent = skipped ? 'Skipped' : 'Skip';
                  if (skipped) {
                      skipBtn.setAttribute('data-state', 'skipped');
                      skipBtnMobile.setAttribute('data-state', 'skipped');
                  } else {
                      skipBtn.removeAttribute('data-state');
                      skipBtnMobile.removeAttribute('data-state');
                  }
              } else {
                  if (skipBtn) skipBtn.remove();
                  if (skipBtnMobile) skipBtnMobile.remove();
              }
          });
          try { syncAccordionItemRequiredClasses(); } catch(_) {}
        }

        function syncAccordionItemRequiredClasses() {
          try {
            root.querySelectorAll('.accordion-item').forEach((item) => {
              const step = item.querySelector('.atlas-cvp__step');
              if (!step) return;
              const req = step.getAttribute('data-required') === 'true' || step.dataset.required === 'true';
              item.classList.toggle('required', !!req);
              item.classList.toggle('optional', !req);
            });
          } catch(_) {}
        }

root.addEventListener('click', (ev) => {
    const btn = ev.target && ev.target.closest && ev.target.closest('.atlas-cvp__skip');
    if (!btn) return;


    // Prevent the Skip click from toggling the accordion open/closed
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();

    let item = btn.closest('.accordion-item');
    let step = item && item.querySelector('.atlas-cvp__step');
    if (!step && item) step = item.querySelector('.atlas-cvp__step');
    if (!step) {
      return;
    }

    const isRequired = step.dataset.required === 'true';
    if (isRequired) {
      return;
    }

    const wasSkipped = step.getAttribute('data-skipped') === 'true';

    // If the step is already marked as skipped, clicking Skip again does NOT unskip it.
    // Unskip only happens on real user interaction with the step (pointerdown/focusin/change),
    // which is already handled by other event listeners below.
    if (wasSkipped) {
      return;
    }

    // Explicitly mark the step as SKIPPED
    setStepSkipped(step, true);

    // Safety refresh for header display, total price, and ATC state
    try { injectSkipButtonsIntoHeaders(); } catch (_) {}
    try { updateAccordionHeaderDisplay(); } catch (_) {}
    try { recomputeSelections(); } catch (_) {}
    try { recomputeTotal(); } catch (_) {}
    try { syncAtcDisabled(); } catch (_) {}

    // After skipping, open the next accordion step
    if (!item) item = step.closest('.accordion-item');
    if (item) {
      try { _cvpAdvanceToNextAccordion(item); } catch (_) {}
    }
}, true);

        root.addEventListener('click', (ev) => {
            const btn = ev.target && ev.target.closest && ev.target.closest('.cvp-action[data-action="apply"]');
            if (!btn) return;
            ev.preventDefault();
            ev.stopPropagation();

            const row = btn.closest('.atlas-cvp__table-row');
            if (!row) return;
            const radio = row.querySelector('input[type="radio"].js-cvp-text-toggle');
            if (!radio) return;

            const step = row.closest('.atlas-cvp__step');
            const required = step && step.dataset.required === 'true';

            if ((btn.classList.contains('selected') || radio.checked) && !required) {
                radio.checked = false;
                const ta = row.querySelector('.atlas-cvp__textarea');
                if (ta) ta.value = '';
                btn.classList.remove('selected');
                btn.textContent = 'Apply';

                radio.dispatchEvent(new Event('change', { bubbles: true }));
                try { recomputeSelections(); } catch(_) {}
                try { recomputeTotal(); } catch(_) {}
                try { updateAccordionHeaderDisplay(); } catch(_) {}
                try { syncAtcDisabled(); } catch(_) {}
                return;
            }

            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            btn.classList.add('selected');
            btn.textContent = 'Applied';

            const taWrap = row.querySelector('.atlas-cvp__textarea-wrap');
            const ta = taWrap && taWrap.querySelector('.atlas-cvp__textarea');
            if (taWrap && ta) { taWrap.style.display = 'block'; ta.disabled = false; }

            try { recomputeSelections(); } catch(_) {}
            try { recomputeTotal(); } catch(_) {}
            try { updateAccordionHeaderDisplay(); } catch(_) {}
            try { syncAtcDisabled(); } catch(_) {}
        }, true);

        root.addEventListener('change', (ev) => {

          const step = ev.target && ev.target.closest && ev.target.closest('.atlas-cvp__step');
          if (step && step.dataset.required !== 'true' && step.getAttribute('data-skipped') === 'true') {
            setStepSkipped(step, false);
            injectSkipButtonsIntoHeaders();
          }
          updateAccordionHeaderDisplay();
        });

        function _cvpSetMaxHeight(panel) {
          if (!panel) return;
          try {
            const item = panel.closest('.accordion-item');
            const isOpen = !!(item && item.classList && item.classList.contains('open'));

            // If the accordion item is closed, remove inline max-height so the component can collapse.
            if (!isOpen) {
              try {
                panel.style.removeProperty('max-height');
              } catch(_) {
                panel.style.maxHeight = null;
              }
              panel._cvpPrevH = null;
              return;
            }

            // When open, measure and set max-height to the content's full height.
            panel.style.maxHeight = 'none';
            const h = panel.scrollHeight;
            if (h && h !== panel._cvpPrevH) {
              panel.style.maxHeight = h + 'px';
              panel._cvpPrevH = h;
            } else if (h) {
              panel.style.maxHeight = h + 'px';
            }
          } catch(_) {}
        }

        function _cvpAutoSize(panel) {
          if (!panel) return;

          if (panel._cvpAutoBound) {
            try { _cvpSetMaxHeight(panel); } catch(_) {}
            return;
          }
          panel._cvpAutoBound = true;

          // Debounced scheduler (rAF) to avoid tight resize/mutation loops
          let rafId = null;
          const schedule = () => {
            if (rafId != null) return;
            rafId = requestAnimationFrame(() => {
              rafId = null;
              _cvpSetMaxHeight(panel);
            });
          };

          // Watch the closest accordion item for open/close (class changes) and reschedule
          const accItem = panel.closest('.accordion-item');
          if (accItem && !panel._cvpItemMO) {
            try {
              const moItem = new MutationObserver(() => schedule());
              moItem.observe(accItem, { attributes: true, attributeFilter: ['class'] });
              panel._cvpItemMO = moItem;
            } catch(_) {}
          }

          // Initial passes to catch late layout
          schedule();
          setTimeout(schedule, 50);
          setTimeout(schedule, 200);
          setTimeout(schedule, 600);

          panel.querySelectorAll('img').forEach(img => {
            if (img.complete) return;
            img.addEventListener('load', schedule, { once: true });
            img.addEventListener('error', schedule, { once: true });
          });

          try {
            const mo = new MutationObserver(() => schedule());
            mo.observe(panel, { childList: true, subtree: true });
            panel._cvpMO = mo;
          } catch(_) {}

          // Track size changes via ResizeObserver — also debounced
          if (typeof ResizeObserver !== 'undefined') {
            try {
              const ro = new ResizeObserver(() => schedule());
              ro.observe(panel);
              panel._cvpRO = ro;
            } catch(_) {}
          }

          // After document fonts are ready and window load
          if (document.fonts && typeof document.fonts.ready?.then === 'function') {
            document.fonts.ready.then(schedule).catch(() => {});
          }
          if (!panel._cvpLoadHook) {
            panel._cvpLoadHook = true;
            window.addEventListener('load', schedule, { once: true });
          }
        }

        // Helper to programmatically open the first accordion item (idempotent)
        function openFirstAccordionOnce() {
          const acc = root.querySelector('custom-accordion[data-cvp-accordion]') || root.querySelector('custom-accordion');
          if (!acc) return false;

          const firstItem = acc.querySelector('.accordion-item');
          if (!firstItem) return false;

          const header = firstItem.querySelector('.accordion-header');
          const content = firstItem.querySelector('.accordion-content');
          const firstStep = firstItem.querySelector('.atlas-cvp__step');

          // If the first step is a multi-qty grid, ensure no preselection before opening
          const grid = firstStep && firstStep.querySelector('.atlas-cvp__multiqty');
          if (grid) {
            try {
              // Do NOT reset existing quantities here. Only sync helper UI
              // with whatever values are currently in the DOM.
              updateMultiQtyUI(grid);
            } catch(_) {}
          }

          // Already open? just ensure autosize bound
          if (firstItem.classList.contains('open')) {
            if (content && !content._cvpAutoBound) _cvpAutoSize(content);
            return true;
          }

          // If custom element controls behavior, wait until it is defined
          const whenDefined = (window.customElements && typeof customElements.whenDefined === 'function')
            ? customElements.whenDefined('custom-accordion').catch(() => {})
            : Promise.resolve();

          whenDefined.then(() => {
            if (header && !firstItem.classList.contains('open')) {
              header.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
            if (content && !content._cvpAutoBound) _cvpAutoSize(content);
          });

          return true;
        }

        // Robust auto-open for the first accordion item
        (function initAutoOpen() {
          let opened = false;
          const tryOpen = () => {
            if (opened) return true;
            opened = !!openFirstAccordionOnce();
            return opened;
          };

          // Fast attempts
          try { tryOpen(); } catch(_) {}
          requestAnimationFrame(() => { try { tryOpen(); } catch(_) {} });
          setTimeout(() => { try { tryOpen(); } catch(_) {} }, 120);
          setTimeout(() => { try { tryOpen(); } catch(_) {} }, 300);

          // After DOM is ready and on load
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => { try { tryOpen(); } catch(_) {} }, { once: true });
          } else {
            setTimeout(() => { try { tryOpen(); } catch(_) {} }, 0);
          }
          window.addEventListener('load', () => { try { tryOpen(); } catch(_) {} }, { once: true });

          // Retry loop with cap (e.g., up to ~2s)
          let attempts = 0;
          const maxAttempts = 20;
          const iv = setInterval(() => {
            if (opened || attempts++ >= maxAttempts) { clearInterval(iv); return; }
            try { tryOpen(); } catch(_) {}
          }, 100);

          // Observe the mount area and the root for late insertion of accordion/items
          try {
            const mountNode = root.querySelector('[data-cvp-steps-mount]') || root;
            const mo = new MutationObserver(() => {
              if (opened) { try { mo.disconnect(); } catch(_) {} return; }
              try { if (tryOpen()) mo.disconnect(); } catch(_) {}
            });
            mo.observe(mountNode, { childList: true, subtree: true });
          } catch(_) {}
        })();

        // Ensure first required (non multi-qty) step gets preselected after UI settles
        (function runAutoPreselect() {
          const tryRun = () => { try { autoPreselectFirstRequired(); } catch(_) {} };
          tryRun();
          requestAnimationFrame(tryRun);
          setTimeout(tryRun, 120);
          setTimeout(tryRun, 300);
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', tryRun, { once: true });
          } else {
            setTimeout(tryRun, 0);
          }
          window.addEventListener('load', tryRun, { once: true });
        })();

        // Restore any persisted quantities after initial UI setup
        try { loadQtyState(); } catch(_) {}

        // Only build client-side if Liquid didn't render any steps
        if (mount && !root.querySelector(".atlas-cvp__step")) {
            const frag = document.createDocumentFragment();

            let accordionCurrent = null;
            let accordionIndex = 0;

            // Helper to normalize accordion label text (for consistent wording)
            function _cvpFixLabelText(t){
              return String(t||'').replace(/^Select your cake flavour\b/i,'Select cake flavour');
            }

            function makeAccordionItem(titleText, contentNode, index) {
              const accItem = document.createElement('div');
              const stepEl = contentNode.querySelector('.atlas-cvp__step');
              const isRequired = stepEl && stepEl.dataset.required === 'true';
              accItem.className = 'accordion-item ' + (isRequired ? 'required' : 'optional');

              const hdr = document.createElement('div');
              hdr.className = 'accordion-header';

              // Badge with number
              const badge = document.createElement('span');
              badge.className = 'accordion-step-badge';
              setBadgeState(badge, index || 1, false);
              hdr.appendChild(badge);

              const titleSpan = document.createElement('span');
              titleSpan.className = 'accordion-title';
              // Render (Optional) if present in title (updated logic)
              (function() {
                const cleanTitle = _cvpFixLabelText(titleText || '');
                const optMatch = /\(\s*optional\s*\)/i;
                const baseTitle = cleanTitle.replace(optMatch, '').trim();
                if (optMatch.test(cleanTitle)) {
                  titleSpan.innerHTML = `${baseTitle} <span>(Optional)</span>`;
                } else {
                  titleSpan.textContent = baseTitle;
                }
              })();
              hdr.appendChild(titleSpan);

              // Selected value
              const valSpan = document.createElement('span');
              valSpan.className = 'accordion-selected-value';
              hdr.appendChild(valSpan);

              // No longer append colon for optional labels; logic removed as per requirements
              // (MutationObserver and colon appending code removed)

              // Edit Selection (styling hook)
              const editSpan = document.createElement('span');
              editSpan.className = 'accordion-edit-label';
              editSpan.textContent = 'Edit Selection';
              hdr.appendChild(editSpan);

              // Skip buttons (desktop + mobile) for optional
              if (stepEl && !isRequired) {
                  const skippedNow = stepEl.getAttribute('data-skipped') === 'true';

                  const skipBtn = document.createElement('button');
                  skipBtn.className = 'atlas-cvp__skip';
                  skipBtn.type = 'button';
                  skipBtn.textContent = skippedNow ? 'Step skipped' : 'Skip this step';
                  hdr.appendChild(skipBtn);

                  const skipBtnMobile = document.createElement('button');
                  skipBtnMobile.className = 'atlas-cvp__skip atlas-cvp__skip--mobile';
                  skipBtnMobile.type = 'button';
                  skipBtnMobile.textContent = skippedNow ? 'Skipped' : 'Skip';
                  hdr.appendChild(skipBtnMobile);
              }

              const body = document.createElement('div');
              body.className = 'accordion-content';
              body.appendChild(contentNode);
              accItem.appendChild(hdr);
              accItem.appendChild(body);
              return accItem;
            }

            // === Swatch Conditional Qty ===
            function renderConditionalQty(step, idx) {
                const stepName = step.name || step.label || `Step ${idx + 1}`;
                const wrap = el("div", {
                    "class": "atlas-cvp__step",
                    "data-step-index": idx + 1,
                    "data-step-type": "swatch-conditional-qty",
                    "data-step-name": stepName
                });
                if (step.label) {
                    const head = el("div", { class: "atlas-cvp__step-head" }, [
                        el("div", { class: "atlas-cvp__step-title" }, step.label),
                        step.required
                            ? el("span", { class: "atlas-cvp__req" }, "Required")
                            : null
                    ]);
                    if (step.required) wrap.setAttribute("data-required", "true");
                    wrap.appendChild(head);
                    if (!step.required) {
                        const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                        const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                        head.appendChild(skipBtn);
                        head.appendChild(skipBtnMobile);
                    }
                }
                const totalQty = step.total_quantity || 0;
                const isMenu = /menu/i.test(String(step.label || step.name || ''));
                const showCap = totalQty > 0 && !isMenu;
                const cap = showCap ? el("div", { class: "atlas-cvp__multiqty-cap" }, [
                    `Select ${totalQty} items for your pack. `,
                    el("span", { class: "js-cvp-message" }, `Please add another ${totalQty} items.`)
                ]) : null;
                const grid = el("div", { class: "atlas-cvp__multiqty-grid" });
                (step.options || []).forEach((opt, i) => {
                    const handle = opt.handle;
                    const optLabel =
                        opt.name_override || handle || `Option ${i + 1}`;
                    const qtyId = `cvp-qty-${root.dataset.uid}-${stepName.replace(/\s+/g, "-").toLowerCase()}-${i + 1}`;
                    const item = el("div", { class: "atlas-cvp__multiqty-item" });
                    const head = el("div", { class: "atlas-cvp__multiqty-head" }, [
                        imgForProduct(handle, 90),
                        el("div", { class: "atlas-cvp__multiqty-title" }, optLabel)
                    ]);
                    // Begin new <quantity-input> controls
                    const ctrls = el("quantity-input", { class: "quantity cvp-quantity" });

                    const dec = el("button", {
                      type: "button",
                      name: "minus",
                      class: "quantity__button cvp-btn js-cvp-dec",
                      "aria-controls": qtyId
                    });
                    dec.innerHTML = `
                      <span class="visually-hidden">Decrease quantity for ${optLabel}</span>
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2">
                          <path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path>
                        </svg>
                      </span>
                    `;

                    const inp = el("input", {
                      id: qtyId,
                      class: "quantity__input cvp-qty-input",
                      type: "number",
                      inputmode: "numeric",
                      min: "0",
                      "data-min": "0",
                      step: "1",
                      value: "0",
                      "data-handle": handle,
                      "aria-label": `${optLabel} quantity`,
                      form: formId
                    });
                      if (step.increment || opt.increment) {
                                            inp.setAttribute('data-increment', String(step.increment || opt.increment));
                    }
                    let pc = 0;
                    if (handle && handlePrices[handle] != null) pc = parseInt(handlePrices[handle],10) || 0;
                    else if (opt.name_override) {
                      const m = opt.name_override.match(/\+\s*\$\s*(\d+(?:[\.,]\d{1,2})?)/i);
                      if (m) pc = Math.round(parseFloat(m[1].replace(',', '.'))*100);
                    }
                    inp.setAttribute('data-price-cents', String(pc));
                    if ((!pc || pc === 0) && handle) {
                      inp.setAttribute('data-price-pending', '1');
                      resolvePriceCentsViaAjax(handle);
                    }

                    // Preselect tile on initial render if value > 0
                    try {
                      const initialVal = Math.max(0, parseInt(inp.value || '0', 10) || 0);
                      if (initialVal > 0) {
                        const tile = inp.closest('.atlas-cvp__multiqty-item');
                        if (tile) tile.classList.add('selected');
                      }
                    } catch(_) {}

                    const inc = el("button", {
                      type: "button",
                      name: "plus",
                      class: "quantity__button cvp-btn js-cvp-inc",
                      "aria-controls": qtyId
                    });
                    inc.innerHTML = `
                      <span class="visually-hidden">Increase quantity for ${optLabel}</span>
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
                          <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path>
                        </svg>
                      </span>
                    `;

                    ctrls.appendChild(dec);
                    ctrls.appendChild(inp);
                    ctrls.appendChild(inc);

                    item.appendChild(head);
                    item.appendChild(ctrls);
                    try {
                      inp.setAttribute('min', '0');
                      inp.setAttribute('data-min', '0');

                      const decBtn = ctrls.querySelector('.js-cvp-dec');
                      if (decBtn) {
                        const v = Math.max(0, parseInt(inp.value || '0', 10) || 0);
                        const minVal = (parseInt(inp.getAttribute('min') || '0', 10) || 0);
                        decBtn.classList.toggle('disabled', v <= minVal);
                      }

                      if (!inp._cvpMinObserver) {
                        const mo = new MutationObserver(() => {
                          if (inp.getAttribute('min') !== '0') inp.setAttribute('min', '0');
                          if (inp.getAttribute('data-min') !== '0') inp.setAttribute('data-min', '0');
                        });
                        mo.observe(inp, { attributes: true, attributeFilter: ['min', 'data-min'] });
                        inp._cvpMinObserver = mo;
                      }
                    } catch(_) {}
                    grid.appendChild(item);
                });
                const box = el("div", {
                    "class": "atlas-cvp__multiqty",
                    "data-total": String(step.total_quantity || 0)
                });
                if (cap) box.appendChild(cap);
                box.appendChild(grid);
                if (step.required)
                    box.appendChild(
                        el("input", {
                            type: "hidden",
                            class: "cvp-multiqty-required",
                            value: "1",
                            form: formId
                        })
                    );
                wrap.appendChild(box);
                return wrap;
            }

            function renderDropdown(step, idx) {
                const stepName = step.name || step.label || `Step ${idx + 1}`;
                const wrap = el("div", {
                    "class": "atlas-cvp__step",
                    "data-step-index": idx + 1,
                    "data-step-type": "dropdown",
                    "data-step-name": stepName
                });

                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label || stepName),
                    step.required ? el("span", { class: "atlas-cvp__req" }, "Required") : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);

                if (!step.required) {
                    const skipBtn = el('button', { class: 'atlas-cvp__skip', type: 'button' }, 'Skip this step');
                    const skipBtnMobile = el('button', { class: 'atlas-cvp__skip atlas-cvp__skip--mobile', type: 'button' }, 'Skip');
                    head.appendChild(skipBtn);
                    head.appendChild(skipBtnMobile);
                }

                const selectId = `cvp-dropdown-${(root.dataset.uid || 'x')}-${idx + 1}`;
                const select = el('select', { id: selectId, class: 'atlas-cvp__dropdown-select', name: `cvp__${stepName}` });

                // Placeholder option (empty value)
                select.appendChild(el('option', { value: '' }, step.placeholder || 'Please choose'));

                (step.options || []).forEach(opt => {
                    const txt = (opt && (opt.name || opt.name_override)) ? (opt.name || opt.name_override) : '';
                    if (!txt) return;
                    select.appendChild(el('option', { value: txt }, txt));
                });

                select.addEventListener('change', () => {
                    try { recomputeSelections(); } catch(_) {}
                    try { updateAccordionHeaderDisplay(); } catch(_) {}
                    try { syncAtcDisabled(); } catch(_) {}
                    try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
                    try { recomputeTotal(); } catch(_) {}
                });

                const row = el('div', { class: 'atlas-cvp__dropdown-row' }, [ select ]);
                wrap.appendChild(row);
                return wrap;
            }

            function renderText(step, idx) {
                const stepName = step.name || step.label || `Step ${idx + 1}`;
                const wrap = el("div", {
                    "class": "atlas-cvp__step",
                    "data-step-index": idx + 1,
                    "data-step-type": "text",
                    "data-step-name": stepName
                });

                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label || stepName),
                    step.required ? el("span", { class: "atlas-cvp__req" }, "Required") : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);

                const placeholder = step.placeholder || "Enter your message";
                const maxWords = parseInt(step.max_words || 4, 10) || 4;

                const input = el("input", {
                    type: "text",
                    class: "atlas-cvp__text-input",
                    placeholder,
                    "data-max-words": maxWords
                });

                input.style.display = "none";
const boxesWrap = el("div", { class: "atlas-cvp__word-boxes" });
const boxes = [];
for (let wi = 0; wi < maxWords; wi++) {
    const box = el("input", { type: "text", class: "atlas-cvp__word-box", placeholder: `Word ${wi + 1}` });
    box.addEventListener("input", () => {
        input.value = boxes.map(b => b.value.trim()).filter(Boolean).join(" ");
        input.dispatchEvent(new Event("input", { bubbles: true }));
    });
    box.addEventListener("blur", () => {
        input.dispatchEvent(new Event("blur", { bubbles: true }));
    });
    boxes.push(box);
    boxesWrap.appendChild(box);
}
const hint = el("div", { class: "atlas-cvp__text-hint" }, `Max ${maxWords} words`);
                const row = el("div", { class: "atlas-cvp__text-row" }, [boxesWrap, input, hint]);
                wrap.appendChild(row);

                input.addEventListener("input", () => {
                  const raw = String(input.value || "").trim();
                  const words = raw.split(/\s+/).filter(Boolean);
                  const maxWords = parseInt(input.dataset.maxWords || "4", 10);
                  if (words.length > maxWords) input.value = words.slice(0, maxWords).join(" ");
                  try { recomputeSelections(); } catch(_) {}
                  try { recomputeTotal(); } catch(_) {}
                  try { updateAccordionHeaderDisplay(); } catch(_) {}
                  try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
                  try { syncAtcDisabled(); } catch(_) {}
                });

                input.addEventListener("blur", () => {
                  const raw = String(input.value || "").trim();
                  const words = raw.split(/\s+/).filter(Boolean);
                  const maxWords = parseInt(input.dataset.maxWords || "4", 10);
                  if (words.length > maxWords) input.value = words.slice(0, maxWords).join(" ");
                  try { recomputeSelections(); } catch(_) {}
                  try { recomputeTotal(); } catch(_) {}
                  try { updateAccordionHeaderDisplay(); } catch(_) {}
                  try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
                  try { syncAtcDisabled(); } catch(_) {}
                });

                return wrap;
            }
            function renderTextarea(step, idx) {
                const stepName = step.name || step.label || `Step ${idx + 1}`;
                const wrap = el("div", {
                    "class": "atlas-cvp__step",
                    "data-step-index": idx + 1,
                    "data-step-type": "textarea",
                    "data-step-name": stepName
                });

                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label || stepName),
                    step.required ? el("span", { class: "atlas-cvp__req" }, "Required") : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);

                const placeholder = step.placeholder || "Enter your message";
                const maxWords = parseInt(step.max_words || 0, 10) || 0; // 0 = no limit

                const textarea = el("textarea", {
                    class: "atlas-cvp__textarea",
                    placeholder,
                    "data-max-words": maxWords
                });

                const hint = maxWords > 0
                    ? el("div", { class: "atlas-cvp__text-hint" }, `Max ${maxWords} words`)
                    : null;

                const row = el("div", { class: "atlas-cvp__text-row" }, hint ? [textarea, hint] : [textarea]);
                wrap.appendChild(row);

                const enforceMax = () => {
                    if (!maxWords) { textarea.style.height = 'auto'; textarea.style.height = textarea.scrollHeight + 'px'; return; }
                    const raw = String(textarea.value || "").trim();
                    const words = raw.split(/\s+/).filter(Boolean);
                    if (words.length > maxWords) textarea.value = words.slice(0, maxWords).join(" "); textarea.style.height = 'auto'; textarea.style.height = textarea.scrollHeight + 'px';
                };

                textarea.addEventListener("input", () => {
                    enforceMax();
                    try { recomputeSelections(); } catch(_) {}
                    try { recomputeTotal(); } catch(_) {}
                    try { updateAccordionHeaderDisplay(); } catch(_) {}
                    try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
                    try { syncAtcDisabled(); } catch(_) {}
                });

                textarea.addEventListener("blur", () => {
                    enforceMax();
                    try { recomputeSelections(); } catch(_) {}
                    try { recomputeTotal(); } catch(_) {}
                    try { updateAccordionHeaderDisplay(); } catch(_) {}
                    try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
                    try { syncAtcDisabled(); } catch(_) {}
                });

                return wrap;
            }


            function renderFileUpload(step, idx) {
                const stepName = step.name || step.label || `Step ${idx + 1}`;
                const wrap = el("div", {
                    "class": "atlas-cvp__step",
                    "data-step-index": idx + 1,
                    "data-step-type": "file",
                    "data-step-name": stepName
                });

                const opt = (step.options && step.options[0]) || {};
                const optHandle = opt.handle || null;

                const head = el("div", { class: "atlas-cvp__step-head" }, [
                    el("div", { class: "atlas-cvp__step-title" }, step.label || "Upload file"),
                    step.required ? el("span", { class: "atlas-cvp__req" }, "Required") : null
                ]);
                if (step.required) wrap.setAttribute("data-required", "true");
                wrap.appendChild(head);

                if (optHandle) {
                    const imgWrap = el('div', {});
                    imgWrap.style.cssText = (opt.large_image) ? 'display:block;width:100%;margin:0 auto 8px;' : 'display:block;width:50%;margin:0 auto 8px;';
                    const fileStepImg = el('img', { alt: '', loading: 'lazy' });
                    fileStepImg.style.cssText = 'width:100%;height:auto;display:block;border-radius:8px;';
                    imgWrap.appendChild(fileStepImg);
                    wrap.appendChild(imgWrap);

                    const setFileStepImgSrc = (url) => {
                        if (!url) return;
                        let finalUrl = url;
                        if (finalUrl.indexOf('//') === 0) finalUrl = 'https:' + finalUrl;
                        if (!/[?&]width=\d+/i.test(finalUrl)) {
                            finalUrl += (finalUrl.indexOf('?') === -1 ? '?' : '&') + 'width=800';
                        }
                        fileStepImg.src = finalUrl;
                    };
                    if (handleImages[optHandle]) setFileStepImgSrc(handleImages[optHandle]);
                    else resolveImageUrlViaAjax(optHandle).then(setFileStepImgSrc).catch(() => {});
                }

                if (opt.name_override) {
                    wrap.appendChild(el("div", { class: "atlas-cvp__table-desc" }, opt.name_override));
                }

                const accept = step.accept || "image/jpeg,image/png,application/pdf";
                const inputId = `cvp-file-${(root.dataset.uid || 'x')}-${idx + 1}`;

                const fileInput = el("input", {
                    id: inputId,
                    type: "file",
                    accept,
                    class: "atlas-cvp__file-input"
                });

                if (optHandle) {
                    fileInput.setAttribute('data-handle', optHandle);
                    let pc = (handlePrices[optHandle] != null) ? (parseInt(handlePrices[optHandle], 10) || 0) : 0;
                    fileInput.setAttribute('data-price-cents', String(pc));
                    if (!pc) {
                        fileInput.setAttribute('data-price-pending', '1');
                        resolvePriceCentsViaAjax(optHandle).then((cents) => {
                            if (cents) fileInput.setAttribute('data-price-cents', String(cents));
                            try { recomputeTotal(); } catch(_) {}
                        });
                    }
                }

                // Only include the file input in the row (no label, no filename span)
                const row = el("div", { class: "atlas-cvp__file-row" }, [
                    fileInput
                ]);
                wrap.appendChild(row);

                fileInput.addEventListener("change", () => {
                    try { updateAccordionHeaderDisplay(); } catch(_) {}
                    try { syncAtcDisabled(); } catch(_) {}
                    try { recomputeTotal(); } catch(_) {}
                });

                return wrap;
            }

            steps.forEach((step, idx) => {
                const type = (step.type || "").toLowerCase();
                const title = step.label || step.name || `Step ${idx + 1}`;

                // render step node with the existing renderers
                let node;
                if (type === "description") node = renderDescription(step, idx);
                else if (type === "swatch-single") node = renderSwatchSingle(step, idx);
                else if (type === "swatch-table") node = renderSwatchTable(step, idx);
                else if (type === "swatch-table-linked") node = renderSwatchTableLinked(step, idx);
                else if (type === "finishing-touches-modal") node = renderFinishingTouchesModal(step, idx);
                else if (type === "number-wheel-picker") node = renderNumberWheelPicker(step, idx);
                else if (type === "swatch-table-text") node = renderSwatchTableText(step, idx);
                else if (type === "swatch-multi-qty") node = renderMultiQty(step, idx);
                else if (type === "swatch-conditional-qty") node = renderConditionalQty(step, idx);
                else if (type === "dropdown") node = renderDropdown(step, idx);
                else if (type === "text") node = renderText(step, idx);
                else if (type === "textarea") node = renderTextarea(step, idx);
                else if (type === "file") node = renderFileUpload(step, idx);
                else if (type === "upsell-links") node = renderUpsell(step, idx);
                else {
                  node = el(
                    "div",
                    {
                      "class": "atlas-cvp__step",
                      "data-step-index": idx + 1,
                      "data-step-type": type,
                      "data-step-name": step.name || step.label || `Step ${idx + 1}`
                    },
                    [
                      el("div", {
                        class: "atlas-cvp__unknown",
                        html: `Unsupported step type: <code>${step.type || ""}</code>`
                      })
                    ]
                  );
                }


                const shouldAccordion = !(type === "description" || type === "upsell-links" || type === "finishing-touches-modal");
                if (shouldAccordion) {
                  if (!accordionCurrent) {
                    accordionCurrent = document.createElement('custom-accordion');
                    accordionCurrent.setAttribute('data-cvp-accordion', '');
                    accordionCurrent.setAttribute('data-single-open', 'true');
                    frag.appendChild(accordionCurrent);
                  }
                  accordionIndex += 1;
                  accordionCurrent.appendChild(makeAccordionItem(title, node, accordionIndex));
                } else {

                  accordionCurrent = null;
                  frag.appendChild(node);
                }
            });

            mount.replaceWith(frag);

            // Group consecutive "modal trigger" steps (Personalise Your Cake, Add
            // Candles & Toppers, etc.) into one visually distinct "Add extras" row,
            // instead of them stacking as separate full-width blocks.
            (function groupExtrasTriggers() {
                if (document.getElementById('cvp-extras-group-style')) {
                    // style already injected
                } else {
                    const s = document.createElement('style');
                    s.id = 'cvp-extras-group-style';
                    s.textContent = `
                        .atlas-cvp__extras-group { margin-top:28px; padding-top:20px; border-top:1px solid rgba(var(--color-foreground),0.1); }
                        .atlas-cvp__extras-label { font-size:12px; font-weight:600; letter-spacing:0.04em; text-transform:uppercase; color:rgba(var(--color-foreground),0.55); margin-bottom:10px; }
                        .atlas-cvp__extras-row { display:flex; gap:10px; flex-wrap:wrap; }
                        .atlas-cvp__extras-row .atlas-cvp__step { margin:0 !important; flex:1; min-width:150px; }
                        .atlas-cvp__extras-row .atlas-cvp__step > button:first-child {
                            width:100%; padding:15px 14px; border-radius:999px; font-size:16px; font-weight:600;
                            background:#FBE7E6; border:1px solid #262967; color:#262967;
                        }
                        .atlas-cvp__extras-summaries { margin-top:12px; display:flex; flex-direction:column; gap:4px; }
                        .atlas-cvp__extras-summaries .atlas-cvp__ft-summary-line { display:flex; justify-content:space-between; gap:10px; font-size:0.9em; font-weight:600; color:rgb(var(--color-foreground)); }
                    `;
                    document.head.appendChild(s);
                }

                const isTriggerStep = (el) =>
                    el.classList && el.classList.contains('atlas-cvp__step') &&
                    el.querySelector(':scope > .atlas-cvp__ft-items-holder');

                const children = Array.from(root.querySelectorAll('[data-cvp-steps-mount], .atlas-custom-variant-picker'))
                    .length ? Array.from((root.querySelector('.atlas-custom-variant-picker') || root).children)
                    : [];

                // Fall back to scanning root's direct step children if the above selector setup differs
                const scanRoot = root.querySelector('.atlas-custom-variant-picker') || root;
                const nodes = Array.from(scanRoot.children);

                let i = 0;
                while (i < nodes.length) {
                    if (isTriggerStep(nodes[i])) {
                        const runStart = i;
                        let runEnd = i;
                        while (runEnd + 1 < nodes.length && isTriggerStep(nodes[runEnd + 1])) runEnd++;
                        if (runEnd > runStart) {
                            const group = document.createElement('div');
                            group.className = 'atlas-cvp__extras-group';
                            const label = document.createElement('div');
                            label.className = 'atlas-cvp__extras-label';
                            label.textContent = 'Add extras';
                            const row = document.createElement('div');
                            row.className = 'atlas-cvp__extras-row';
                            const summaries = document.createElement('div');
                            summaries.className = 'atlas-cvp__extras-summaries';
                            group.appendChild(label);
                            group.appendChild(row);
                            group.appendChild(summaries);
                            nodes[runStart].parentNode.insertBefore(group, nodes[runStart]);
                            for (let k = runStart; k <= runEnd; k++) {
                                const stepEl = nodes[k];
                                const summaryEl = stepEl.querySelector(':scope > .atlas-cvp__ft-summary');
                                if (summaryEl) summaries.appendChild(summaryEl);
                                row.appendChild(stepEl);
                            }
                        }
                        i = runEnd + 1;
                    } else {
                        i++;
                    }
                }
            })();

            // Normalize any pre-rendered accordion headers (defensive sweep)
            try {
              root.querySelectorAll('.accordion-title').forEach(el => {
                // Get raw textual content and strip any trailing colon
                const raw = (el.textContent || '').replace(/:\s*$/, '');
                // Detect (optional) case-insensitively
                const optRe = /\(\s*optional\s*\)/i;
                const hasOpt = optRe.test(raw) || !!el.querySelector('span');
                const base = _cvpFixLabelText(raw.replace(optRe, '').trim());

                if (hasOpt) {
                  el.innerHTML = `${base} <span>(Optional)</span>`;
                } else {
                  el.textContent = base;
                }
              });
            } catch(_) {}
            openFirstAccordionOnce();

            setTimeout(() => {
              const first = root.querySelector('custom-accordion .accordion-item.open .accordion-content');
              if (first) _cvpSetMaxHeight(first);
            }, 0);

            setTimeout(() => {
              root.querySelectorAll('.atlas-cvp__multiqty').forEach(box => {
                try { updateMultiQtyUI(box); } catch(_) {}
              });
            }, 0);
            window.addEventListener('load', () => {
              root.querySelectorAll('.atlas-cvp__multiqty').forEach(box => {
                try { updateMultiQtyUI(box); } catch(_) {}
              });
            }, { once: true });

            const __cvpCondLinks = [];
            const __cvpQtyOptionsByChild = new Map();
            const __cvpPresetQtyByStepName = new Map();

            try {
              (steps || []).forEach((s) => {
                const type = String(s.type || '').toLowerCase();
                const name = s.name || s.label;
                if (!name) return;

                if (type === 'swatch-conditional-qty') {
                  const map = {};
                  (s.total_quantity_options || []).forEach((opt) => {
                    if (opt && opt.handle) map[opt.handle] = parseInt(opt.quantity || 0, 10) || 0;
                  });
                  __cvpQtyOptionsByChild.set(name, map);
                  // console.log('[CVP preset_qty] swatch-conditional-qty step found:', name, '| preset:', s.preset, '| options count:', Array.isArray(s.options) ? s.options.length : 'N/A');
                }

                if (type === 'swatch-conditional-qty' || type === 'swatch-multi-qty') {
                  if (Array.isArray(s.options)) {
                    const presetMap = {};
                    s.options.forEach((opt) => {
                      if (!opt || !opt.handle) return;
                      const q = Math.max(0, parseInt(opt.preset_quantity || 0, 10) || 0);
                      if (q > 0) presetMap[String(opt.handle)] = q;
                    });
                    if (Object.keys(presetMap).length) {
                      __cvpPresetQtyByStepName.set(name, presetMap);
                    }
                  }
                }

                if (type === 'swatch-single' && s.conditional_field_parent) {
                  __cvpCondLinks.push({ parent: name, child: s.conditional_field_parent });
                  // console.log('[CVP preset_qty] condLink added — parent:', name, '→ child:', s.conditional_field_parent);
                }
              });
              // console.log('[CVP preset_qty] Init summary — __cvpCondLinks:', JSON.parse(JSON.stringify(__cvpCondLinks)), '| __cvpPresetQtyByStepName size:', __cvpPresetQtyByStepName.size, '| handleStep1Presets keys:', Object.keys(handleStep1Presets || {}));
            } catch (_) { /* console.warn('[CVP preset_qty] Error during init parse:', _); */ }

            // Set to true on first real user interaction with CVP qty controls
            let __cvpUserHasInteracted = false;
            const __cvpMarkUserInteracted = () => { __cvpUserHasInteracted = true; };
            root.addEventListener('click', (ev) => {
              if (ev.target && (ev.target.closest('.cvp-btn') || ev.target.closest('.js-cvp-inc') || ev.target.closest('.js-cvp-dec') || ev.target.closest('.atlas-cvp__multiqty-item'))) {
                __cvpMarkUserInteracted();
              }
            }, { capture: true, passive: true });
            root.addEventListener('input', (ev) => {
              if (ev.target && ev.target.classList && ev.target.classList.contains('cvp-qty-input')) {
                __cvpMarkUserInteracted();
              }
            }, { capture: true, passive: true });

            function __cvpApplyInlinePresets() {
              // console.log('[CVP preset_qty] __cvpApplyInlinePresets called, map size:', __cvpPresetQtyByStepName.size);
              __cvpPresetQtyByStepName.forEach((presetMap, stepName) => {
                // console.log('[CVP preset_qty]   applying inline presets for step:', stepName, '| presetMap:', presetMap);
                const stepEl = root.querySelector(`.atlas-cvp__step[data-step-name="${CSS.escape(stepName)}"]`);
                // console.log('[CVP preset_qty]   stepEl found?', !!stepEl);
                if (!stepEl) return;
                const box = stepEl.querySelector('.atlas-cvp__multiqty');
                // console.log('[CVP preset_qty]   multiqty box found?', !!box);
                if (!box) return;

                // Restore data-total in case conditional reconcile changed it
                const originalTotal = parseInt(box.getAttribute('data-total') || '0', 10) || 0;
                const presetSum = Object.values(presetMap).reduce((s, v) => s + (Math.max(0, parseInt(v || 0, 10) || 0)), 0);
                if (originalTotal > 0 && parseInt(box.dataset.total || '0', 10) !== originalTotal) {
                  box.dataset.total = String(originalTotal);
                }

                const inputs = box.querySelectorAll('.cvp-qty-input');
                // console.log('[CVP preset_qty]   qty inputs count:', inputs.length);
                inputs.forEach((inp) => {
                  const h = String(inp.getAttribute('data-handle') || '');
                  const q = Math.max(0, parseInt(presetMap[h] || 0, 10) || 0);
                  if (q > 0) {
                    inp.value = String(q);
                    const tile = inp.closest('.atlas-cvp__multiqty-item');
                    if (tile) tile.classList.add('selected');
                  }
                });
                try { updateMultiQtyUI(box); } catch (_) {}
                try { recomputeSelections(); } catch (_) {}
                try { recomputeTotal(); } catch (_) {}
                try { updateAccordionHeaderDisplay(); } catch (_) {}
                try { syncAtcDisabled(); } catch (_) {}
              });
            }

            function __cvpApplyConditionalTargetFor(childName, newTotal) {
              const stepEl = root.querySelector(`.atlas-cvp__step[data-step-name="${CSS.escape(childName)}"]`);
              if (!stepEl) return;

              const box = stepEl.querySelector('.atlas-cvp__multiqty');
              if (!box) return;

              const prevTotal = parseInt(box.dataset.total || '0', 10) || 0;
              const target = Math.max(0, parseInt(newTotal || 0, 10) || 0);

              // Update dataset
              box.dataset.total = String(target);

              const cap = box.querySelector('.atlas-cvp__multiqty-cap');
              if (cap) {
                cap.innerHTML = `Select ${target} items for your pack. <span class="js-cvp-message">${target > 0 ? `Please add another ${target} items.` : ''}</span>`;
              }

              if (prevTotal !== target) {
                box.querySelectorAll('.cvp-qty-input').forEach((inp) => {
                  inp.value = '0';
                  const tile = inp.closest('.atlas-cvp__multiqty-item');
                  if (tile) tile.classList.remove('selected');
                });
              }

              // Apply inline presets from current metafield step (independent from all_products)
              try {
                const presetMap = __cvpPresetQtyByStepName.get(childName);
                if (presetMap && typeof presetMap === 'object') {
                  let presetSum = 0;
                  box.querySelectorAll('.cvp-qty-input').forEach((inp) => {
                    const h = String(inp.getAttribute('data-handle') || '');
                    const q = Math.max(0, parseInt(presetMap[h] || 0, 10) || 0);
                    if (q > 0) {
                      inp.value = String(q);
                      presetSum += q;
                    }
                    const tile = inp.closest('.atlas-cvp__multiqty-item');
                    if (tile) tile.classList.toggle('selected', q > 0);
                  });
                }
              } catch (_) {}

              // Refresh UI and gating
              try { updateMultiQtyUI(box); } catch (_) {}
              try { recomputeSelections(); } catch (_) {}
              try { recomputeTotal(); } catch (_) {}
              try { updateAccordionHeaderDisplay(); } catch (_) {}
              try { syncAtcDisabled(); } catch (_) {}
            }

            function __cvpApplyPresetFromParentHandle(childName, parentHandle) {
              try {
                // console.log('[CVP preset_qty] __cvpApplyPresetFromParentHandle called — child:', childName, '| parentHandle:', parentHandle);
                if (!childName || !parentHandle) return;
                const presetStep = handleStep1Presets && handleStep1Presets[parentHandle];
                // console.log('[CVP preset_qty]   handleStep1Presets[handle] found?', !!presetStep, '| has options?', !!(presetStep && Array.isArray(presetStep.options)));
                if (!presetStep || !Array.isArray(presetStep.options)) return;

                const stepEl = root.querySelector(`.atlas-cvp__step[data-step-name="${CSS.escape(childName)}"]`);
                if (!stepEl) return;
                const box = stepEl.querySelector('.atlas-cvp__multiqty');
                if (!box) return;

                const qtyByHandle = {};
                presetStep.options.forEach((opt) => {
                  if (!opt || !opt.handle) return;
                  const q = Math.max(0, parseInt(opt.preset_quantity || 0, 10) || 0);
                  qtyByHandle[String(opt.handle)] = q;
                });

                box.querySelectorAll('.cvp-qty-input').forEach((inp) => {
                  const h = String(inp.getAttribute('data-handle') || '');
                  const q = qtyByHandle[h] != null ? qtyByHandle[h] : 0;
                  inp.value = String(q);
                  const tile = inp.closest('.atlas-cvp__multiqty-item');
                  if (tile) tile.classList.toggle('selected', q > 0);
                });


                try { updateMultiQtyUI(box); } catch (_) {}
                try { saveQtyState(); } catch (_) {}
                try { recomputeSelections(); } catch (_) {}
                try { recomputeTotal(); } catch (_) {}
                try { updateAccordionHeaderDisplay(); } catch (_) {}
                try { syncAtcDisabled(); } catch (_) {}
              } catch (_) {}
            }

            // Walk all defined parent→child links and push current selection-derived totals
            function __cvpReconcileConditionalTargetsFromSelection() {
              // console.log('[CVP preset_qty] __cvpReconcileConditionalTargetsFromSelection called, condLinks count:', __cvpCondLinks.length);
              __cvpCondLinks.forEach((link) => {
                const parentStep = root.querySelector(`.atlas-cvp__step[data-step-name="${CSS.escape(link.parent)}"]`);
                const childName = link.child;
                if (!parentStep || !childName) {
                  // console.log('[CVP preset_qty]   skipping link — parentStep found?', !!parentStep, '| childName:', childName);
                  return;
                }

                const checked = parentStep.querySelector('input[type="radio"]:checked');
                const selHandle = checked && checked.getAttribute('data-handle');
                // console.log('[CVP preset_qty]   link parent:', link.parent, '→ child:', childName, '| checked radio handle:', selHandle);
                const qtyMap = __cvpQtyOptionsByChild.get(childName) || {};
                const newTotal = selHandle ? (qtyMap[selHandle] || 0) : 0;

                __cvpApplyConditionalTargetFor(childName, newTotal);
                if (selHandle) __cvpApplyPresetFromParentHandle(childName, selHandle);
                // Re-apply inline presets: only override items that ARE in the inline map (q>0)
                // so parent-preset values for items not in the map are preserved
                try {
                  const _inlineMap = __cvpPresetQtyByStepName.get(childName);
                  if (_inlineMap) {
                    const _childStep = root.querySelector(`.atlas-cvp__step[data-step-name="${CSS.escape(childName)}"]`);
                    const _box = _childStep && _childStep.querySelector('.atlas-cvp__multiqty');
                    if (_box) {
                      _box.querySelectorAll('.cvp-qty-input').forEach((inp) => {
                        const h = String(inp.getAttribute('data-handle') || '');
                        const q = Math.max(0, parseInt(_inlineMap[h] || 0, 10) || 0);
                        if (q > 0) {
                          inp.value = String(q);
                          const tile = inp.closest('.atlas-cvp__multiqty-item');
                          if (tile) tile.classList.add('selected');
                        }
                      });
                      try { updateMultiQtyUI(_box); } catch (_) {}
                    }
                  }
                } catch (_) {}
              });
            }
            // Update accordion headers with selected option label
            function updateAccordionHeaderValues() {
              root.querySelectorAll('.accordion-item').forEach(item => {
                const step = item.querySelector('.atlas-cvp__step');
                const header = item.querySelector('.accordion-selected-value');
                if (!step || !header) return;
                const type = (step.dataset.stepType || '').toLowerCase();
                {
                  let _total = 0, _selected = 0;
                  if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
                    const _mqAll = step.querySelectorAll('.atlas-cvp__multiqty-item');
                    _total = _mqAll.length;
                    _mqAll.forEach(tile => {
                      const inp = tile.querySelector('.cvp-qty-input');
                      if (inp && parseInt(inp.value || '0', 10) > 0) _selected++;
                    });
                  } else if (['swatch-single','swatch-table','swatch-table-text'].includes(type)) {
                    _total = step.querySelectorAll('input[type="radio"]').length;
                    _selected = step.querySelectorAll('input[type="radio"]:checked').length;
                  } else if (type === 'dropdown') {
                    _total = step.querySelectorAll('.atlas-cvp__dropdown-select option[value]:not([value=""])').length;
                    const sel = step.querySelector('.atlas-cvp__dropdown-select');
                    _selected = (sel && sel.value) ? 1 : 0;
                  }
                  header.dataset.items = _total;
                  header.dataset.itemsSelected = _selected;
                }
                let value = '';
                if (['swatch-single', 'swatch-table', 'swatch-table-text'].includes(type)) {
                  const checked = step.querySelector('input[type="radio"]:checked');
                  if (checked) value = checked.value;
                } else if (type === 'dropdown') {
                  const sel = step.querySelector('.atlas-cvp__dropdown-select');
                  if (sel && sel.value) value = sel.options[sel.selectedIndex].text.trim();
                } else if (type === 'text') {
                    const inp = step.querySelector('.atlas-cvp__text-input');
                    if (inp && inp.value.trim()) value = inp.value.trim();
                    else value = '';
                } else if (type === 'textarea') {
                    const ta = step.querySelector('.atlas-cvp__textarea');
                    if (ta && ta.value.trim()) value = ta.value.trim();
                    else value = '';
                } else if (type === 'swatch-multi-qty' || type === 'swatch-conditional-qty') {
                  const lines = [];
                  step.querySelectorAll('.cvp-qty-input').forEach(inp => {
                    const q = Math.max(0, parseInt(inp.value || '0', 10));
                    if (!q) return;
                    const item = inp.closest('.atlas-cvp__multiqty-item');
                    const titleEl = item && item.querySelector('.atlas-cvp__multiqty-title');
                    const label = (titleEl && titleEl.textContent ? titleEl.textContent.trim() : inp.getAttribute('data-handle') || '').trim();
                    if (label) lines.push(`${q}x ${label}`);
                  });
                  if (lines.length) value = lines.join(', <br>');
                } else if (type === 'file') {
                    const fi = step.querySelector('input[type="file"]');
                    const f = fi && fi.files && fi.files[0];
                    if (f) value = f.name;
                }
                const skipped = step.hasAttribute('data-skipped') || step.getAttribute('data-skipped') === 'true';
                header.innerHTML = skipped ? '' : (value ? `${value}` : '');
                item.toggleAttribute('data-skipped', skipped);
                const hasCheckedRadio2 = !!step.querySelector('input[type="radio"]:checked');
                if (!skipped && (value || hasCheckedRadio2)) item.classList.add('selected');
                else item.classList.remove('selected');

                // Toggle colon after (Optional) only when a selection is made
                try {
                  const optEl = item.querySelector('.accordion-title span');
                  if (optEl) {
                    const hasVal = !!(value && !skipped);
                    optEl.textContent = hasVal ? '(Optional):' : '(Optional)';
                  }
                } catch(_) {}
              });
            }
            root.addEventListener('change', (e) => {
              const target = e.target;

              if (target && (target.matches('input[type="radio"]') || target.classList.contains('cvp-qty-input') || target.classList.contains('atlas-cvp__textarea'))) {
                const step = target.closest('.atlas-cvp__step');
                if (step && step.dataset.required !== 'true' && step.getAttribute('data-skipped') === 'true') {
                  setStepSkipped(step, false);
                  try { injectSkipButtonsIntoHeaders(); } catch(_) {}
                  try { updateAccordionHeaderDisplay(); } catch(_) {}
                }
              }

              // Enable textarea when choosing a swatch-table-text option
                if (target && target.classList && target.classList.contains('js-cvp-text-toggle')) {
                    const row = target.closest('.atlas-cvp__table-row');
                    const taWrap = row && row.querySelector('.atlas-cvp__textarea-wrap');
                    const ta = taWrap && taWrap.querySelector('.atlas-cvp__textarea');
                    if (taWrap) taWrap.style.display = 'block';
                    if (ta) ta.disabled = false;
                    try { refreshActionStates(); } catch(_) {}
                }

                if (target && target.matches('input[type="file"]')) {
                    try { updateAccordionHeaderDisplay(); } catch(_) {}
                }

              updateAccordionHeaderValues();
            });
            setTimeout(updateAccordionHeaderValues, 300);

            try { __cvpReconcileConditionalTargetsFromSelection(); } catch (_) {}

            root.addEventListener('change', (e) => {
              const t = e.target;
              if (!t || t.type !== 'radio') return;

              const stepEl = t.closest('.atlas-cvp__step');
              if (!stepEl) return;

              const stepName = stepEl.getAttribute('data-step-name') || '';
              const isParentOfConditional = (__cvpCondLinks || []).some((lnk) => lnk.parent === stepName);
              if (!isParentOfConditional) return;

              try { __cvpReconcileConditionalTargetsFromSelection(); } catch (_) {}
            }, true);

            try { refreshActionStates(); } catch(_) {}

            root.querySelectorAll('.atlas-cvp__step:not([data-required="true"]) .atlas-cvp__skip')
              .forEach(btn => { btn.textContent = 'Skip this step'; });
            autoPreselectFirstRequired();
            try { __cvpReconcileConditionalTargetsFromSelection(); } catch (_) {}
            try { __cvpApplyInlinePresets(); } catch (_) {}
            // Deferred re-apply: guard against async code (reconcile, AJAX, timers) resetting preset values
            [0, 80, 250, 500].forEach(delay => {
              setTimeout(() => {
                if (!__cvpUserHasInteracted) {
                  try { __cvpApplyInlinePresets(); } catch (_) {}
                }
              }, delay);
            });
            openFirstAccordionOnce();

            try { injectSkipButtonsIntoHeaders(); } catch(_) {}
            try { updateAccordionHeaderDisplay(); } catch(_) {}
            try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
            try { syncAccordionItemRequiredClasses(); } catch(_) {}
        }

        const state = { selections: {}, textInputs: {}, multiQty: {} };

        const DROPDOWN_FIXED_ADDONS = {
          "Number of Digits": {
            "1 digit": "number-topper-1-digit",
            "2 digits": "number-topper-2-digits"
          }
        };

        // Helper: get first variant id by handle (sync with Shopify /products/<handle>.js)
        async function resolveFirstVariantIdByHandle(handle) {
          try {
            const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
            if (!res || !res.ok) return null;
            const data = await res.json();
            const v = data && data.variants && data.variants[0];
            return v ? v.id : null;
          } catch(_) { return null; }
        }

        // Optional surcharge config from theme settings
        const SURCHARGE_VID = __cvpCfg.surchargeVariantId || null; // Variant ID for $ step (e.g., 1234567890)
        const SURCHARGE_STEP_CENTS = __cvpCfg.surchargeStepCents || 100; // step price in cents (e.g., 100 for $1)

        function buildParentProps(groupKey, parentVid, bundleQty, productID) {
          function mapKey(stepName, selectedLabel) {
            const s = String(stepName||'').toLowerCase();
            const v = String(selectedLabel||'').toLowerCase();
            // Prefer Pack Size when label or step references packs
            if (s.includes('pack') || /\bpack\b/.test(v)) return 'Pack Size';
            if (s.includes('size')) return 'Cake Size';
                            if (s.includes('flavour') || s.includes('flavor')) {
                    if (s.includes('mini') && s.includes('cupcake')) return 'Mini Cupcake Flavours';
                    return String(stepName || 'Cake Flavour').trim();
                }
            if (s.includes('garnish')) return 'Garnish';
            if (s.includes('iced message') || s.includes('message')) return 'Cake Iced Message';
            if (s.includes('postcard')) return 'Personalised Postcard';
            const trimmed = String(stepName||'').replace(/^classic\s+cake\s+/i,'').replace(/^cake\s+/i,'').trim();
            return trimmed || stepName || 'Option';
          }

          const props = {};

          const summaryParts = [];

const orderedStepNames = Array.from(root.querySelectorAll('.atlas-cvp__step[data-step-name]'))
  .sort((a, b) => (parseInt(a.dataset.stepIndex,10)||0) - (parseInt(b.dataset.stepIndex,10)||0))
  .map(el => el.dataset.stepName);

orderedStepNames.forEach((stepName) => {
    const sel = state.selections[stepName];
    if (sel) {
        const lbl = typeof sel.label === 'string' ? sel.label.trim() : '';
        if (lbl && lbl !== 'Step skipped') {
            const visKey = mapKey(stepName, lbl);
                        const __isCandleTopper = /candle|topper/i.test(String(stepName || '') + ' ' + String(visKey || ''));
                    props[visKey] = (!__isCandleTopper && (state.textInputs[stepName] || (sel && sel.isAddonToggle))) ? 'Included' : lbl;
            summaryParts.push(`${visKey}: ${props[visKey]}`);
        }
    }

    const val = state.textInputs[stepName];
    const v = String(val || '').trim();
    if (v) {
        const s = String(stepName || '').toLowerCase();
        let key;
        if (s.includes('postcard')) key = '_Personalised Message';
        else if (s.includes('iced message')) key = 'Cake Iced Message';
        else if (s.includes('message')) key = 'Message';
        else key = (mapKey(stepName, v) || stepName || 'Message');
        props[key] = v;
        summaryParts.push(`${key}: ${v}`);
    }
});

          Object.entries(state.multiQty).forEach(([stepName, obj]) => {
            if (!obj || !obj.items) return;
            const picked = Object.entries(obj.items).filter(([, q]) => q > 0);
            if (!picked.length) return;

            const labelForHandle = (h) => {
              try {
                const inp = root.querySelector(`.cvp-qty-input[data-handle="${CSS.escape(h)}"]`);
                const item = inp && inp.closest('.atlas-cvp__multiqty-item');
                const titleEl = item && item.querySelector('.atlas-cvp__multiqty-title');
                const txt = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
                return txt || h;
              } catch(_) {
                return h;
              }

            };

            const visKey = mapKey(stepName);
            const humanLines = picked.map(([h, q]) => `${q}x ${labelForHandle(h)}`);
            props[visKey] = humanLines.join(',\n');
            summaryParts.push(`${visKey}: ` + humanLines.join(', '));
          });

          try {
            const cents = parseInt((root.querySelector('.js-cvp-total-price')?.dataset.cents)||'0',10) || 0;
            props['_ProductPrice'] = (cents/100).toFixed(2);
          } catch(_) {}
          try {
            if (!productID) {
              productID = Math.random().toString(36).slice(2, 5).toUpperCase();
            }
            props['_ProductID'] = String(productID);
          } catch(_) {}

            // Include chosen file names (not binary) in visible properties
            try {
                root.querySelectorAll('.atlas-cvp__step[data-step-type="file"]').forEach(stepEl => {
                    const stepName = stepEl.getAttribute('data-step-name') || 'File';
                    const fi = stepEl.querySelector('input[type="file"]');
                    const f = fi && fi.files && fi.files[0];
                    if (f) {
                        props[stepName] = 'Included';
                        summaryParts.push(`${stepName}: Included`);
                    }
                });
            } catch(_) {}

          return props;
        }

        function makeProductID() {
          return Math.random().toString(36).slice(2, 5).toUpperCase();
        }

        function __cvpLabelForHandle(handle) {
          try {
            const inp = root.querySelector(`.cvp-qty-input[data-handle="${CSS.escape(handle)}"]`);
            const item = inp && inp.closest('.atlas-cvp__multiqty-item');
            const titleEl = item && item.querySelector('.atlas-cvp__multiqty-title');
            const txt = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
            return txt || handle;
          } catch(_) {
            return handle;
          }
        }

        function setProp(name, value) {
            // Normalize: remove existing hidden input for this name, then add new
            const key = `properties[${name}]`;
            let input = propsHolder.querySelector(
                `[name="${CSS.escape(key)}"]`
            );
            if (
                value === undefined ||
                value === null ||
                value === "" ||
                (typeof value === "object" && Object.keys(value).length === 0)
            ) {
                if (input) input.remove();
                return;
            }
            if (!input) {
                input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.setAttribute("form", formId);
                propsHolder.appendChild(input);
            }
            if (typeof value === "object") {
                try {
                    input.value = JSON.stringify(value);
                } catch {
                    input.value = String(value);
                }
            } else {
                input.value = String(value);
            }
        }

        function recomputeSelections() {
            state.selections = {};
            state.textInputs = {};
            // Purge selections/text from skipped steps and from single-choice steps with no checked radio
            try {
                // Remove anything from steps explicitly marked as skipped
                root.querySelectorAll('.atlas-cvp__step[data-skipped="true"]').forEach(stepEl => {
                    const name = stepEl && stepEl.getAttribute('data-step-name');
                    if (name) {
                        delete state.selections[name];
                        delete state.textInputs[name];
                    }
                });
                // For single-choice steps, if nothing is checked — drop previous selection
                root.querySelectorAll('.atlas-cvp__step[data-step-type="swatch-single"], .atlas-cvp__step[data-step-type="swatch-table"], .atlas-cvp__step[data-step-type="swatch-table-text"]').forEach(stepEl => {
                    const name = stepEl && stepEl.getAttribute('data-step-name');
                    if (!name) return;
                    const hasChecked = !!stepEl.querySelector('input[type="radio"]:checked');
                    if (!hasChecked) delete state.selections[name];
                });
            } catch(_) {}
            // Radios (single choice)
            root.querySelectorAll('.atlas-cvp__input[type="radio"]').forEach(
                (radio) => {
                    if (!radio.name.startsWith("cvp__")) return;
                    if (!radio.checked) return;
                    const wrapper = radio.closest(".atlas-cvp__step");
                    const stepName =
                        wrapper?.dataset.stepName ||
                        radio.name.replace(/^cvp__/, "");
                    const val = radio.value;
                    state.selections[stepName] = {
                        label: val,
                        handle: radio.dataset.handle || null,
                        linkedHandle: radio.dataset.linkedHandle || null,
                              linkedQuantity: radio.dataset.linkedQuantity || null,
      isAddonToggle: !radio.dataset.keepLabel && wrapper.querySelectorAll('input[type="radio"]').length === 1
                    };
                }
            );

            // Dropdowns (single select)
            root.querySelectorAll('.atlas-cvp__dropdown-select').forEach((sel) => {
                const step = sel.closest('.atlas-cvp__step');
                const stepName = step?.dataset.stepName;
                if (!stepName) return;
                const val = sel.value || '';
                if (val) {
                    state.selections[stepName] = { label: val, handle: null };
                } else {
                    delete state.selections[stepName];
                }
            });
            root.querySelectorAll('.atlas-cvp__step[data-step-type="text"]').forEach(step => {
                const stepName = step?.dataset.stepName;
                if (!stepName) return;
                const inp = step.querySelector('.atlas-cvp__text-input');
                const val = (inp && inp.value ? inp.value.trim() : '');
                if (val) {
                    state.textInputs[stepName] = val;
                } else {
                    delete state.textInputs[stepName];
                }
            });

            root.querySelectorAll('.atlas-cvp__step[data-step-type="textarea"]').forEach(step => {
                const stepName = step?.dataset.stepName;
                if (!stepName) return;
                const ta = step.querySelector('.atlas-cvp__textarea');
                const val = (ta && ta.value ? ta.value.trim() : '');
                if (val) {
                    state.textInputs[stepName] = val;
                } else {
                    delete state.textInputs[stepName];
                }
            });

            // Textareas linked to swatch-table-text
            root.querySelectorAll(".atlas-cvp__textarea").forEach((ta) => {
                const step = ta.closest(".atlas-cvp__step");
                const stepName = step?.dataset.stepName;
                if (!stepName) return;
                if (!(stepName in state.selections)) return; // only if chosen
                state.textInputs[stepName] = ta.value.trim();
            });

            // Multi-qty
            root.querySelectorAll(".atlas-cvp__multiqty").forEach((wrap) => {
                const stepName =
                    wrap.closest(".atlas-cvp__step")?.dataset.stepName;
                if (!stepName) return;
                const items = {};
                let total = 0;
                wrap.querySelectorAll(".cvp-qty-input").forEach((inp) => {
                    const q = Math.max(0, parseInt(inp.value || "0", 10));
                    if (q > 0) {
                        items[inp.dataset.handle] = q;
                        total += q;
                    }
                });
                state.multiQty[stepName] = {
                    items,
                    total,
                    required:
                        !!wrap.closest(".atlas-cvp__step")?.dataset.required,
                    target: parseInt(wrap.dataset.total || "0", 10)
                };
            });


            // File steps: keep selected file names in state (for headers/summary only)
            try {
                root.querySelectorAll('.atlas-cvp__step[data-step-type="file"]').forEach(stepEl => {
                    const stepName = stepEl.getAttribute('data-step-name') || 'File';
                    const fi = stepEl.querySelector('input[type="file"]');
                    const f = fi && fi.files && fi.files[0];
                    if (f) {
                        state.selections[stepName] = { label: f.name, handle: (fi.getAttribute('data-handle') || null) };
                    } else {
                        delete state.selections[stepName];
                    }
                });
            } catch(_) {}

            // Ensure the visual placeholder "Step skipped" never persists in state
            try {
              Object.keys(state.selections || {}).forEach((k) => {
                const v = state.selections[k];
                const lbl = v && typeof v.label === 'string' ? v.label.trim() : '';
                if (lbl === 'Step skipped') delete state.selections[k];
              });
            } catch(_) {}

            // Push to hidden inputs
            // 1) singles (do not persist the UI stub "Step skipped")
            Object.entries(state.selections).forEach(([k, v]) => {
              const lbl = v && typeof v.label === 'string' ? v.label.trim() : '';
              if (!lbl || lbl === 'Step skipped') {
                setProp(k, null); // remove hidden input if it exists
              } else {
                setProp(k, lbl);
              }
            });
            // 2) text add-ons
            // 2) text add-ons (single visible key, no duplication)
            Object.entries(state.textInputs).forEach(([stepName, val]) => {
                const s = String(stepName || '').toLowerCase();
                let key;
                if (s.includes('postcard')) key = '_Personalised Message';
                else if (s.includes('iced message')) key = 'Cake Iced Message';
                else if (s.includes('message')) key = 'Message';
                else key = (stepName ? `${stepName}` : 'Message');
                setProp(key, val || null);
            });
            // 3) multi-qty
            Object.entries(state.multiQty).forEach(([k, v]) => {
                const human = Object.entries(v.items)
                  .filter(([, q]) => q > 0)
                  .map(([h, q]) => `${q}x ${__cvpLabelForHandle(h)}`)
                  .join(',\n');
                setProp(k, human || null);
                try {
                  const slug = String(k).toLowerCase().replace(/[^a-z0-9]+/g, '_');
                  setProp(`_cvp_multiqty_${slug}`, v.items);
                } catch(_) {}
            });
            try { normalizeTextKeysInState(); } catch(_) {}
        }

        function updateMultiQtyUI(container) {
            const selectedEl = container.querySelector(".js-cvp-selected");
            const totalEl = container.querySelector(".js-cvp-total");
            let sum = 0;
            container
                .querySelectorAll(".cvp-qty-input")
                .forEach(
                    (inp) =>
                        (sum += Math.max(0, parseInt(inp.value || "0", 10)))
                );
            // Apply/remove `selected` explicitly to avoid rare toggle race conditions
            container.querySelectorAll('.cvp-qty-input').forEach((inp) => {
              const q = Math.max(0, parseInt(inp.value || '0', 10));
              const tile = inp.closest('.atlas-cvp__multiqty-item');
              if (!tile) return;
              if (q > 0) {
                tile.classList.add('selected');
              } else {
                tile.classList.remove('selected');
              }
            });
            if (selectedEl) selectedEl.textContent = sum;
            // Hard cap at total if defined
            const max = parseInt(container.dataset.total || "0", 10);
            if (max > 0) {
                // Disable increments when reached
                const remaining = Math.max(0, max - sum);
                container.querySelectorAll(".js-cvp-inc").forEach((btn) => {
                    btn.disabled = remaining <= 0;
                });
            }
            // Update message text
            const messageEl = container.closest('.atlas-cvp__multiqty')?.querySelector('.js-cvp-message');
            if (messageEl) {
                if (max > 0) {
                    const remaining = Math.max(0, max - sum);
                    if (remaining > 0) {
                                             messageEl.textContent = `Please add another ${remaining} item${remaining !== 1 ? 's' : ''}.`;
                        messageEl.classList.add('invalid');
                        messageEl.classList.remove('complete');
                    } else {
                                        messageEl.textContent = `All ${max} items selected.`;
                    messageEl.classList.add('complete');
                    messageEl.classList.remove('invalid');
                    }
                } else {
                    messageEl.textContent = '';
                }
            }
        }

        // Helper: Sync display of conditional-qty totals
        function syncConditionalTotals() {
            root.querySelectorAll('.atlas-cvp__step[data-step-type="swatch-conditional-qty"] .atlas-cvp__multiqty').forEach(updateMultiQtyUI);
        }

        // === Required steps gating ===
        function isStepComplete(stepEl) {
            if (!stepEl) return true;
            const type = (stepEl.dataset.stepType || '').toLowerCase();
            const isRequired = stepEl.dataset.required === 'true';
            if (!isRequired) return true;

            if (type === 'swatch-single' || type === 'swatch-table' || type === 'swatch-table-linked' || type === 'swatch-table-text' || type === 'swatch-conditional-qty') {
                if (type === 'swatch-conditional-qty') {

                    const box = stepEl.querySelector('.atlas-cvp__multiqty');
                    if (!box) return true;
                    const target = parseInt(box.dataset.total || '0', 10) || 0;
                    let sum = 0;
                    box.querySelectorAll('.cvp-qty-input').forEach(inp => {
                        sum += Math.max(0, parseInt(inp.value || '0', 10));
                    });
                    if (target > 0) return sum === target;
                    return sum > 0;
                }
                return !!stepEl.querySelector('input[type="radio"]:checked');
            }
            if (type === 'swatch-multi-qty') {
                const box = stepEl.querySelector('.atlas-cvp__multiqty');
                if (!box) return true;
                const target = parseInt(box.dataset.total || '0', 10) || 0;
                let sum = 0;
                box.querySelectorAll('.cvp-qty-input').forEach(inp => {
                    sum += Math.max(0, parseInt(inp.value || '0', 10));
                });
                if (target > 0) return sum === target;
                return sum > 0;
            }
            if (type === 'dropdown') {
                if (!isRequired) return true;
                const sel = stepEl.querySelector('.atlas-cvp__dropdown-select');
                return !!(sel && sel.value);
            }
            if (type === 'file') {
                if (stepEl.dataset.required !== 'true') return true;
                const fi = stepEl.querySelector('input[type="file"]');
                const f = fi && fi.files && fi.files[0];
                return !!f;
            }
            if (type === 'text') {
                if (!isRequired) return true;
                const inp = stepEl.querySelector('.atlas-cvp__text-input');
                const v = (inp && inp.value ? inp.value.trim() : '');
                return v.length > 0;
            }
            if (type === 'textarea') {
                if (!isRequired) return true;
                const ta = stepEl.querySelector('.atlas-cvp__textarea');
                const v = (ta && ta.value ? ta.value.trim() : '');
                return v.length > 0;
            }
            return true;
        }

        function allRequiredCompleted() {
            const steps = root.querySelectorAll('.atlas-cvp__step[data-required="true"]');
            for (const s of steps) {
                if (!isStepComplete(s)) return false;
            }
            return true;
        }

        function findFirstIncompleteStep() {
            const steps = root.querySelectorAll('.atlas-cvp__step[data-required="true"]');
            for (const s of steps) {
                if (!isStepComplete(s)) return s;
            }
            return null;
        }

        function syncAtcDisabled() {
            const complete = allRequiredCompleted();
            const btns = (form
                ? Array.from(form.querySelectorAll('[type="submit"], button[name="add"], .product-form__submit'))
                : []);

            btns.forEach(btn => {
                if (!complete) {
                    btn.setAttribute('disabled', 'disabled');
                    btn.setAttribute('aria-disabled', 'true');
                    btn.classList.add('disabled');
                } else {
                    btn.removeAttribute('disabled');
                    btn.removeAttribute('aria-disabled');
                    btn.classList.remove('disabled');
                }
            });

            root.dataset.requiredComplete = complete ? 'true' : 'false';
            return complete;
        }

        try { injectSkipButtonsIntoHeaders(); } catch(_) {}
        try { updateAccordionHeaderDisplay(); } catch(_) {}

        document.addEventListener('DOMContentLoaded', () => {
          try {
            root.querySelectorAll('.cvp-qty-input').forEach((inp) => {
              inp.setAttribute('min', '0');
              inp.setAttribute('data-min', '0');
            });
          } catch(_) {}
        });

        function bindFormOnce() {

            const actionableSelector = '.atlas-cvp__step:not([data-step-type="description"]):not([data-step-type="upsell-links"])';
            const hasActionableCvpSteps = !!root.querySelector(actionableSelector);
            if (!hasActionableCvpSteps) {
                log('bindFormOnce(): only non-actionable CVP steps (description/upsell) found — skipping CVP binding.');
                return;
            }
            if (form && form.__cvpBound) return;
            if (!form) {
                form = document.getElementById(formId) || root.closest('form');
                if (!form) { warn('bindFormOnce(): form still not found'); return; }
            }

            form.__cvpBound = true;
            form.setAttribute('data-cvp-bound', 'true');

            syncAtcDisabled();

            // Add-to-cart loading state helper for CVP
            function __cvpSetAtcLoading(isLoading) {
              try {
                const scope = root.closest('[data-section-id]') || document;
                const btns = new Set();

                // Primary ATC buttons in/near the product form
                if (form) {
                  form.querySelectorAll('.product-form__submit, [type="submit"][name="add"], button[name="add"]').forEach(b => btns.add(b));
                }
                scope.querySelectorAll('.product-form__submit').forEach(b => btns.add(b));

                btns.forEach(btn => {
                  const spinner = btn.querySelector('.loading__spinner');
                  if (isLoading) {
                    btn.classList.add('loading');
                      setTimeout(() => {
                          btn.classList.add('disabled');
                          btn.disabled = true;
                          btn.setAttribute('aria-disabled', 'true');
                      },50)

                    if (spinner) spinner.classList.remove('hidden');
                  } else {
                    btn.classList.remove('loading');
                    btn.classList.remove('disabled');
                    btn.disabled = false;
                    btn.setAttribute('aria-disabled', 'false');
                    if (spinner) spinner.classList.add('hidden');
                  }
                });
              } catch(_) {}
            }

            async function handleCVPSubmit(e) {
                log('handleCVPSubmit: start');
                if (!allRequiredCompleted()) {
                    const firstBad = findFirstIncompleteStep();
                    if (firstBad) {
                        firstBad.classList.add('cvp-error');
                        firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        setTimeout(() => firstBad.classList.remove('cvp-error'), 1200);
                    }
                    syncAtcDisabled();
                    _cvpToast('Please complete the required options');
                    form.removeAttribute('data-cvp-submitting');
                    __cvpSetAtcLoading(false);
                    return;
                }
                if (form.getAttribute('data-cvp-submitting') === 'true') { warn('submit blocked: already submitting'); return; }
                form.setAttribute('data-cvp-submitting', 'true');
                if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
                __cvpSetAtcLoading(true);
                let ok = true;

                // Compute per-unit dropdown extras in cents (mirror of recomputeTotal)
                // Skip steps that are handled as fixed add-on products (DROPDOWN_FIXED_ADDONS)
                let dropdownExtrasCents = 0;
                try {
                  root.querySelectorAll('.atlas-cvp__step[data-step-type="dropdown"] select.atlas-cvp__dropdown-select').forEach(sel => {
                    const stepEl = sel.closest('.atlas-cvp__step');
                    const stepName = stepEl && stepEl.getAttribute('data-step-name');
                    // If this dropdown is mapped to a fixed add-on product – skip adding its delta to extras
                    if (stepName && DROPDOWN_FIXED_ADDONS[stepName]) return;

                    const idx = sel.selectedIndex;
                    if (idx < 0) return;
                    const opt = sel.options[idx];
                    if (!opt || !opt.text) return;
                    const text = opt.text.trim();
                    if (!text || /^please\s+choose$/i.test(text)) return;
                    const m = text.match(/\+\s*\$?\s*(\d+(?:[\.,]\d{1,2})?)/);
                    if (!m) return;
                    const cents = Math.round(parseFloat(m[1].replace(',', '.')) * 100);
                    if (isFinite(cents)) dropdownExtrasCents += cents;
                  });
                } catch(_) {}

                // (removed: const items = [];)
                recomputeSelections();

                if (!ok) {
                    _cvpToast('Please complete the required options');
                    return;
                }

                recomputeTotal();
                syncAtcDisabled();

                const neededHandles = [];
                Object.values(state.selections).forEach(sel => {
                  if (sel && sel.handle) neededHandles.push(sel.handle);
                  if (sel && sel.linkedHandle) neededHandles.push(sel.linkedHandle);
                });
                root.querySelectorAll('.atlas-cvp__multiqty .cvp-qty-input').forEach(inp => {
                  const q = Math.max(0, parseInt(inp.value||'0',10));
                  if (q > 0) {
                    const h = inp.getAttribute('data-handle');
                    if (h) neededHandles.push(h);
                  }
                });
                await ensureVariantIds(neededHandles);

                function getParentQty() {
                  let el = form ? form.querySelector('[name="quantity"]') : null;

                  if (!el) {
                    el = document.querySelector(`input[name="quantity"][form="${formId}"]`);
                  }

                  if (!el) {
                    el = document.querySelector('.quantity__input[name="quantity"]');
                  }
                  const val = parseInt(el && el.value ? el.value : '1', 10);
                  return isNaN(val) ? 1 : Math.max(1, val);
                }

                const parentQty = __cvpGetParentQty();
                const parentVid = parseInt(__cvpCfg.parentVariantId || "0", 10) || 0;
                const group = makeGroupKey();
                const productID = makeProductID();

                // Build components payload for Cart Transform Function
                const cvpComponents = [];
                // Singles from state
                Object.entries(state.selections).forEach(([stepName, sel]) => {
                  const h = sel && sel.handle;
                  const label = sel && sel.label;
                  if (!h) return;
                  const vid = handleVariants[h];
                  if (!vid) { warn('No variant id for handle after ensureVariantIds (components)', h, 'step', stepName); return; }
                  const taVal = state.textInputs && state.textInputs[stepName] ? String(state.textInputs[stepName]).trim() : '';
                  cvpComponents.push({ variantId: `gid://shopify/ProductVariant/${vid}`, quantity: parentQty, label: label || '', step: stepName, note: taVal });
                });
                // Multi-qty components
                root.querySelectorAll('.atlas-cvp__multiqty').forEach(wrap => {
                  const stepName = wrap.closest('.atlas-cvp__step')?.dataset.stepName || '';
                  wrap.querySelectorAll('.cvp-qty-input').forEach(inp => {
                    const q = Math.max(0, parseInt(inp.value||'0',10));
                    if (!q) return;
                    const h = inp.getAttribute('data-handle');
                    const vid = (h && handleVariants[h]) ? handleVariants[h] : null;
                    if (!vid) { warn('Multi-qty missing variant id after ensureVariantIds for handle (components)', h); return; }
                    cvpComponents.push({ variantId: `gid://shopify/ProductVariant/${vid}`, quantity: q*parentQty, label: h, step: stepName });
                  });
                });

                const items = [];

                // Fixed add-on child for specific dropdown (e.g., Number of Digits)
                try {
                  const stepName = 'Number of Digits';
                  const selObj = state.selections && state.selections[stepName];
                  const label = selObj && typeof selObj.label === 'string' ? selObj.label.trim() : '';
                  if (label && DROPDOWN_FIXED_ADDONS[stepName]) {
                    let key = null;
                    if (/^1\s*digit\b/i.test(label)) key = '1 digit';
                    else if (/^2\s*digits\b/i.test(label)) key = '2 digits';

                    if (key) {
                      const handle = DROPDOWN_FIXED_ADDONS[stepName][key];
                      if (handle) {
                        const vid = await resolveFirstVariantIdByHandle(handle);
                        if (vid) {
                          const childProps = {
                            _ParentProductID: String(productID),
                            _Child: 'true',
                            _FixedAddon: stepName,
                            _Selected: label
                          };
                          childProps['_group-data'] = `type:child;group:${group}`;
                          // Quantity ties to parent quantity so one add-on per parent unit
                          items.push({ id: vid, quantity: parentQty, properties: childProps });
                        }
                      }
                    }
                  }
                } catch(_) {}

                // If a surcharge variant is configured, convert dropdown extras into child line(s)
                try {
                  const stepCents = parseInt(SURCHARGE_STEP_CENTS || 0, 10) || 0;
                  if (SURCHARGE_VID && stepCents > 0 && dropdownExtrasCents > 0) {
                    const qtyUnits = Math.round(dropdownExtrasCents / stepCents);
                    const qtyTotal = Math.max(0, qtyUnits * parentQty);
                    if (qtyTotal > 0) {
                      const childProps = {
                        _ParentProductID: String(productID),
                        _Child: 'true',
                        _Surcharge: 'dropdown',
                        _SurchargeStepCents: String(stepCents),
                        _SurchargeUnits: String(qtyUnits),
                        _SurchargePerUnitCents: String(dropdownExtrasCents)
                      };
                      childProps['_group-data'] = `type:child;group:${group}`;
                      items.push({ id: SURCHARGE_VID, quantity: qtyTotal, properties: childProps });
                    }
                  }
                } catch(_) {}

                // 1) Child items from single-choice steps
                Object.entries(state.selections).forEach(([stepName, sel]) => {
                  const h = sel && sel.handle;
                  const label = sel && sel.label;

                  if (h) {
                    const vid = handleVariants[h];
                    if (!vid) {
                      warn('No variant id for handle (child single)', h, 'step', stepName);
                    } else {
                      const childProps = {
                        _ParentProductID: String(productID),
                        _Child: 'true'
                      };
                      childProps['_group-data'] = `type:child;group:${group}`;
                      items.push({ id: vid, quantity: parentQty, properties: childProps });
                    }
                  }

                  // Linked add-on product, works even if this selection has no base handle of its own
                  const linkedH = sel && sel.linkedHandle;
                  if (linkedH && (JSON.parse((root.querySelector('script[type="application/json"][data-cvp-prices]')||{}).textContent||root.dataset.prices||'{}'))[linkedH] !== 0) {
                    const linkedVid = handleVariants[linkedH];
                    if (linkedVid) {
                      const linkedProps = {
                        _ParentProductID: String(productID),
                        _Child: 'true'
                      };
                      linkedProps['_group-data'] = `type:child;group:${group}`;
                      const linkedQty = parentQty * (parseInt(sel.linkedQuantity, 10) || 1);
                      items.push({ id: linkedVid, quantity: linkedQty, properties: linkedProps });
                    } else {
                      warn('No variant id for linked handle', linkedH, 'step', stepName);
                    }
                  }
                });

                // 2) Child items from multi-qty steps
                root.querySelectorAll('.atlas-cvp__multiqty').forEach(wrap => {
                  const stepName = wrap.closest('.atlas-cvp__step')?.dataset.stepName || '';
                  wrap.querySelectorAll('.cvp-qty-input').forEach(inp => {
                    const q = Math.max(0, parseInt(inp.value||'0',10));
                    if (!q) return;
                    const h = inp.getAttribute('data-handle');
                    const vid = (h && handleVariants[h]) ? handleVariants[h] : null;
                    if (!vid) { warn('Multi-qty missing variant id for handle (child)', h); return; }
                    const childProps = {
                      _ParentProductID: String(productID),
                      _Child: 'true'
                    };
                    childProps['_group-data'] = `type:child;group:${group}`;
                    items.push({ id: vid, quantity: q * parentQty, properties: childProps });
                  });
                });

                // 3) Parent item (visible) with summary properties
                const parentProps = buildParentProps(group, parentVid, parentQty, productID);
                try {
                  if (dropdownExtrasCents > 0) {
                    parentProps['_DropdownExtrasCents'] = String(dropdownExtrasCents);
                    parentProps['_DropdownExtras'] = (dropdownExtrasCents/100).toFixed(2);
                  }
                } catch(_) {}
                let visiblePropsMap = {};
                try {
                  Object.keys(parentProps).forEach((k) => {
                    if (k && k[0] !== '_') visiblePropsMap[k] = parentProps[k];
                  });

                  if (parentProps && parentProps._Bundles != null && parentProps._Bundles !== '') {
                    visiblePropsMap['Bundles'] = String(parentProps._Bundles);
                  } else {
                    const pq = parseInt(parentQty, 10);
                    if (!Number.isNaN(pq) && pq > 0) {
                      visiblePropsMap['Bundles'] = String(pq);
                    }
                  }
                } catch(_) {}

                // Strip specific visible properties from the parent line item (keep them only inside meta/_group-data)
                try {
                           Object.keys(parentProps).forEach((k) => {
            if (/flavou?r/i.test(k)) {
              delete parentProps[k];
            }
          });
                } catch(_) {}

                // Encode meta into _group-data so the bundling app still carries our selections
                let metaPart = '';
                try {
                  const json = JSON.stringify(Object.assign({}, visiblePropsMap || {}, dropdownExtrasCents > 0 ? { _DropdownExtrasCents: dropdownExtrasCents } : {}));
                  metaPart = ';meta:' + encodeURIComponent(json);
                } catch(_) {}

                parentProps['_group-data'] = `type:parent;group:${group}${metaPart}`;
                items.push({ id: parentVid, quantity: parentQty, properties: parentProps });
                log('Parent properties:', parentProps);

                log('handleCVPSubmit: items →', items);

                // === file-aware add to cart ===
                const children = items.filter(it => {
                    try {
                        const gd = it.properties && String(it.properties['_group-data'] || '');
                        return gd.indexOf('type:child;') === 0;
                    } catch(_) { return false; }
                });
                const parentLine = items.find(it => {
                    try {
                        const gd = it.properties && String(it.properties['_group-data'] || '');
                        return gd.indexOf('type:parent;') === 0;
                    } catch(_) { return false; }
                });

                const fileInputs = Array.from(root.querySelectorAll('.atlas-cvp__step[data-step-type="file"] input[type="file"]'));
                const hasFiles = fileInputs.some(inp => inp.files && inp.files.length > 0);

                try {
                    if (hasFiles && parentLine) {
                        // 1) Add parent with files via multipart
                        const fd = new FormData();
                        fd.append('id', String(parentLine.id || parentVid));
                        fd.append('quantity', String(parentLine.quantity || 1));
                        Object.entries(parentLine.properties || {}).forEach(([k, v]) => {
                            fd.append(`properties[${k}]`, String(v));
                        });
                        fileInputs.forEach(inp => {
                            const stepEl = inp.closest('.atlas-cvp__step');
                            const propName = stepEl?.getAttribute('data-step-name') || 'Uploaded File';
                            if (inp.files && inp.files[0]) {
                                fd.append(`properties[_${propName}]`, inp.files[0]);
                            }
                        });

                        // Guard this call ONLY when a follow-up children-POST is coming
                        // (children.length > 0). The site's shared cart.js wraps window.fetch
                        // and auto-refreshes/opens the cart drawer after EVERY successful
                        // /cart/add.js call. Our file-aware add is really one logical action
                        // split into two HTTP calls (parent, then children) - without this
                        // guard, the site auto-refresh fires after the FIRST call too, showing
                        // an incomplete cart (missing children, wrong price) for a moment
                        // before the second call's auto-refresh corrects it. Guarding the
                        // first call suppresses that premature refresh so the drawer only
                        // updates once, after the real final state is in place. If there are
                        // no children, this is the only add call, so it must stay unguarded.
                        const res1 = await fetch('/cart/add.js', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: children.length ? { 'X-Postmut-Guard': '1' } : undefined,
                            body: fd
                        });
                        if (!res1.ok) {
                            const txt = await res1.text();
                            throw new Error(txt || 'Failed to add parent with file');
                        }

                        // 2) Add child lines (if any)
                        if (children.length) {
                            const res2 = await fetch('/cart/add.js', {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify({ items: children })
                            });
                            if (!res2.ok) {
                                const txt = await res2.text();
                                throw new Error(txt || 'Failed to add child items');
                            }
                        }
                    } else {
                        // No files: regular JSON add
                        const res = await fetch('/cart/add.js', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify({ items })
                        });
                        if (!res.ok) {
                            const txt = await res.text();
                            throw new Error(txt || 'Add to cart failed');
                        }
                    }

                    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(_) {}
                    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(_) {}
                    const tryOpeners = [
                        () => window.theme && window.theme.cart && typeof window.theme.cart.open === 'function' && window.theme.cart.open(),
                        () => window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && document.querySelector('[data-cart-drawer-toggle]')?.click(),
                        () => document.querySelector('.js-cart-drawer-open')?.click(),
                        () => document.querySelector('[data-action="open-drawer"][data-drawer-id*="cart"]')?.click(),
                    ];
                    for (const open of tryOpeners) { try { if (open()) break; } catch(_) {} }
                    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added')); } catch(_) {}
                    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch(_) {}
                } catch(e) {
                    err('CVP add error (file-aware)', e);
                    alert(e?.message || 'Could not add items to cart. Please try again.');
                } finally {
                    form.removeAttribute('data-cvp-submitting');
                    __cvpSetAtcLoading(false);
                }
            }

            form.addEventListener('submit', handleCVPSubmit, { capture: true });

            // Intercept submit buttons early to avoid theme duplicate adds
            const atcBtns = form.querySelectorAll('[type="submit"], button[name="add"], .product-form__submit');
            atcBtns.forEach(btn => {
                btn.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    handleCVPSubmit(ev);
                }, { capture: true });
            });
        }

        root.addEventListener("change", (e) => {
            const t = e.target;
            // Keep conditional totals (parent → child) in sync for Liquid-rendered markup too
            try {
              if (t && t.matches('input[type="radio"]')) {
                __cvpReconcileConditionalTargetsFromSelection();
              }
            } catch (_) {}
            // Toggle textarea enabled state and visibility when selecting swatch-table-text
            if (t.matches(".js-cvp-text-toggle")) {
                const row = t.closest(".atlas-cvp__table-row");
                const taWrap = row?.querySelector(".atlas-cvp__textarea-wrap");
                const ta = taWrap?.querySelector(".atlas-cvp__textarea");
                if (taWrap) taWrap.style.display = "block";
                if (ta) ta.disabled = false;
            }
            if (t.matches(".cvp-qty-input")) {
                updateMultiQtyUI(t.closest(".atlas-cvp__multiqty"));
                syncConditionalTotals();
            }
            if (t.matches('.atlas-cvp__dropdown-select')) {
                updateAccordionHeaderDisplay();
            }
            syncConditionalTotals();
            recomputeSelections();
            recomputeTotal();
            log('UI updated');
            syncAtcDisabled();
            refreshActionStates();
        });

         root.addEventListener('input', (ev) => {
            const ta = ev.target && ev.target.closest ? ev.target.closest('.atlas-cvp__textarea') : null;
            if (!ta) return;

            const row = ta.closest('.atlas-cvp__table-row');
            if (!row) return;

             const freeInp = ev.target && ev.target.closest ? ev.target.closest('.atlas-cvp__text-input') : null;
             if (freeInp) {
                 const words = String(freeInp.value || '').trim().split(/\s+/).filter(Boolean);
                 if (words.length > 4) freeInp.value = words.slice(0, 4).join(' ');
                 try { recomputeSelections(); } catch(_) {}
                 try { recomputeTotal(); } catch(_) {}
                 try { updateAccordionHeaderDisplay(); } catch(_) {}
                 try { updateAccordionHeaderValues && updateAccordionHeaderValues(); } catch(_) {}
                 try { syncAtcDisabled(); } catch(_) {}
                 return;
             }

            const radio = row.querySelector('input[type="radio"].js-cvp-text-toggle');
            const btn = row.querySelector('.cvp-action[data-action="apply"]');

            let changedSomething = false;
            if (btn && btn.classList.contains('selected')) {
                btn.classList.remove('selected');
                btn.textContent = 'Apply';
                changedSomething = true;
            }
            if (radio && radio.checked) {
                radio.checked = false;
                try { radio.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
                changedSomething = true;
            }

            if (changedSomething) {
                try { recomputeSelections(); } catch(_) {}
                try { recomputeTotal(); } catch(_) {}
                try { updateAccordionHeaderDisplay(); } catch(_) {}
                try { syncAtcDisabled(); } catch(_) {}
            }
        }, true);

        // Update action buttons and row selection
        root.addEventListener('click', e => {
            const blockedLabel = e.target.closest('label.atlas-cvp__table-row, label.atlas-cvp__table-main');
            if (blockedLabel && !e.target.closest('.cvp-action')) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            const btn = e.target;
            if (btn.classList.contains('cvp-action')) {
              const row = btn.closest('.atlas-cvp__table-row');
              const radio = row && row.querySelector('input[type="radio"]');
              const step = row && row.closest('.atlas-cvp__step');
              const required = step && step.dataset.required === 'true';
              const isTextRow = !!(row && row.querySelector('input[type="radio"].js-cvp-text-toggle'));

              if (radio) {
                if (radio.checked && !required) {
                  radio.checked = false;
                  if (isTextRow) {
                    const ta = row.querySelector('.atlas-cvp__textarea');
                    if (ta) ta.value = '';
                    btn.textContent = 'Apply';
                  } else {
                    btn.textContent = 'Select';
                  }
                  btn.classList.remove('selected');
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                  try { recomputeSelections(); } catch(_) {}
                  try { recomputeTotal(); } catch(_) {}
                  try { updateAccordionHeaderDisplay(); } catch(_) {}
                  try { syncAtcDisabled(); } catch(_) {}
                  return;
                }

                const name = radio.name;
                const group = root.querySelectorAll(`input[name="${CSS.escape(name)}"]`);
                group.forEach(r => { if (r !== radio) r.checked = false; });
                radio.checked = true;
                btn.classList.add('selected');
                btn.textContent = isTextRow ? 'Applied' : 'Selected';

                if (isTextRow) {
                  const ta = row.querySelector('.atlas-cvp__textarea');
                  const taWrap = row.querySelector('.atlas-cvp__textarea-wrap');
                  if (taWrap && ta) { taWrap.style.display = 'block'; ta.disabled = false; }
                }

                radio.dispatchEvent(new Event('change', { bubbles: true }));
                try { recomputeSelections(); } catch(_) {}
                try { recomputeTotal(); } catch(_) {}
                log('UI updated');
                try { updateAccordionHeaderDisplay(); } catch(_) {}
                try { syncAtcDisabled(); } catch(_) {}
              }
            }
            if (btn.classList.contains('atlas-cvp__skip')) {
                const step = btn.closest('.atlas-cvp__step');
                if (!step) return;
                if (step.dataset.required === 'true') return;
                const isSkipped = step.getAttribute('data-skipped') === 'true';
                setStepSkipped(step, !isSkipped);
                try { recomputeSelections(); } catch(_) {}
                refreshActionStates();
                recomputeTotal();
                log('UI updated (skip toggled)');
                syncAtcDisabled();
            }
        });

        if (!root.__cvpQtyClicksBound) {
            root.__cvpQtyClicksBound = true;

            root.addEventListener("click", (e) => {
                const btn = e.target && e.target.closest && e.target.closest('.js-cvp-inc, .js-cvp-dec');
                if (!btn) return;

                if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();

                const inpId = btn.getAttribute("aria-controls");
                const inp = inpId ? document.getElementById(inpId) : null;
                if (!inp) return;

                const maxWrap = btn.closest(".atlas-cvp__multiqty");
                const max = parseInt(maxWrap?.dataset.total || "0", 10);
                const dir = btn.classList.contains("js-cvp-inc") ? 1 : -1;
                let v = Math.max(0, parseInt(inp.value || "0", 10));

                const increment = parseInt(inp.getAttribute('data-increment') || '1', 10) || 1;

                if (dir > 0 && max > 0) {
                    let currentSum = 0;
                    maxWrap.querySelectorAll(".cvp-qty-input").forEach(i => {
                        currentSum += Math.max(0, parseInt(i.value || "0", 10));
                    });
                    if (currentSum >= max) return;
                }

                v = dir > 0 ? (v + increment) : Math.max(0, v - increment);
                inp.value = String(v);

                try { inp.dispatchEvent(new Event("change", { bubbles: true })); } catch(_) {}
                try { updateMultiQtyUI(maxWrap); } catch(_) {}
                try { syncConditionalTotals(); } catch(_) {}
                try { recomputeTotal(); } catch(_) {}
                try { syncAtcDisabled(); } catch(_) {}
            }, { capture: true });
        }

        root.querySelectorAll(".atlas-cvp__multiqty").forEach(updateMultiQtyUI);

        setTimeout(() => {
          try {
            root.querySelectorAll('.atlas-cvp__multiqty').forEach(updateMultiQtyUI);
            syncConditionalTotals();
          } catch(_) {}
        }, 0);
        syncConditionalTotals();

        if (!root.querySelector('.atlas-cvp__step[data-required="true"] input[type="radio"]:checked')) {
            autoPreselectFirstRequired();
        }
        openFirstAccordionOnce()
        refreshActionStates();
        recomputeSelections();
        recomputeTotal();
        syncAtcDisabled();

        setTimeout(openFirstAccordionOnce, 0);

        (async () => {
          const pendingHandles = Array.from(root.querySelectorAll('[data-price-pending="1"]'))
            .map(el => el.getAttribute('data-handle'))
            .filter(Boolean);
          const uniq = Array.from(new Set(pendingHandles));
          if (uniq.length) {
            await Promise.all(uniq.map(h => resolvePriceCentsViaAjax(h)));
            try { recomputeTotal(); } catch(_){}
          }
        })();

        bindFormOnce();
        setTimeout(bindFormOnce, 0);
        document.addEventListener('DOMContentLoaded', bindFormOnce);

        function bindVariantPriceSync() {
          const scope = root.closest('[data-section-id]') || document;
          const idInputs = scope.querySelectorAll('select[name="id"], input[name="id"], [data-product-select]');
          idInputs.forEach(el => {
            if (el.__cvpPriceSyncBound) return;
            el.__cvpPriceSyncBound = true;
              el.addEventListener('change', () => {
                  try { recomputeTotal(); } catch(_) {}
              }, { capture: true });
          });

          ['variant:change','product:variant-change','theme:variant:change'].forEach(evt => {
              document.addEventListener(evt, () => {
                  try { recomputeTotal(); } catch(_) {}
              });
          });
        }
        bindVariantPriceSync();
        function bindQtySync() {
            try {
                const scope = root.closest('[data-section-id]') || document;
                const inputs = new Set();
                const inside = form ? Array.from(form.querySelectorAll('input[name="quantity"]')) : [];
                inside.forEach(i => inputs.add(i));
                const linked = Array.from(scope.querySelectorAll(`input[name="quantity"][form="${formId}"]`));
                linked.forEach(i => inputs.add(i));
                const generic = scope.querySelector('.quantity__input[name="quantity"]');
                if (generic) inputs.add(generic);
                inputs.forEach(inp => {
                    if (inp.__cvpQtyBound) return;
                    inp.__cvpQtyBound = true;
                    ['input', 'change'].forEach(evt => {
                        inp.addEventListener(evt, () => {
                            try { recomputeTotal(); } catch(_) {}
                        }, { capture: true });
                    });
                });
            } catch(_) {}
        }
        bindQtySync();

        const moQty = new MutationObserver(() => bindQtySync());
        moQty.observe(document.documentElement, { childList: true, subtree: true });
        const moPrice = new MutationObserver(() => bindVariantPriceSync());
        moPrice.observe(document.documentElement, { childList: true, subtree: true });
        const mo = new MutationObserver(bindFormOnce);
        mo.observe(document.documentElement, { childList: true, subtree: true });

        function __cvpGetParentQty() {
            try {
                const formEl = form || document.getElementById(formId);
                let el = formEl ? formEl.querySelector('[name="quantity"]') : null;
                if (!el) el = document.querySelector(`input[name="quantity"][form="${formId}"]`);
                if (!el) el = document.querySelector('.quantity__input[name="quantity"]');
                const val = parseInt(el && el.value ? el.value : '1', 10);
                return (Number.isNaN(val) ? 1 : Math.max(1, val));
            } catch(_) { return 1; }
        }

        function recomputeTotal() {

            let unitTotal = (parseInt(baseCents, 10) || 0);

            root.querySelectorAll('.atlas-cvp__input[type="radio"]:checked').forEach(r => {
                unitTotal += parseInt(r.getAttribute('data-price-cents') || '0', 10) || 0;
            });

            root.querySelectorAll('.cvp-qty-input').forEach(inp => {
                const q = Math.max(0, parseInt(inp.value || '0', 10));
                const pc = parseInt(inp.getAttribute('data-price-cents') || '0', 10) || 0;
                if (q > 0 && pc > 0) unitTotal += q * pc;
            });

            // Dropdown extras from option text like "... +$3.00"
            root.querySelectorAll('.atlas-cvp__step[data-step-type="dropdown"] select.atlas-cvp__dropdown-select').forEach(sel => {
                try {
                    const idx = sel.selectedIndex;
                    if (idx < 0) return;
                    const opt = sel.options[idx];
                    if (!opt || !opt.text) return;
                    const text = opt.text.trim();
                    if (!text || /^please\s+choose$/i.test(text)) return;
                    const m = text.match(/\+\s*\$?\s*(\d+(?:[\.,]\d{1,2})?)/);
                    if (!m) return;
                    const cents = Math.round(parseFloat(m[1].replace(',', '.')) * 100);
                    if (isFinite(cents)) unitTotal += cents;
                } catch(_) {}
            });

            root.querySelectorAll('.atlas-cvp__step[data-step-type="file"] input[type="file"]').forEach(fi => {
                if (fi.files && fi.files.length > 0) {
                    const pc = parseInt(fi.getAttribute('data-price-cents') || '0', 10) || 0;
                    if (pc > 0) unitTotal += pc;
                }
            });

            const qty = __cvpGetParentQty();
            const total = unitTotal * (qty > 0 ? qty : 1);

            const out = root.querySelector('.js-cvp-total-price');
            if (out) out.dataset.cents = String(total);
            if (out) out.textContent = formatMoney(total);
            syncPdpPrice(total);

            return total;
        }
    } // end initAtlasCvp

    // One-time global key/paste guards for CVP qty inputs
    document.addEventListener('keydown', function (e) {
        const inp = e.target.closest && e.target.closest('.cvp-qty-input');
        if (!inp) return;

        const blocked = ['.', ',', 'e', 'E', '-', '+'];
        if (blocked.includes(e.key)) {
            e.preventDefault();
            return;
        }

        // allow digits + control keys only
        const isDigit = e.key >= '0' && e.key <= '9';
        const allowedControl = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
        ];
        if (!isDigit && !allowedControl.includes(e.key)) {
            e.preventDefault();
        }
    }, true);

    // prevent paste of non-numeric
    document.addEventListener('paste', function (e) {
        const inp = e.target.closest && e.target.closest('.cvp-qty-input');
        if (!inp) return;

        const text = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^\d+$/.test(text)) {
            e.preventDefault();
        }
    }, true);


    // Process any already-queued uids
    function processQueue() {
        const queue = window.__atlasCvpQueue;
        if (Array.isArray(queue)) {
            queue.forEach(function (uid) {
                try { initAtlasCvp(uid); } catch (e) { console.error('[CVP] init error for uid', uid, e); }
            });
            window.__atlasCvpQueue = [];
        }
    }

    window.__atlasCvpInit = initAtlasCvp;
    processQueue();
})();